import { createI18n } from "vue-i18n";

const message = {
  /**
   * 增加新的国际化字段时只需要添加到 en，然后通过脚本 npm run i18n 自动翻译其他语言
   */
  en: {
    message: {
      title: "Messages",
      order: "Orders",
      networkError: "Network abnormality",
      orderDesc: "Keep updated on order status.",
      promo: "Promos",
      promoDesc: "{count} codes are available",
      orderTitle: "Order Messages",
      errorTitle: "Internal Server Error",
      errorDesc:
        "The server encountered an internal error or misconfiguration and was unable to complete your request.",
      reload: "Reload",
      noMoreGoods: "No more, click another tab and view more",
      goodsEmptyTitle: "No goods available",
      goodsEmptyDesc: "Click another tab and view more",
      orderEmptyTitle: "It is empty here",
      orderEmptyDesc: "See what else you would like to buy",
      viewMore: "View more",
      latestProgress: "Latest progress",
      reason: "Reason",
      sold: "Sold",
      noMoreInformation: "no more information",
      loadError: "load error, click to retry",
      clearMessageSuccess: "Marked all messages as read successful",
      orderTime: "Order Time",
      orderId: "Order ID",
      send: "Send",
      sentence1:
        "Please log in before chatting with customer service using Zoomies.",
      networkOutage: "The network is down, please exit and re-enter!",
      versionTooLow: "The app version is too low.",
      submit: "Submit",
      inviting: "INVITING",
      unpaid: "UNPAID",
      qualityInspection: "QUALITY INSPECTION",
      qualityInspectionFailed: "QUALITY INSPECTION FAILED",
      preparingForShipment: "PREPARING FOR SHIPMENT",
      approved: "APPROVED",
      closed: "CLOSED",
      shipped: "SHIPPED",
      complete: "COMPLETE",
      returning: "RETURNING",
      processing: "PROCESSING",
      pending: "PENDING",
      refunded: "REFUNDED",
      refundRejected: "REFUND REJECTED",
      waitRefund: "WAIT REFUND",
      cancel: "CANCEL",
      received: "RECEIVED",
      rejected: "REJECTED",
      end: "END",
      refunding: "REFUNDING",
      tobeshipped: "TO BE SHIPPED",
      login: "LOG IN",
      dialogtitle: "Please select what you want to ask",
      noMore: "No more",
      Camera: "Camera",
      Order: "Order",
      viewed: "Viewed",
      favorites: "Favorites",
      cart: "Cart",
      pushNotifications:
        "Turn on notifications for updates on your latest order status.",
      pushNotificationsOpen: "OPEN",
      contactServiceText: "If cannot find order or product, please",
      contactService: "contact us",
      serverDesc: "Voghion Customer Service Agent",
      serverWaitTip: "Support Connecting",
      serverWaitDesc:
        "Dear user, we are matching you with customer service, please wait patiently.",
      warnSpeakTitle: "System Messages",
      warnSpeakP1: "Welcome to Zoomies!",
      warnSpeakP2:
        "Harassment, explicit content, violence, provocative messages, and infringement are strictly prohibited in our chat. Violations will result in immediate mute or other disciplinary actions. Thank you for helping us maintain a positive community!",
      ServiceNotification: "Service Notification",
      VipNotification: "Vip Notification",
      empty: "It is empty here",
      newin: "New in",
      check_the_user_manual: "Check the user manual",
      uploading: "Uploading",
      uploadError: "Upload error",
      loading: "Loading...",
      ai: {
        title: "AskShop",
        subTitle: "Ask Shopping, Shop Smarter.",
        slogan: "AI shopping hub.",
        recordInvisible:
          "Oops! Your voice seems to have gone invisible ~ Please get closer to the microphone and try again! 🎤🤔",
        failedResolveAudio: "Failed to resolve audio",
        serverBusy: "Sorry, the server is busy, please try again later.",
        clearHistory: "Clear all chat history?",
        cancel: "Cancel",
        clear: "Clear",
        newTopic: "New Topic",
        Refresh: "Refresh",
        holdToTalk: "Hold to talk",
        releaseToCancel: "Release to cancel",
        swipeUpToCancel: "Swipe up to cancel",
        askMTQuestion: "Ask MT a question",
        askAnything: "Ask anything…",
        describeYourNeeds: "Describe your needs",
        speakTimeTooShort: "Speak time too short",
        Camera: "Camera",
        Photo: "Photo",
        sold: "sold",
        updateTitle:
          "New version available! Update now for the latest features.",
        confirm: "Confirm",
        thinking: "Thinking.",
        suggestMore: "Suggest More",
        feedbackSubmitted: "Feedback submitted",
        serverError: "Server Error, try again later",
        copied: "Copied",
        mostPopular: "Most Popular",
        TopSales: "Top Sales",
        Price: "Price",
        recommendation: "Recommendation",
      },
      view_more: "view more",
      signIn: {
        main: "Sign in",
        register: "Register",
        email: "Email",
        password: "Password",
        forgotPassword: "Forgot password",
        forgotDesc:
          "Confirm your email address and we will send a password reset link.",
        phoneNumber: "Phone Number",
        emailPlaceholder: "Please input email",
        passwordPlaceholder: "Please input password",
        passwordInvalid: "The password consists of 5-16 digits characters",
        success: "Sign in successful, page will be refreshed",
        resendSuccess: "Resend successful",
        signOut: "Sign out",
        otherWays: "Or continue with other ways",
        termsTips: "I accept to Voghion",
        newsletterTips: "Sign up for Newsletter",
        privacyTips:
          "We use cookies and similar technologies that are essential to provide you our services. For more details, see our",
        terms: "Terms of Use",
        and: "and",
        privacy: "Privacy & cookie policy",
        confirmAcceptPrivacy: "Please confirm privacy for sign in",
        agreeAccpetSms: "You have to agree to receive SMS",
        sendResetEmailSuccess: {
          title: "We sent you an email",
          content: `If you haven't found email, <br>
          • email may be delayed for a few minutes.<br>
          • please check vour spam folder.<br>
          • try to click`,
          resend: "RESEND",
          back: "Back to Sign In",
        },
        registerTitle: "Create your {platform} account",
        registerAutoLoginTitle:
          "Your email is registered with us. Please log in to access the full Zoomies features.",
        submitTips: "Please enter your email and your question",
      },
      common: {
        continue: "Continue",
        submit: "Submit",
        save: "Save",
      },
      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Or",
        login: "log in",
        continue: "to continue",
      },
    },
  },
  da: {
    message: {
      title: "Beskeder",
      order: "Ordre:% s",
      orderDesc: "Hold dig opdateret om ordrestatus.",
      promo: "Kampagner",
      promoDesc: "{count} koder er tilgængelige",
      orderTitle: "Bestil beskeder",
      errorTitle: "Intern serverfejl",

      errorDesc:
        "Serveren stødte på en intern fejl eller fejlkonfiguration og kunne ikke fuldføre din anmodning.",

      reload: "Genindlæs",
      noMoreGoods: "Ikke mere, klik på en anden fane og se mere",
      goodsEmptyTitle: "Ingen varer tilgængelige",
      goodsEmptyDesc: "Klik på en anden fane og se mere",
      orderEmptyTitle: "Her er tomt",
      orderEmptyDesc: "Se hvad du ellers kunne tænke dig at købe",
      viewMore: "Se mere",
      latestProgress: "Seneste fremskridt",
      reason: "Grund",
      sold: "Solgt",
      noMore: "ingen flere oplysninger",
      loadError: "indlæsningsfejl, klik for at prøve igen",
      clearMessageSuccess: "Markerede alle beskeder som læst vellykket",
      orderTime: "Bestillingstid",
      orderId: "Ordre ID",
      send: "Sende",
      networkOutage: "Netværket er nede, forlad venligst og gå ind igen!",
      versionTooLow: "Appversionen er for lav.",
      submit: "Indsend",
      unpaid: "UBETALT",
      closed: "LUKKET",
      shipped: "FORSENDES",
      complete: "KOMPLET",
      returning: "TILBAGEKOMST",
      processing: "FORARBEJDNING",
      pending: "VERSERENDE",
      refunded: "REFUNDERING",
      refunding: "REFUNDERING",
      tobeshipped: "SKAL SENDES",

      sentence1:
        "Log venligst ind, før du chatter med kundeservice ved hjælp af Zoomies.",

      login: "LOG PÅ",
      dialogtitle: "Vælg venligst, hvad du vil spørge om",
      viewed: "har set",
      favorites: "Favoritter",
      cart: "Vogn",
      Order: "Bestille",
      networkError: "Netværksabnormitet",

      pushNotifications:
        "Slå notifikationer til for opdateringer om din seneste ordrestatus.",

      pushNotificationsOpen: "ÅBEN",
      warnSpeakTitle: "Systemmeddelelser",
      warnSpeakP1: "Velkommen til Zoomies!",

      warnSpeakP2:
        "Chikane, eksplicit indhold, vold, provokerende beskeder og krænkelse er strengt forbudt i vores chat. Overtrædelser vil resultere i øjeblikkelige mute eller andre disciplinære handlinger. Tak fordi du hjælper os med at bevare et positivt fællesskab!",

      Camera: "Kamera",
      serverDesc: "Voghion kundeserviceagent",
      serverWaitTip: "Support tilslutning",

      serverWaitDesc:
        "Kære bruger, vi matcher dig med kundeservice, vent venligst tålmodigt.",

      contactServiceText:
        "Hvis du ikke kan finde ordre eller produkt, bedes du venligst",

      contactService: "kontakt os",
      ServiceNotification: "Servicemeddelelse",
      empty: "Her er tomt",
      VipNotification: "VIP-meddelelse",
      refundRejected: "REFUSION AFVISET",
      waitRefund: "VENT TILBAGEBETALING",
      cancel: "AFBESTILLE",
      received: "MODTAGET",
      end: "ENDE",
      inviting: "INVITERER",
      qualityInspection: "KVALITETSINSPEKTION",
      qualityInspectionFailed: "KVALITETSINSPEKTION FEJLLET",
      preparingForShipment: "FORBEREDELSE TIL FORSENDELSE",
      approved: "GODKENDT",
      rejected: "AFVISET",
      check_the_user_manual: "Tjek brugermanualen",
      newin: "Ny i",
      uploading: "Uploader",
      uploadError: "Uploadfejl",

      ai: {
        recordInvisible:
          "Ups! Din stemme virker usynlig ~ Gå venligst tættere på mikrofonen og prøv igen! 🎤🤔",

        failedResolveAudio: "Kunne ikke løse lyden",
        serverBusy: "Beklager, serveren er optaget, prøv venligst igen senere.",
        clearHistory: "Ryd al chathistorik?",
        cancel: "Afbestille",
        clear: "Ryd",
        newTopic: "Nyt emne",
        Refresh: "Opdater",
        holdToTalk: "Hold for at tale",
        releaseToCancel: "Slip for at annullere",
        swipeUpToCancel: "Stryg op for at annullere",
        askMTQuestion: "Stil et spørgsmål til MT",
        describeYourNeeds: "Beskriv dine behov",
        speakTimeTooShort: "Taletiden er for kort",
        Camera: "Kamera",
        Photo: "Foto",
        sold: "solgt",

        updateTitle:
          "Ny version tilgængelig! Opdater nu for at få de nyeste funktioner.",

        confirm: "Bekræfte",
        thinking: "Tænkning.",
        suggestMore: "Foreslå mere",
        feedbackSubmitted: "Feedback indsendt",
        serverError: "Serverfejl, prøv igen senere",
        copied: "Kopieret",
        mostPopular: "Mest populære",
        TopSales: "Topsalg",
        Price: "Pris",
        recommendation: "Henstilling",
        title: "AskShop",
        subTitle: "Spørg Shopping, Shop Smartere.",
        askAnything: "Spørg om hvad som helst…",
        slogan: "AI shopping hub.",
      },

      loading: "Indlæser...",
      view_more: "Se mere",

      signIn: {
        main: "Log ind",
        register: "Tilmeld",
        email: "E-mail",
        password: "Adgangskode",
        forgotPassword: "Glemt kodeord",
        forgotDesc:
          "Bekræft din e-mailadresse, og vi sender et link til nulstilling af adgangskode.",
        phoneNumber: "Telefonnummer",
        emailPlaceholder: "Indtast venligst e-mail",
        passwordPlaceholder: "Indtast venligst adgangskode",
        passwordInvalid: "Adgangskoden består af 5-16 cifre",
        success: "Log ind lykkedes, siden vil blive opdateret",
        resendSuccess: "Gensend vellykket",
        signOut: "Log ud",
        otherWays: "Eller fortsæt med andre måder",
        termsTips: "Jeg accepterer til Voghion",
        newsletterTips: "Tilmeld dig nyhedsbrev",
        privacyTips:
          "Vi bruger cookies og lignende teknologier, der er essentielle for at give dig vores tjenester. For flere detaljer, se vores",
        terms: "Vilkår for brug",
        and: "og",
        privacy: "Privatlivs- og cookiepolitik",
        confirmAcceptPrivacy:
          "Bekræft venligst privatlivets fred for at logge ind",
        agreeAccpetSms: "Du skal acceptere at modtage SMS",

        sendResetEmailSuccess: {
          title: "Vi har sendt dig en e-mail",

          content: `Hvis du ikke har fundet e-mail, <br>
          • e-mail kan blive forsinket i et par minutter.<br>
          • Tjek venligst vores spam-mappe.<br>
          • prøv at klikke`,

          resend: "SEND GEN",
          back: "Tilbage til Log ind",
        },

        registerTitle: "Opret din {platform} konto",
        registerAutoLoginTitle:
          "Din e-mail er allerede registreret hos os. Log venligst ind for at få adgang til alle Zoomies-funktionerne.",
        submitTips: "Indtast venligst din e-mail og dit spørgsmål.",
      },

      common: {
        continue: "Blive ved",
        submit: "Indsend",
        save: "Gemme",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Eller",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "ingen flere oplysninger",
    },
  },
  de: {
    message: {
      title: "Mitteilungen",
      order: "Aufträge",
      orderDesc: "Bleiben Sie über den Bestellstatus auf dem Laufenden.",
      promo: "Promos",
      promoDesc: "{count}-Codes sind verfügbar",
      orderTitle: "Bestellnachrichten",
      errorTitle: "interner Serverfehler",

      errorDesc:
        "Der Server hat einen internen Fehler oder eine Fehlkonfiguration festgestellt und konnte Ihre Anfrage nicht abschließen.",

      reload: "Neu laden",

      noMoreGoods:
        "Nicht mehr, klicken Sie auf eine andere Registerkarte und sehen Sie mehr",

      goodsEmptyTitle: "Keine Ware verfügbar",

      goodsEmptyDesc:
        "Klicken Sie auf eine andere Registerkarte und sehen Sie mehr",

      orderEmptyTitle: "Hier ist es leer",
      orderEmptyDesc: "Sehen Sie, was Sie sonst noch kaufen möchten",
      viewMore: "Mehr sehen",
      latestProgress: "Neuester Fortschritt",
      reason: "Grund",
      sold: "Verkauft",
      noMore: "keine weiteren Informationen",
      loadError: "Ladefehler, klicken Sie, um es erneut zu versuchen",

      clearMessageSuccess:
        "Alle Nachrichten wurden als erfolgreich gelesen markiert",

      orderTime: "Bestellzeitpunkt",
      orderId: "Auftragsnummer",
      send: "Schicken",

      networkOutage:
        "Das Netzwerk ist ausgefallen. Bitte beenden und erneut starten!",

      versionTooLow: "Die App-Version ist zu niedrig.",
      submit: "Einreichen",
      unpaid: "UNBEZAHLT",
      closed: "GESCHLOSSEN",
      shipped: "VERSENDET",
      complete: "VOLLSTÄNDIG",
      returning: "RÜCKKEHR",
      processing: "WIRD BEARBEITET",
      pending: "AUSSTEHEND",
      refunded: "ERSTATTET",
      refunding: "RÜCKERSTATTUNG",
      tobeshipped: "VERSCHIFFT WERDEN",

      sentence1:
        "Bitte melden Sie sich an, bevor Sie über Zoomies mit dem Kundenservice chatten.",

      login: "ANMELDUNG",
      dialogtitle: "Bitte wählen Sie aus, was Sie fragen möchten",
      viewed: "Angesehen",
      favorites: "Favoriten",
      cart: "Wagen",
      Order: "Befehl",
      networkError: "Netzwerkanomalie",

      pushNotifications:
        "Aktivieren Sie Benachrichtigungen für Updates zu Ihrem neuesten Bestellstatus.",

      pushNotificationsOpen: "OFFEN",
      warnSpeakTitle: "Systemmeldungen",
      warnSpeakP1: "Willkommen bei Zoomies!",

      warnSpeakP2:
        "Belästigungen, explizite Inhalte, Gewalt, provokative Nachrichten und Verstöße sind in unserem Chat streng verboten. Verstöße führen zur sofortigen Stummschaltung oder anderen Disziplinarmaßnahmen. Vielen Dank, dass Sie uns helfen, eine positive Community aufrechtzuerhalten!",

      Camera: "Kamera",
      serverDesc: "Voghion Kundenservice-Mitarbeiter",
      serverWaitTip: "Support-Verbindung",

      serverWaitDesc:
        "Sehr geehrter Benutzer, wir verbinden Sie mit dem Kundendienst. Bitte haben Sie Geduld.",

      contactServiceText:
        "Wenn Sie die Bestellung oder das Produkt nicht finden können,",

      contactService: "kontaktiere uns",
      ServiceNotification: "Servicemeldung",
      empty: "Hier ist es leer",
      VipNotification: "VIP-Benachrichtigung",
      refundRejected: "RÜCKERSTATTUNG ABGELEHNT",
      waitRefund: "WARTEN RÜCKERSTATTUNG",
      cancel: "STORNIEREN",
      received: "ERHALTEN",
      end: "ENDE",
      inviting: "EINLADEND",
      qualityInspection: "QUALITÄTSPRÜFUNG",
      qualityInspectionFailed: "QUALITÄTSPRÜFUNG FEHLGESCHLAGEN",
      preparingForShipment: "VERSANDVORBEREITUNG",
      approved: "GENEHMIGT",
      rejected: "ABGELEHNT",
      check_the_user_manual: "Überprüfen Sie das Benutzerhandbuch",
      newin: "Neu in",
      uploading: "Hochladen",
      uploadError: "Upload-Fehler",

      ai: {
        recordInvisible:
          "Ups! Deine Stimme scheint unsichtbar geworden zu sein. ~ Bitte gehe näher ans Mikrofon und versuche es erneut! 🎤🤔",

        failedResolveAudio: "Audio konnte nicht aufgelöst werden",

        serverBusy:
          "Entschuldigung, der Server ist ausgelastet. Bitte versuchen Sie es später erneut.",

        clearHistory: "Gesamten Chatverlauf löschen?",
        cancel: "Absagen",
        clear: "Klar",
        newTopic: "Neues Thema",
        Refresh: "Aktualisierung",
        holdToTalk: "Drücken und Sprechen",
        releaseToCancel: "Zum Abbrechen loslassen",
        swipeUpToCancel: "Zum Abbrechen nach oben wischen",
        askMTQuestion: "Stelle MT eine Frage",
        describeYourNeeds: "Beschreiben Sie Ihre Bedürfnisse",
        speakTimeTooShort: "Redezeit zu kurz",
        Camera: "Kamera",
        Photo: "Foto",
        sold: "verkauft",

        updateTitle:
          "Neue Version verfügbar! Jetzt aktualisieren für die neuesten Funktionen.",

        confirm: "Bestätigen",
        thinking: "Denken.",
        suggestMore: "Mehr vorschlagen",
        feedbackSubmitted: "Feedback gesendet",
        serverError: "Serverfehler. Versuchen Sie es später erneut.",
        copied: "Kopiert",
        mostPopular: "Am beliebtesten",
        TopSales: "Top-Verkäufe",
        Price: "Preis",
        recommendation: "Empfehlung",
        title: "AskShop",
        subTitle: "Fragen Sie Shopping, kaufen Sie intelligenter ein.",
        askAnything: "Stellen Sie Ihre Fragen …",
        slogan: "KI-Einkaufszentrum.",
      },

      loading: "Laden...",
      view_more: "mehr sehen",

      signIn: {
        main: "anmelden",
        register: "Registrieren",
        email: "Email",
        password: "Passwort",
        forgotPassword: "Passwort vergessen",
        forgotDesc:
          "Bestätigen Sie Ihre E-Mail-Adresse und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
        phoneNumber: "Telefonnummer",
        emailPlaceholder: "Bitte geben Sie Ihre E-Mail-Adresse ein",
        passwordPlaceholder: "Bitte Passwort eingeben",
        passwordInvalid: "Das Passwort besteht aus 5-16-stelligen Zeichen",
        success: "Anmeldung erfolgreich, Seite wird aktualisiert",
        resendSuccess: "Erneut senden erfolgreich",
        signOut: "Abmelden",
        otherWays: "Oder fahren Sie mit anderen Wegen fort",
        termsTips: "Ich akzeptiere nach Voghion",
        newsletterTips: "Anmeldung für Newsletter",
        privacyTips:
          "Wir verwenden Cookies und ähnliche Technologien, die für die Bereitstellung unserer Dienste unerlässlich sind. Weitere Einzelheiten finden Sie in unserer",
        terms: "Nutzungsbedingungen",
        and: "Und",
        privacy: "Datenschutz- und Cookie-Richtlinie",
        confirmAcceptPrivacy:
          "Bitte bestätigen Sie den Datenschutz, um sich anzumelden",
        agreeAccpetSms: "Sie müssen dem Empfang von SMS zustimmen",

        sendResetEmailSuccess: {
          title: "Wir haben Ihnen eine E-Mail geschickt",

          content: `Wenn Sie keine E-Mail gefunden haben, <br>
          • E-Mails können sich um einige Minuten verzögern.<br>
          • Bitte überprüfen Sie Ihren Spam-Ordner.<br>
          • Versuchen Sie zu klicken`,

          resend: "ERNEUT SENDEN",
          back: "Zurück zur Anmeldung",
        },

        registerTitle: "Erstellen Sie Ihr {platform}-Konto",
        registerAutoLoginTitle:
          "Ihre E-Mail-Adresse ist bei uns registriert. Bitte melden Sie sich an, um auf alle Zoomies-Funktionen zugreifen zu können.",
        submitTips: "Bitte geben Sie Ihre E-Mail und Ihre Frage ein",
      },

      common: {
        continue: "Weitermachen",
        submit: "Einreichen",
        save: "Speichern",
      },

      notLogin: {
        question: "Hallo, ich habe eine Frage:",
        emailTip: "Diese E-Mail sieht nicht ganz richtig aus",
        pageTip:
          "Bitte stellen Sie Ihre Fragen möglichst detailliert mit Textbeschreibung und Screenshots. Wir helfen Ihnen schnellstmöglich! Wenn Sie uns verlassen, erhalten Sie eine Antwort per E-Mail.",
        or: "Oder",
        login: "einloggen",
        continue: "weitermachen",
      },

      noMoreInformation: "keine weiteren Informationen",
    },
  },
  el: {
    message: {
      title: "Μηνύματα",
      order: "Παραγγελίες",
      orderDesc: "Μείνετε ενημερωμένοι για την κατάσταση της παραγγελίας.",
      promo: "Προσφορές",
      promoDesc: "Οι κωδικοί {count} είναι διαθέσιμοι",
      orderTitle: "Μηνύματα παραγγελίας",
      errorTitle: "Εσωτερικό Σφάλμα Διακομιστή",

      errorDesc:
        "Ο διακομιστής αντιμετώπισε εσωτερικό σφάλμα ή εσφαλμένη διαμόρφωση και δεν μπόρεσε να ολοκληρώσει το αίτημά σας.",

      reload: "Γεμίζω πάλι",
      noMoreGoods: "Όχι άλλο, κάντε κλικ σε άλλη καρτέλα και δείτε περισσότερα",
      goodsEmptyTitle: "Δεν υπάρχουν διαθέσιμα αγαθά",
      goodsEmptyDesc: "Κάντε κλικ σε άλλη καρτέλα και δείτε περισσότερα",
      orderEmptyTitle: "Εδώ είναι άδειο",
      orderEmptyDesc: "Δείτε τι άλλο θα θέλατε να αγοράσετε",
      viewMore: "Δείτε περισσότερα",
      latestProgress: "Τελευταία πρόοδος",
      reason: "Λόγος",
      sold: "Πωληθεί",
      noMore: "όχι περισσότερες πληροφορίες",
      loadError: "σφάλμα φόρτωσης, κάντε κλικ για επανάληψη",

      clearMessageSuccess:
        "Επισημάνθηκαν όλα τα μηνύματα ως αναγνωσμένα επιτυχημένα",

      orderTime: "Ώρα παραγγελίας",
      orderId: "Αριθμός Παραγγελίας",
      send: "Στείλετε",

      networkOutage:
        "Το δίκτυο είναι εκτός λειτουργίας, βγείτε και μπείτε ξανά!",

      versionTooLow: "Η έκδοση της εφαρμογής είναι πολύ χαμηλή.",
      submit: "υποβάλλουν",
      unpaid: "ΑΠΛΗΡΩΤΟΣ",
      closed: "ΚΛΕΙΣΤΟ",
      shipped: "ΑΠΟΣΤΟΛΗ",
      complete: "ΠΛΗΡΗΣ",
      returning: "ΕΠΙΣΤΡΟΦΗ",
      processing: "ΕΠΕΞΕΡΓΑΣΙΑ",
      pending: "ΕΚΚΡΕΜΗΣ",
      refunded: "ΕΠΙΣΤΡΟΦΗ ΧΡΗΜΑΤΩΝ",
      refunding: "ΑΝΑΧΡΗΜΑΤΟΔΟΤΗΣΗ",
      tobeshipped: "ΠΡΟΣ ΑΠΟΣΤΟΛΗ",

      sentence1:
        "Συνδεθείτε πριν συνομιλήσετε με την εξυπηρέτηση πελατών χρησιμοποιώντας το Zoomies.",

      login: "ΣΥΝΔΕΣΗ",
      dialogtitle: "Επιλέξτε αυτό που θέλετε να ρωτήσετε",
      viewed: "Προβλήθηκε",
      favorites: "Αγαπημένα",
      cart: "Καροτσάκι",
      Order: "Σειρά",
      networkError: "Ανωμαλία δικτύου",

      pushNotifications:
        "Ενεργοποιήστε τις ειδοποιήσεις για ενημερώσεις σχετικά με την κατάσταση της τελευταίας παραγγελίας σας.",

      pushNotificationsOpen: "ΑΝΟΙΧΤΟ",
      warnSpeakTitle: "Μηνύματα συστήματος",
      warnSpeakP1: "Καλώς ήρθατε στο Zoomies!",

      warnSpeakP2:
        "Η παρενόχληση, το άσεμνο περιεχόμενο, η βία, τα προκλητικά μηνύματα και η παραβίαση απαγορεύονται αυστηρά στη συνομιλία μας. Οι παραβιάσεις θα οδηγήσουν σε άμεση σίγαση ή άλλες πειθαρχικές ενέργειες. Σας ευχαριστούμε που μας βοηθάτε να διατηρήσουμε μια θετική κοινότητα!",

      Camera: "ΦΩΤΟΓΡΑΦΙΚΗ ΜΗΧΑΝΗ",
      serverDesc: "Πράκτορας εξυπηρέτησης πελατών Voghion",
      serverWaitTip: "Υποστήριξη Σύνδεση",

      serverWaitDesc:
        "Αγαπητέ χρήστη, σας ταιριάζουμε με την εξυπηρέτηση πελατών, περιμένετε υπομονετικά.",

      contactServiceText:
        "Εάν δεν μπορείτε να βρείτε παραγγελία ή προϊόν, παρακαλούμε",

      contactService: "επικοινωνήστε μαζί μας",
      ServiceNotification: "Ειδοποίηση υπηρεσίας",
      empty: "Εδώ είναι άδειο",
      VipNotification: "Ειδοποίηση Vip",
      refundRejected: "Η ΕΠΙΣΤΡΟΦΗ ΧΡΗΜΑΤΩΝ ΑΠΟΡΡΙΦΘΗΚΕ",
      waitRefund: "ΑΝΑΜΟΝΗ ΕΠΙΣΤΡΟΦΗΣ ΧΡΗΜΑΤΩΝ",
      cancel: "ΜΑΤΑΙΩΣΗ",
      received: "ΛΗΨΗ",
      end: "ΤΕΛΟΣ",
      inviting: "ΕΛΚΥΣΤΙΚΟΣ",
      qualityInspection: "ΠΟΙΟΤΙΚΟΣ ΕΠΙΘΕΩΡΗΣΗ",
      qualityInspectionFailed: "Η ΠΟΙΟΤΙΚΗ ΕΠΙΘΕΩΡΗΣΗ ΑΠΟΤΥΧΕ",
      preparingForShipment: "ΠΡΟΕΤΟΙΜΑΣΙΑ ΓΙΑ ΑΠΟΣΤΟΛΗ",
      approved: "ΕΓΚΕΚΡΙΜΕΝΟ",
      rejected: "ΑΠΟΡΡΙΦΘΗΚΕ",
      check_the_user_manual: "Ελέγξτε το εγχειρίδιο χρήσης",
      newin: "Νέο σε",
      uploading: "Μεταφόρτωση",
      uploadError: "Σφάλμα μεταφόρτωσης",

      ai: {
        entrySubTitle:
          "Χρειάζεστε βοήθεια για να αποφασίσετε; Ρωτήστε την MT ...",

        title: "Συνομιλία με Τεχνητή Νοημοσύνη",
        subTitle: "Τεχνητή Νοημοσύνη που ψωνίζει από εσάς.",

        recordInvisible:
          "Ωχ! Η φωνή σου φαίνεται να έχει γίνει αόρατη ~ Παρακαλώ πλησίασε το μικρόφωνο και δοκίμασε ξανά! 🎤🤔",

        failedResolveAudio: "Αποτυχία επίλυσης ήχου",

        serverBusy:
          "Λυπούμαστε, ο διακομιστής είναι απασχολημένος, δοκιμάστε ξανά αργότερα.",

        clearHistory: "Διαγραφή όλου του ιστορικού συνομιλιών;",
        cancel: "Ακύρωση",
        clear: "Σαφή",
        newTopic: "Νέο Θέμα",
        Refresh: "Φρεσκάρω",
        holdToTalk: "Κρατήστε πατημένο για να μιλήσετε",
        releaseToCancel: "Αφήστε το για ακύρωση",
        swipeUpToCancel: "Σύρετε προς τα πάνω για ακύρωση",
        askMTQuestion: "Κάντε μια ερώτηση στον MT στον χρήστη.",
        describeYourNeeds: "Περιγράψτε τις ανάγκες σας",
        speakTimeTooShort: "Ο χρόνος ομιλίας είναι πολύ σύντομος",
        Camera: "ΦΩΤΟΓΡΑΦΙΚΗ ΜΗΧΑΝΗ",
        Photo: "φωτογραφία",
        sold: "πωληθεί",

        updateTitle:
          "Νέα έκδοση διαθέσιμη! Ενημερώστε τώρα για τις πιο πρόσφατες λειτουργίες.",

        confirm: "Επιβεβαιώνω",
        thinking: "Σκέψη.",
        suggestMore: "Προτείνετε περισσότερα",
        feedbackSubmitted: "Υποβλήθηκαν σχόλια",
        serverError: "Σφάλμα διακομιστή, δοκιμάστε ξανά αργότερα",
        copied: "Αντιγράφηκε",
        mostPopular: "Δημοφιλέστερος",
        TopSales: "Κορυφαίες πωλήσεις",
        Price: "Τιμή",
        recommendation: "Σύσταση",
        askAnything: "Ρωτήστε οτιδήποτε…",
        slogan: "AI shopping hub.",
      },

      loading: "Φόρτωση...",
      view_more: "Δείτε περισσότερα",

      signIn: {
        main: "Συνδεθείτε",
        register: "Κανω ΕΓΓΡΑΦΗ",
        email: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
        password: "Κωδικός πρόσβασης",
        forgotPassword: "Ξεχάσατε τον κωδικό",
        forgotDesc:
          "Επιβεβαιώστε τη διεύθυνση email σας και θα σας στείλουμε έναν σύνδεσμο επαναφοράς κωδικού πρόσβασης.",
        phoneNumber: "Τηλεφωνικό νούμερο",
        emailPlaceholder: "Παρακαλώ εισάγετε email",
        passwordPlaceholder: "Εισαγάγετε κωδικό πρόσβασης",
        passwordInvalid:
          "Ο κωδικός πρόσβασης αποτελείται από 5-16 ψηφίους χαρακτήρες",
        success: "Η σύνδεση είναι επιτυχής, η σελίδα θα ανανεωθεί",
        resendSuccess: "Επιτυχής εκ νέου αποστολή",
        signOut: "Αποσύνδεση",
        otherWays: "Ή συνεχίστε με άλλους τρόπους",
        termsTips: "Δέχομαι στο Βόγειον",
        newsletterTips: "Εγγραφείτε στο Newsletter",
        privacyTips:
          "Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες που είναι απαραίτητες για να σας παρέχουμε τις υπηρεσίες μας. Για περισσότερες λεπτομέρειες, δείτε το δικό μας",
        terms: "Οροι χρήσης",
        and: "και",
        privacy: "Πολιτική απορρήτου και cookie",
        confirmAcceptPrivacy: "Επιβεβαιώστε το απόρρητο για να συνδεθείτε",
        agreeAccpetSms: "Πρέπει να συμφωνήσετε για να λάβετε SMS",

        sendResetEmailSuccess: {
          title: "Σας στείλαμε ένα email",

          content: `Εάν δεν έχετε βρει email, <br>
          • Το email ενδέχεται να καθυστερήσει για λίγα λεπτά.<br>
          • ελέγξτε τον φάκελο ανεπιθύμητων μηνυμάτων.<br>
          • προσπαθήστε να κάνετε κλικ`,

          resend: "ΕΠΑΝΑΠΟΣΤΟΛΗ",
          back: "Επιστροφή στη Σύνδεση",
        },

        registerTitle: "Δημιουργήστε τον λογαριασμό σας {platform}",
        registerAutoLoginTitle:
          "Το email σας είναι ήδη εγγεγραμμένο. Συνδεθείτε για να αποκτήσετε πρόσβαση σε όλες τις λειτουργίες του Zoomies.",
        submitTips: "Παρακαλούμε εισαγάγετε το email σας και την ερώτησή σας.",
      },

      common: {
        continue: "Να συνεχίσει",
        submit: "υποβάλλουν",
        save: "Αποθηκεύσετε",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Ή",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "όχι περισσότερες πληροφορίες",
    },
  },
  es: {
    message: {
      title: "Mensajes",
      order: "Pedidos",
      orderDesc: "Manténgase actualizado sobre el estado del pedido.",
      promo: "Promociones",
      promoDesc: "{count} códigos están disponibles",
      orderTitle: "Mensajes de pedido",
      errorTitle: "Error Interno del Servidor",

      errorDesc:
        "El servidor encontró un error interno o una mala configuración y no pudo completar su solicitud.",

      reload: "Recargar",
      noMoreGoods: "No más, haz clic en otra pestaña y ve más",
      goodsEmptyTitle: "No hay productos disponibles",
      goodsEmptyDesc: "Haga clic en otra pestaña y vea más",
      orderEmptyTitle: "esta vacio aqui",
      orderEmptyDesc: "Mira qué más te gustaría comprar",
      viewMore: "Ver más",
      latestProgress: "Último progreso",
      reason: "Razón",
      sold: "Vendido",
      noMore: "no hay más información",
      loadError: "error de carga, haga clic para volver a intentarlo",

      clearMessageSuccess:
        "Marqué todos los mensajes como leídos correctamente.",

      orderTime: "Tiempo de la orden",
      orderId: "Solicitar ID",
      send: "Enviar",
      networkOutage: "La red está caída, ¡salga y vuelva a ingresar!",
      versionTooLow: "La versión de la aplicación es demasiado baja.",
      submit: "Enviar",
      unpaid: "NO PAGADO",
      closed: "CERRADO",
      shipped: "ENVIADO",
      complete: "COMPLETO",
      returning: "REGRESANDO",
      processing: "PROCESANDO",
      pending: "PENDIENTE",
      refunded: "REINTEGRADO",
      refunding: "REEMBOLSO",
      tobeshipped: "PARA SER ENVIADO",

      sentence1:
        "Inicie sesión antes de chatear con el servicio de atención al cliente mediante Zoomies.",

      login: "ACCESO",
      dialogtitle: "Por favor selecciona lo que quieres preguntar",
      viewed: "Visto",
      favorites: "Favoritos",
      cart: "Carro",
      Order: "Ordenar",
      networkError: "Anormalidad de la red",

      pushNotifications:
        "Active las notificaciones para recibir actualizaciones sobre el estado de su último pedido.",

      pushNotificationsOpen: "ABIERTO",
      warnSpeakTitle: "Mensajes del sistema",
      warnSpeakP1: "¡Bienvenido a Zoomies!",

      warnSpeakP2:
        "El acoso, el contenido explícito, la violencia, los mensajes provocativos y las infracciones están estrictamente prohibidos en nuestro chat. Las infracciones darán lugar al silenciamiento inmediato o a otras medidas disciplinarias. ¡Gracias por ayudarnos a mantener una comunidad positiva!",

      Camera: "Cámara",
      serverDesc: "Agente de atención al cliente de Voghion",
      serverWaitTip: "Soporte de conexión",

      serverWaitDesc:
        "Estimado usuario, lo estamos conectando con el servicio de atención al cliente, por favor espere pacientemente.",

      contactServiceText:
        "Si no puede encontrar el pedido o el producto, por favor",

      contactService: "Contáctenos",
      ServiceNotification: "Notificación de servicio",
      empty: "esta vacio aqui",
      VipNotification: "Notificación VIP",
      refundRejected: "REEMBOLSO RECHAZADO",
      waitRefund: "ESPERAR REEMBOLSO",
      cancel: "CANCELAR",
      received: "RECIBIÓ",
      end: "FIN",
      inviting: "ATRACTIVO",
      qualityInspection: "INSPECCIÓN DE CALIDAD",
      qualityInspectionFailed: "FALLÓ LA INSPECCIÓN DE CALIDAD",
      preparingForShipment: "PREPARACIÓN PARA EL ENVÍO",
      approved: "APROBADO",
      rejected: "RECHAZADO",
      check_the_user_manual: "Consulte el manual del usuario",
      newin: "Nuevo en",
      uploading: "Subiendo",
      uploadError: "Error de subida",

      ai: {
        recordInvisible:
          "¡Uy! Parece que tu voz se ha vuelto invisible. Acércate al micrófono y vuelve a intentarlo. 🎤🤔",

        failedResolveAudio: "No se pudo resolver el audio",

        serverBusy:
          "Lo sentimos, el servidor está ocupado, por favor inténtalo de nuevo más tarde.",

        clearHistory: "¿Borrar todo el historial de chat?",
        cancel: "Cancelar",
        clear: "Claro",
        newTopic: "Nuevo tema",
        Refresh: "Actualizar",
        holdToTalk: "Mantenga pulsado para hablar",
        releaseToCancel: "Liberar para cancelar",
        swipeUpToCancel: "Desliza hacia arriba para cancelar",
        askMTQuestion: "Hazle una pregunta a MT",
        describeYourNeeds: "Describe tus necesidades",
        speakTimeTooShort: "El tiempo de conversación es demasiado corto",
        Camera: "Cámara",
        Photo: "Foto",
        sold: "vendido",

        updateTitle:
          "¡Nueva versión disponible! Actualízala ahora para disfrutar de las últimas funciones.",

        confirm: "Confirmar",
        thinking: "Pensamiento.",
        suggestMore: "Sugerir más",
        feedbackSubmitted: "Comentarios enviados",
        serverError: "Error del servidor, inténtelo de nuevo más tarde",
        copied: "Copiado",
        mostPopular: "Más popular",
        TopSales: "Mayores ventas",
        Price: "Precio",
        recommendation: "Recomendación",
        title: "AskShop",
        subTitle: "Pregunte en Shopping, compre de manera más inteligente.",
        askAnything: "Pregunta cualquier cosa…",
        slogan: "Centro de compras con inteligencia artificial.",
      },

      loading: "Cargando...",
      view_more: "ver más",

      signIn: {
        main: "Iniciar sesión",
        register: "Registro",
        email: "Correo electrónico",
        password: "Contraseña",
        forgotPassword: "Has olvidado tu contraseña",
        forgotDesc:
          "Confirme su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
        phoneNumber: "Número de teléfono",
        emailPlaceholder: "Por favor ingrese el correo electrónico",
        passwordPlaceholder: "Por favor ingrese la contraseña",
        passwordInvalid:
          "La contraseña consta de caracteres de 5 a 16 dígitos.",
        success: "Inicio de sesión exitoso, la página se actualizará",
        resendSuccess: "Reenviar exitosamente",
        signOut: "desconectar",
        otherWays: "O continuar con otras formas",
        termsTips: "Acepto Voghion",
        newsletterTips: "Suscríbete al boletín",
        privacyTips:
          "Utilizamos cookies y tecnologías similares que son esenciales para brindarle nuestros servicios. Para más detalles, consulte nuestro",
        terms: "Condiciones de uso",
        and: "y",
        privacy: "Política de privacidad y cookies",
        confirmAcceptPrivacy:
          "Por favor confirme la privacidad para iniciar sesión",
        agreeAccpetSms: "Tienes que aceptar recibir SMS",

        sendResetEmailSuccess: {
          title: "Te enviamos un correo electrónico",

          content: `Si no ha encontrado el correo electrónico, <br>
          • El correo electrónico puede tardar unos minutos.<br>
          • Revise su carpeta de correo no deseado.<br>
          • Intente hacer clic`,

          resend: "REENVIAR",
          back: "Volver a iniciar sesión",
        },

        registerTitle: "Crea tu cuenta {platform}",
        registerAutoLoginTitle:
          "Tu correo electrónico está registrado con nosotros. Inicia sesión para acceder a todas las funciones de Zoomies.",
        submitTips: "Por favor ingrese su correo electrónico y su pregunta",
      },

      common: {
        continue: "Continuar",
        submit: "Entregar",
        save: "Ahorrar",
      },

      notLogin: {
        question: "Hola tengo una pregunta:",
        emailTip: "Ese correo electrónico no parece del todo correcto.",
        pageTip:
          "Por favor, envíe sus preguntas detalladas con una descripción textual y capturas de pantalla, si es posible. ¡Le atenderemos lo antes posible! Si se marcha, le enviaremos una respuesta por correo electrónico.",
        or: "O",
        login: "acceso",
        continue: "Para continuar",
      },

      noMoreInformation: "no hay más información",
    },
  },
  et: {
    message: {
      title: "Sõnumid",
      order: "Tellimused",
      orderDesc: "Hoidke end kursis tellimuse olekuga.",
      promo: "Kampaaniad",
      promoDesc: "{count} koodid on saadaval",
      orderTitle: "Telli Sõnumid",
      errorTitle: "Serveri sisemine viga",

      errorDesc:
        "Serveris ilmnes sisemine viga või vale konfiguratsioon ja teie taotlust ei õnnestunud täita.",

      reload: "Laadi uuesti",
      noMoreGoods: "Pole enam, klõpsake teisel vahekaardil ja vaadake rohkem",
      goodsEmptyTitle: "Kaupa pole saadaval",
      goodsEmptyDesc: "Klõpsake teisel vahekaardil ja vaadake rohkem",
      orderEmptyTitle: "Siin on tühi",
      orderEmptyDesc: "Vaadake, mida soovite veel osta",
      viewMore: "Vaata rohkem",
      latestProgress: "Viimased edusammud",
      reason: "Põhjus",
      sold: "Müüdud",
      noMore: "rohkem infot pole",
      loadError: "laadimisviga, klõpsake uuesti proovimiseks",
      clearMessageSuccess: "Kõik kirjad märgiti loetuks",
      orderTime: "Tellimuse aeg",
      orderId: "Tellimuse ID",
      send: "Saada",
      entence1: "Enne IM-i kasutamist logige sisse",
      networkOutage: "Võrk ei tööta, palun väljuge ja sisenege uuesti!",
      versionTooLow: "Rakenduse versioon on liiga madal.",
      submit: "Esita",
      unpaid: "TASUTA",
      closed: "SULETUD",
      shipped: "SAATUD",
      complete: "TÄIELIK",
      returning: "TAGASTAMINE",
      processing: "TÖÖTLEMINE",
      pending: "OOTEL",
      refunded: "TAASTATUD",
      refunding: "TAGASTAMINE",
      tobeshipped: "SAADA SAADA",

      sentence1:
        "Palun logi sisse enne klienditeenindusega vestlemist, kasutades Zoomiesi.",

      login: "LOGI SISSE",
      dialogtitle: "Palun valige, mida soovite küsida",
      viewed: "Vaadatud",
      favorites: "Lemmikud",
      cart: "Käru",
      Order: "Telli",
      networkError: "Võrgu ebanormaalsus",

      pushNotifications:
        "Lülitage sisse märguanded oma viimase tellimuse oleku värskenduste kohta.",

      pushNotificationsOpen: "AVATUD",
      warnSpeakTitle: "Süsteemi sõnumid",
      warnSpeakP1: "Tere tulemast Zoomiesse!",

      warnSpeakP2:
        "Ahistamine, selgesõnaline sisu, vägivald, provokatiivsed sõnumid ja rikkumine on meie vestluses rangelt keelatud. Rikkumised toovad kaasa kohese vaigistamise või muud distsiplinaarmeetmed. Täname, et aitasite meil säilitada positiivset kogukonda!",

      Camera: "Kaamera",
      serverDesc: "Voghioni klienditeenindusagent",
      serverWaitTip: "Toetage ühendamist",

      serverWaitDesc:
        "Hea kasutaja, me sobitame teid klienditeenindusega, oodake kannatlikult.",

      contactServiceText: "Kui tellimust või toodet ei leia, palun",
      contactService: "võtke meiega ühendust",
      ServiceNotification: "Teenuse teatis",
      empty: "Siin on tühi",
      VipNotification: "Vip-teade",
      refundRejected: "TAGASTUS TAGASI TAGASI",
      waitRefund: "OOTA TAGASTUST",
      cancel: "TÜHISTA",
      received: "SAADUD",
      end: "LÕPP",
      inviting: "KUTSUV",
      qualityInspection: "KVALITEEDI KONTROLL",
      qualityInspectionFailed: "KVALITEEDI KONTROLL ebaõnnestus",
      preparingForShipment: "ETTEVALMISTAMINE SAATMISEKS",
      approved: "KINNITUD",
      rejected: "LÜLITATUD",
      check_the_user_manual: "Kontrollige kasutusjuhendit",
      newin: "Uus sisse",
      uploading: "Üleslaadimine",
      uploadError: "Üleslaadimise viga",

      ai: {
        recordInvisible:
          "Ups! Su hääl tundub olevat nähtamatuks muutunud ~ Palun mine mikrofonile lähemale ja proovi uuesti! 🎤🤔",

        failedResolveAudio: "Heli lahendamine ebaõnnestus",

        serverBusy:
          "Vabandust, server on hõivatud, palun proovige hiljem uuesti.",

        clearHistory: "Kas kustutada kogu vestlusajalugu?",
        cancel: "Tühista",
        clear: "Selge",
        newTopic: "Uus teema",
        Refresh: "Värskenda",
        holdToTalk: "Hoidke rääkimiseks all",
        releaseToCancel: "Tühistamiseks vabastage",
        swipeUpToCancel: "Tühistamiseks libista üles",
        askMTQuestion: "Esita MT-le küsimus",
        describeYourNeeds: "Kirjeldage oma vajadusi",
        speakTimeTooShort: "Liiga lühike kõneaeg",
        Camera: "Kaamera",
        Photo: "Foto",
        sold: "müüdud",

        updateTitle:
          "Uus versioon saadaval! Värskenda kohe uusimate funktsioonide kasutamiseks.",

        confirm: "Kinnitage",
        thinking: "Mõtlemine.",
        suggestMore: "Soovita rohkem",
        feedbackSubmitted: "Tagasiside esitatud",
        serverError: "Serveri viga, proovi hiljem uuesti",
        copied: "Kopeeritud",
        mostPopular: "Populaarseim",
        TopSales: "Parim müük",
        Price: "Hind",
        recommendation: "Soovitus",
        title: "AskShop",
        subTitle: "Küsi ostlemiselt, osta targemini.",
        askAnything: "Küsi ükskõik mida…",
        slogan: "AI shopping hub.",
      },

      loading: "Laadimine...",
      view_more: "vaata rohkem",

      signIn: {
        main: "Logi sisse",
        register: "Registreeri",
        email: "Meil",
        password: "Parool",
        forgotPassword: "Unustasid parooli",
        forgotDesc:
          "Kinnitage oma e-posti aadress ja me saadame parooli lähtestamise lingi.",
        phoneNumber: "Telefoninumber",
        emailPlaceholder: "Palun sisesta email",
        passwordPlaceholder: "Palun sisesta parool",
        passwordInvalid: "Parool koosneb 5-16-kohalisest tähemärgist",
        success: "Sisselogimine õnnestus, lehte värskendatakse",
        resendSuccess: "Uuesti saatmine õnnestus",
        signOut: "Logi välja",
        otherWays: "Või jätkake muudel viisidel",
        termsTips: "Nõustun Voghioniga",
        newsletterTips: "Liituge uudiskirjaga",
        privacyTips:
          "Kasutame küpsiseid ja sarnaseid tehnoloogiaid, mis on teile meie teenuste osutamiseks hädavajalikud. Lisateabe saamiseks vaadake meie",
        terms: "Kasutustingimused",
        and: "ja",
        privacy: "Privaatsuse ja küpsiste poliitika",
        confirmAcceptPrivacy: "Sisselogimiseks kinnitage privaatsus",
        agreeAccpetSms: "Peate nõustuma SMS-i vastuvõtmisega",

        sendResetEmailSuccess: {
          title: "Saatsime teile meili",

          content: `Kui te ei leidnud meili, <br>
          • e-kiri võib mõne minuti viibida.<br>
          • palun kontrollige oma rämpsposti kausta.<br>
          • proovige klõpsata`,

          resend: "SAADA TAAS",
          back: "Tagasi sisselogimise juurde",
        },

        registerTitle: "Looge oma {platform} konto",
        registerAutoLoginTitle:
          "Teie e-posti aadress on meie süsteemis registreeritud. Palun logige sisse, et kasutada kõiki Zoomies funktsioone.",
        submitTips: "Palun sisestage oma e-posti aadress ja küsimus",
      },

      common: {
        continue: "Jätka",
        submit: "Esita",
        save: "Salvesta",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Või",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "rohkem infot pole",

    },
  },
  fi: {
    message: {
      title: "Viestit",
      order: "Tilaukset",
      orderDesc: "Pysy ajan tasalla tilauksen tilasta.",
      promo: "Kampanjat",
      promoDesc: "{count} koodit ovat saatavilla",
      orderTitle: "Tilaa viestejä",
      errorTitle: "Sisäinen palvelinvirhe",

      errorDesc:
        "Palvelimessa tapahtui sisäinen virhe tai määritysvirhe, eikä se voinut suorittaa pyyntöäsi loppuun.",

      reload: "Lataa uudelleen",
      noMoreGoods: "Ei enää, napsauta toista välilehteä ja katso lisää",
      goodsEmptyTitle: "Ei tavaroita saatavilla",
      goodsEmptyDesc: "Napsauta toista välilehteä ja katso lisää",
      orderEmptyTitle: "Täällä on tyhjää",
      orderEmptyDesc: "Katso mitä muuta haluaisit ostaa",
      viewMore: "Katso lisää",
      latestProgress: "Viimeisin edistys",
      reason: "Syy",
      sold: "myyty",
      noMore: "ei enempää tietoa",
      loadError: "latausvirhe, yritä uudelleen napsauttamalla",
      clearMessageSuccess: "Kaikki viestit merkittiin luetuiksi onnistuneiksi",
      orderTime: "Tilausaika",
      orderId: "tilausnumero",
      send: "Lähettää",
      networkOutage: "Verkko on poikki, poistu ja syötä uudelleen!",
      versionTooLow: "Sovelluksen versio on liian alhainen.",
      submit: "Lähetä",
      unpaid: "PALKATON",
      closed: "SULJETTU",
      shipped: "TOIMITETTU",
      complete: "SAATTAA LOPPUUN",
      returning: "PALAUTTAMINEN",
      processing: "KÄSITTELYN",
      pending: "ODOTTAA",
      refunded: "PALAUTETTU",
      refunding: "HYVITYS",
      tobeshipped: "LÄHETETÄÄN",

      sentence1:
        "Kirjaudu sisään ennen kuin chattailet asiakaspalvelun kanssa Zoomien avulla.",

      login: "KIRJAUDU SISÄÄN",
      dialogtitle: "Ole hyvä ja valitse mitä haluat kysyä",
      viewed: "Katsottu",
      favorites: "Suosikit",
      cart: "Kärry",
      Order: "Tilaus",
      networkError: "Verkko epänormaali",

      pushNotifications:
        "Ota käyttöön ilmoitukset viimeisimmän tilauksesi tilan päivityksistä.",

      pushNotificationsOpen: "AVATA",
      warnSpeakTitle: "Järjestelmäviestit",
      warnSpeakP1: "Tervetuloa Zoomiin!",

      warnSpeakP2:
        "Häirintä, selkeä sisältö, väkivalta, provosoivat viestit ja loukkaukset ovat ehdottomasti kiellettyjä chatissamme. Rikkomukset johtavat välittömään mykistykseen tai muihin kurinpidollisiin toimiin. Kiitos, että autat meitä ylläpitämään positiivista yhteisöä!",

      Camera: "Kamera",
      serverDesc: "Voghionin asiakaspalveluagentti",
      serverWaitTip: "Tuki yhteyden muodostamiseen",

      serverWaitDesc:
        "Hyvä käyttäjä, yhdistämme sinut asiakaspalveluun, odota kärsivällisesti.",

      contactServiceText: "Jos tilausta tai tuotetta ei löydy, ole hyvä ja",
      contactService: "ota meihin yhteyttä",
      ServiceNotification: "Palveluilmoitus",
      empty: "Täällä on tyhjää",
      VipNotification: "VIP-ilmoitus",
      refundRejected: "HYVITYS hylätty",
      waitRefund: "ODOTA HYVITYSTÄ",
      cancel: "PERUUTTAA",
      received: "OTETTU VASTAAN",
      end: "LOPPU",
      inviting: "KUTSUVA",
      qualityInspection: "LAATUTARKASTUS",
      qualityInspectionFailed: "LAATUTARKASTUS Epäonnistunut",
      preparingForShipment: "VALMISTELU LÄHETYKSIIN",
      approved: "HYVÄKSYTTY",
      rejected: "hylätty",
      check_the_user_manual: "Tarkista käyttöopas",
      newin: "Uusi",
      uploading: "Lähetetään",
      uploadError: "Latausvirhe",

      ai: {
        recordInvisible:
          "Hups! Äänesi näyttää kadonneen ~ Mene lähemmäs mikrofonia ja yritä uudelleen! 🎤🤔",

        failedResolveAudio: "Äänen ratkaiseminen epäonnistui",
        serverBusy: "Palvelin on varattu, yritä myöhemmin uudelleen.",
        clearHistory: "Tyhjennä kaikki keskusteluhistoria?",
        cancel: "Peruuta",
        clear: "Asia selvä",
        newTopic: "Uusi aihe",
        Refresh: "virkistää",
        holdToTalk: "Pidä painettuna puhuaksesi",
        releaseToCancel: "Vapauta peruuttaaksesi",
        swipeUpToCancel: "Pyyhkäise ylös peruuttaaksesi",
        askMTQuestion: "Kysy MT:ltä kysymys",
        describeYourNeeds: "Kuvaile tarpeitasi",
        speakTimeTooShort: "Puheaika liian lyhyt",
        Camera: "Kamera",
        Photo: "Kuva",
        sold: "myyty",

        updateTitle:
          "Uusi versio saatavilla! Päivitä nyt saadaksesi uusimmat ominaisuudet.",

        confirm: "Vahvista",
        thinking: "Ajattelu.",
        suggestMore: "Ehdota lisää",
        feedbackSubmitted: "Palaute lähetetty",
        serverError: "Palvelinvirhe, yritä myöhemmin uudelleen",
        copied: "Kopioitu",
        mostPopular: "Suosituin",
        TopSales: "Huippumyynti",
        Price: "Hinta",
        recommendation: "Suositus",
        title: "Kysy myymälästä",
        subTitle: "Kysy ostoksilta, osta fiksummin.",
        askAnything: "Kysy mitä tahansa…",
        slogan: "AI shopping hub.",
      },

      loading: "Ladataan...",
      view_more: "Katso lisää",

      signIn: {
        main: "Kirjaudu sisään",
        register: "Rekisteröidy",
        email: "Sähköposti",
        password: "Salasana",
        forgotPassword: "Unohtuiko salasana",
        forgotDesc:
          "Vahvista sähköpostiosoitteesi, niin lähetämme salasanan palautuslinkin.",
        phoneNumber: "Puhelinnumero",
        emailPlaceholder: "Syötä sähköpostiosoite",
        passwordPlaceholder: "Ole hyvä ja syötä salasana",
        passwordInvalid: "Salasana koostuu 5-16 numerosta",
        success: "Kirjautuminen onnistui, sivu päivitetään",
        resendSuccess: "Uudelleenlähetys onnistui",
        signOut: "Kirjaudu ulos",
        otherWays: "Tai jatka muilla tavoilla",
        termsTips: "Hyväksyn Voghionin",
        newsletterTips: "Tilaa uutiskirje",
        privacyTips:
          "Käytämme evästeitä ja vastaavia tekniikoita, jotka ovat välttämättömiä palveluidemme tarjoamiseksi. Katso lisätietoja",
        terms: "Käyttöehdot",
        and: "ja",
        privacy: "Tietosuoja- ja evästekäytäntö",
        confirmAcceptPrivacy: "Vahvista yksityisyys sisäänkirjautumista varten",
        agreeAccpetSms: "Sinun on hyväksyttävä tekstiviestien vastaanottaminen",

        sendResetEmailSuccess: {
          title: "Lähetimme sinulle sähköpostia",

          content: `Jos et löytänyt sähköpostia, <br>
          • sähköposti saattaa viivästyä muutaman minuutin.<br>
          • tarkista roskapostikansiosi.<br>
          • yritä napsauttaa`,

          resend: "UUDELLEEN LÄHETTÄÄ",
          back: "Takaisin kirjautumiseen",
        },

        registerTitle: "Luo {platform}-tilisi",
        registerAutoLoginTitle:
          "Sähköpostiosoitteesi on rekisteröity. Kirjaudu sisään käyttääksesi Zoomiesin kaikkia ominaisuuksia.",
        submitTips: "Anna sähköpostiosoitteesi ja kysymyksesi.",
      },

      common: {
        continue: "Jatkaa",
        submit: "Lähetä",
        save: "Tallentaa",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Tai",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "ei enempää tietoa",
    },
  },
  fr: {
    message: {
      title: "messages",
      order: "Commandes",
      orderDesc: "Restez informé de l'état de la commande.",
      promo: "Promotions",
      promoDesc: "{count} codes promo disponibles",
      orderTitle: "Messages de commande",
      errorTitle: "Erreur interne du serveur",

      errorDesc:
        "Le serveur a rencontré une erreur interne ou une mauvaise configuration et n'a pas pu répondre à votre demande.",

      reload: "Recharger",
      noMoreGoods: "Pas plus, cliquez sur un autre onglet et affichez-en plus",
      goodsEmptyTitle: "Aucun produit disponible",
      goodsEmptyDesc: "Cliquez sur un autre onglet et affichez-en plus",
      orderEmptyTitle: "C'est vide ici",
      orderEmptyDesc: "Voyez ce que vous aimeriez acheter d'autre",
      viewMore: "Voir plus",
      latestProgress: "Derniers progrès",
      reason: "Raison",
      sold: "Vendu",
      noMore: "pas plus d'informations",
      loadError: "erreur de chargement, cliquez pour réessayer",
      clearMessageSuccess: "Marqué tous les messages comme lus avec succès",
      orderTime: "Temps de commande",
      orderId: "numéro de commande",
      send: "Envoyer",
      networkOutage: "Le réseau est en panne, veuillez sortir et rentrer !",
      versionTooLow: "La version de l'application est trop basse.",
      submit: "Soumettre",
      unpaid: "NON PAYÉ",
      closed: "FERMÉ",
      shipped: "EXPÉDIÉ",
      complete: "COMPLET",
      returning: "RETOUR",
      processing: "TRAITEMENT",
      pending: "EN ATTENTE",
      refunded: "REMBOURSÉ",
      refunding: "REMBOURSEMENT",
      tobeshipped: "À ÊTRE EXPÉDIÉ",

      sentence1:
        "Veuillez vous connecter avant de discuter avec le service client en utilisant Zoomies.",

      login: "SE CONNECTER",
      dialogtitle: "Veuillez sélectionner ce que vous souhaitez demander",
      viewed: "Vu",
      favorites: "Favoris",
      cart: "Panier",
      Order: "Commande",
      networkError: "Anomalie du réseau",

      pushNotifications:
        "Activez les notifications pour les mises à jour sur le dernier statut de votre commande.",

      pushNotificationsOpen: "OUVRIR",
      warnSpeakTitle: "Messages système",
      warnSpeakP1: "Bienvenue chez Zoomies !",

      warnSpeakP2:
        "Le harcèlement, le contenu explicite, la violence, les messages provocateurs et les infractions sont strictement interdits dans notre chat. Les infractions entraîneront une mise en sourdine immédiate ou d'autres mesures disciplinaires. Merci de nous aider à maintenir une communauté positive !",

      Camera: "Appareil photo",
      serverDesc: "Agent du service client de Voghion",
      serverWaitTip: "Prise en charge de la connexion",

      serverWaitDesc:
        "Cher utilisateur, nous vous mettons en relation avec le service client, veuillez patienter.",

      contactServiceText:
        "Si vous ne trouvez pas de commande ou de produit, veuillez",

      contactService: "Contactez-nous",
      ServiceNotification: "Notification de service",
      empty: "C'est vide ici",
      VipNotification: "Notification VIP",
      refundRejected: "REMBOURSEMENT REFUSÉ",
      waitRefund: "ATTENDRE REMBOURSEMENT",
      cancel: "ANNULER",
      received: "REÇU",
      end: "FIN",
      inviting: "ATTRAYANT",
      qualityInspection: "CONTRÔLE DE LA QUALITÉ",
      qualityInspectionFailed: "ÉCHEC DU CONTRÔLE QUALITÉ",
      preparingForShipment: "PRÉPARATION DE L'EXPÉDITION",
      approved: "APPROUVÉ",
      rejected: "REJETÉ",
      check_the_user_manual: "Consultez le manuel d'utilisation",
      newin: "Nouvelle dans",
      uploading: "Téléchargement",
      uploadError: "Erreur de téléchargement",

      ai: {
        recordInvisible:
          "Oups ! Votre voix semble être devenue invisible. Veuillez vous rapprocher du microphone et réessayer ! 🎤🤔",

        failedResolveAudio: "Impossible de résoudre le problème audio",

        serverBusy:
          "Désolé, le serveur est occupé, veuillez réessayer plus tard.",

        clearHistory: "Effacer tout l'historique des discussions ?",
        cancel: "Annuler",
        clear: "Dégager",
        newTopic: "Nouveau sujet",
        Refresh: "Rafraîchir",
        holdToTalk: "Maintenir pour parler",
        releaseToCancel: "Libérer pour annuler",
        swipeUpToCancel: "Balayez vers le haut pour annuler",
        askMTQuestion: "Poser une question à MT",
        describeYourNeeds: "Décrivez vos besoins",
        speakTimeTooShort: "Temps de parole trop court",
        Camera: "Appareil photo",
        Photo: "Photo",
        sold: "vendu",

        updateTitle:
          "Nouvelle version disponible ! Mettez à jour dès maintenant pour bénéficier des dernières fonctionnalités.",

        confirm: "Confirmer",
        thinking: "Pensée.",
        suggestMore: "Suggérer plus",
        feedbackSubmitted: "Commentaires soumis",
        serverError: "Erreur du serveur, réessayez plus tard",
        copied: "Copié",
        mostPopular: "Le plus populaire",
        TopSales: "Meilleures ventes",
        Price: "Prix",
        recommendation: "Recommandation",
        title: "AskShop",
        subTitle: "Demandez à faire des achats, achetez plus intelligemment.",
        askAnything: "Demandez n’importe quoi…",
        slogan: "Centre commercial IA.",
      },

      loading: "Chargement...",
      view_more: "Voir plus",

      signIn: {
        main: "S'identifier",
        register: "Enregistrer",
        email: "E-mail",
        password: "Mot de passe",
        forgotPassword: "Mot de passe oublié",
        forgotDesc:
          "Confirmez votre adresse e-mail et nous vous enverrons un lien de réinitialisation du mot de passe.",
        phoneNumber: "Numéro de téléphone",
        emailPlaceholder: "Veuillez saisir l'e-mail",
        passwordPlaceholder: "Veuillez entrer le mot de passe",
        passwordInvalid: "Le mot de passe se compose de 5 à 16 chiffres",
        success: "Connexion réussie, la page sera actualisée",
        resendSuccess: "Renvoi réussi",
        signOut: "se déconnecter",
        otherWays: "Ou continuez avec d'autres moyens",
        termsTips: "J'accepte à Voghion",
        newsletterTips: "S'inscrire aux Newsletters",
        privacyTips:
          "Nous utilisons des cookies et des technologies similaires qui sont essentiels pour vous fournir nos services. Pour plus de détails, consultez notre",
        terms: "Conditions d'utilisation",
        and: "et",
        privacy: "Politique de confidentialité et de cookies",
        confirmAcceptPrivacy:
          "Veuillez confirmer la confidentialité pour vous connecter",
        agreeAccpetSms: "Vous devez accepter de recevoir des SMS",

        sendResetEmailSuccess: {
          title: "Nous vous avons envoyé un e-mail",

          content: `Si vous n'avez pas trouvé d'e-mail, <br>
          • L'envoi de l'e-mail peut être retardé de quelques minutes.<br>
          • Veuillez vérifier votre dossier spam.<br>
          • Essayez de cliquer`,

          resend: "RENVOYER",
          back: "Retour à la connexion",
        },

        registerTitle: "Créez votre compte {platform}",
        registerAutoLoginTitle:
          "Votre adresse e-mail est enregistrée. Veuillez vous connecter pour accéder à toutes les fonctionnalités de Zoomies.",
        submitTips: "Veuillez entrer votre email et votre question",
      },

      common: {
        continue: "Continuer",
        submit: "Soumettre",
        save: "Sauver",
      },

      notLogin: {
        question: "Bonjour, j'ai une question :",
        emailTip: "Cet e-mail ne semble pas tout à fait correct",
        pageTip:
          "Pourriez-vous nous fournir vos questions détaillées, accompagnées d'une description et de captures d'écran si possible ? Nous vous aiderons au plus vite ! Si vous nous quittez, nous vous répondrons par e-mail.",
        or: "Ou",
        login: "se connecter",
        continue: "continuer",
      },

      noMoreInformation: "pas plus d'informations",
    },
  },
  is: {
    message: {
      title: "Skilaboð",
      order: "Pantanir",
      orderDesc: "Haltu áfram að uppfæra um stöðu pöntunar.",
      promo: "Kynningar",
      promoDesc: "{count} kóðar eru tiltækir",
      orderTitle: "Panta skilaboð",
      errorTitle: "Innri netþjónsvilla",

      errorDesc:
        "Þjónninn lenti í innri villu eða rangstillingu og gat ekki klárað beiðni þína.",

      reload: "Endurhlaða",
      noMoreGoods: "Ekki meira, smelltu á annan flipa og skoðaðu meira",
      goodsEmptyTitle: "Engar vörur fáanlegar",
      goodsEmptyDesc: "Smelltu á annan flipa og skoðaðu meira",
      orderEmptyTitle: "Hér er tómt",
      orderEmptyDesc: "Sjáðu hvað annað þú vilt kaupa",
      viewMore: "Sjá meira",
      latestProgress: "Nýjustu framfarir",
      reason: "Ástæða",
      sold: "Seldur",
      noMore: "engar frekari upplýsingar",
      loadError: "hleðsluvilla, smelltu til að reyna aftur",
      clearMessageSuccess: "Merkti öll skilaboð sem lesin",
      orderTime: "Pöntunartími",
      orderId: "Auðkenni pöntunar",
      send: "Senda",

      networkOutage:
        "Netið er niðri, vinsamlegast farðu út og farðu aftur inn!",

      versionTooLow: "App útgáfan er of lág.",
      submit: "Sendu inn",
      unpaid: "ÓGREYNT",
      closed: "LOKAÐ",
      shipped: "SENDUR",
      complete: "LOKIÐ",
      returning: "SENDINGAR",
      processing: "VINNSLA",
      pending: "Í bið",
      refunded: "endurgreitt",
      refunding: "Endurgreiðsla",
      tobeshipped: "Á AÐ SENDA",

      sentence1:
        "Vinsamlegast skráðu þig inn áður en þú spjallar við þjónustuver með Zoomies.",

      login: "SKRÁ INN",
      dialogtitle: "Vinsamlegast veldu það sem þú vilt spyrja um",
      viewed: "Skoðað",
      favorites: "Uppáhalds",
      cart: "Karfa",
      Order: "Panta",
      networkError: "Óeðlilegt netkerfi",

      pushNotifications:
        "Kveiktu á tilkynningum fyrir uppfærslur á nýjustu pöntunarstöðu þinni.",

      pushNotificationsOpen: "OPNA",
      warnSpeakTitle: "Kerfisskilaboð",
      warnSpeakP1: "Velkomin í Zoomies!",

      warnSpeakP2:
        "Áreitni, skýrt efni, ofbeldi, ögrandi skilaboð og brot eru stranglega bönnuð í spjallinu okkar. Brot munu leiða til tafarlausrar þöggunar eða annarra agaaðgerða. Þakka þér fyrir að hjálpa okkur að viðhalda jákvæðu samfélagi!",

      Camera: "Myndavél",
      serverDesc: "Þjónustufulltrúi Voghion",
      serverWaitTip: "Stuðningur við tengingu",

      serverWaitDesc:
        "Kæri notandi, við erum að passa þig við þjónustuver, vinsamlegast bíddu þolinmóður.",

      contactServiceText: "Ef þú finnur ekki pöntun eða vöru, vinsamlegast",
      contactService: "hafðu samband við okkur",
      ServiceNotification: "Þjónustutilkynning",
      empty: "Hér er tómt",
      VipNotification: "Vip tilkynning",
      refundRejected: "ENDURGREININGU HAFNAÐ",
      waitRefund: "BÍÐA endurgreiðslu",
      cancel: "HÆTTA við",
      received: "MOTTEKKT",
      end: "END",
      inviting: "BJÓÐANDI",
      qualityInspection: "GÆÐASKOÐUN",
      qualityInspectionFailed: "GÆÐASKOÐUN MEKST",
      preparingForShipment: "UNDIRBÚNINGUR fyrir sendingu",
      approved: "SAMÞYKKT",
      rejected: "HAFNAÐI",
      check_the_user_manual: "Athugaðu notendahandbókina",
      newin: "Nýtt í",
      uploading: "Hleður upp",
      uploadError: "Upphleðsluvilla",

      ai: {
        recordInvisible:
          "Úbbs! Röddin þín virðist hafa horfið ~ Vinsamlegast farðu nær hljóðnemanum og reyndu aftur! 🎤🤔",

        failedResolveAudio: "Mistókst að leysa hljóð",

        serverBusy:
          "Því miður er netþjónninn upptekinn, vinsamlegast reyndu aftur síðar.",

        clearHistory: "Hreinsa allan spjallferil?",
        cancel: "Hætta við",
        clear: "Hreinsa",
        newTopic: "Nýtt umræðuefni",
        Refresh: "Endurnýja",
        holdToTalk: "Haltu til að tala",
        releaseToCancel: "Sleppa til að hætta við",
        swipeUpToCancel: "Strjúktu upp til að hætta við",
        askMTQuestion: "Spyrðu MT spurningar",
        describeYourNeeds: "Lýstu þörfum þínum",
        speakTimeTooShort: "Ræðutími of stuttur",
        Camera: "Myndavél",
        Photo: "Mynd",
        sold: "seld",

        updateTitle:
          "Ný útgáfa í boði! Uppfærðu núna til að fá nýjustu eiginleikana.",

        confirm: "Staðfesta",
        thinking: "Hugsun.",
        suggestMore: "Leggja til fleiri",
        feedbackSubmitted: "Ábending send inn",
        serverError: "Villa í netþjóni, reyndu aftur síðar",
        copied: "Afritað",
        mostPopular: "Vinsælast",
        TopSales: "Toppsala",
        Price: "Verð",
        recommendation: "Tilmæli",
        title: "SpyrjaShop",
        subTitle: "Spyrjið um verslun, verslið snjallara.",
        askAnything: "Spyrjið hvað sem er…",
        slogan: "AI shopping hub.",
      },

      loading: "Hleður...",
      view_more: "sjá meira",

      signIn: {
        main: "Skráðu þig inn",
        register: "Skráðu þig",
        email: "Tölvupóstur",
        password: "Lykilorð",
        forgotPassword: "Gleymt lykilorð",
        forgotDesc:
          "Staðfestu netfangið þitt og við munum senda hlekk til að endurstilla lykilorð.",
        phoneNumber: "Símanúmer",
        emailPlaceholder: "Vinsamlega sláðu inn tölvupóst",
        passwordPlaceholder: "Vinsamlega sláðu inn lykilorð",
        passwordInvalid: "Lykilorðið samanstendur af 5-16 stafa stöfum",
        success: "Innskráning tókst, síðan verður endurnýjuð",
        resendSuccess: "Endursending tókst",
        signOut: "Útskrá",
        otherWays: "Eða halda áfram með aðrar leiðir",
        termsTips: "Ég samþykki Voghion",
        newsletterTips: "Skráðu þig á fréttabréf",
        privacyTips:
          "Við notum vafrakökur og svipaða tækni sem er nauðsynleg til að veita þér þjónustu okkar. Fyrir frekari upplýsingar, sjá okkar",
        terms: "Notenda Skilmálar",
        and: "og",
        privacy: "Persónuverndar- og fótsporastefna",
        confirmAcceptPrivacy: "Vinsamlegast staðfestu næði til að skrá þig inn",
        agreeAccpetSms: "Þú verður að samþykkja að fá SMS",

        sendResetEmailSuccess: {
          title: "Við sendum þér tölvupóst",

          content: `Ef þú hefur ekki fundið tölvupóst, <br>
          • tölvupóstur gæti seinkað um nokkrar mínútur.<br>
          • vinsamlegast athugaðu ruslpóstmöppuna okkar.<br>
          • reyndu að smella`,

          resend: "ENDURENDUR",
          back: "Til baka í innskráningu",
        },

        registerTitle: "Búðu til {platform} reikninginn þinn",
        registerAutoLoginTitle:
          "Netfangið þitt er þegar skráð hjá okkur. Vinsamlegast skráðu þig inn til að fá aðgang að öllum Zoomies eiginleikum.",
        submitTips:
          "Vinsamlegast sláðu inn netfangið þitt og spurninguna þína.",
      },

      common: {
        continue: "Halda áfram",
        submit: "Sendu inn",
        save: "Vista",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Or",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "engar frekari upplýsingar",
    },
  },
  it: {
    message: {
      title: "Messaggi",
      order: "Ordini",
      orderDesc: "Rimani aggiornato sullo stato dell'ordine.",
      promo: "Promozioni",
      promoDesc: "Sono disponibili {count} codici",
      orderTitle: "Ordina messaggi",
      errorTitle: "Errore interno del server",

      errorDesc:
        "Il server ha riscontrato un errore interno o una configurazione errata e non è stato in grado di completare la richiesta.",

      reload: "Ricaricare",
      noMoreGoods: "Non più, fai clic su un'altra scheda e visualizza altro",
      goodsEmptyTitle: "Nessuna merce disponibile",
      goodsEmptyDesc: "Fai clic su un'altra scheda e visualizza altro",
      orderEmptyTitle: "Qui è vuoto",
      orderEmptyDesc: "Scopri cos'altro vorresti acquistare",
      viewMore: "Visualizza altro",
      latestProgress: "Ultimi progressi",
      reason: "Motivo",
      sold: "Venduto",
      noMore: "nessuna informazione in più",
      loadError: "errore di caricamento, fare clic per riprovare",

      clearMessageSuccess:
        "Contrassegnato tutti i messaggi come letti con successo",

      orderTime: "Orario dell'ordine",
      orderId: "ID ordine",
      send: "Inviare",
      networkOutage: "La rete non funziona, esci e rientra!",
      versionTooLow: "La versione dell'app è troppo bassa.",
      submit: "Invia",
      unpaid: "NON PAGATO",
      closed: "CHIUSO",
      shipped: "SPEDITO",
      complete: "COMPLETARE",
      returning: "RITORNO",
      processing: "IN LAVORAZIONE",
      pending: "IN ATTESA DI",
      refunded: "RIMBORSATO",
      refunding: "RIMBORSO",
      tobeshipped: "ESSERE SPEDITO",

      sentence1:
        "Accedi prima di chattare con il servizio clienti utilizzando Zoomies.",

      login: "LOGIN",
      dialogtitle: "Seleziona cosa vuoi chiedere",
      viewed: "Visualizzato",
      favorites: "Preferiti",
      cart: "Carrello",
      Order: "Ordinazione",
      networkError: "Anomalia di rete",

      pushNotifications:
        "Attiva le notifiche per gli aggiornamenti sullo stato del tuo ultimo ordine.",

      pushNotificationsOpen: "APRIRE",
      warnSpeakTitle: "Messaggi di sistema",
      warnSpeakP1: "Benvenuti a Zoomies!",

      warnSpeakP2:
        "Molestie, contenuti espliciti, violenza, messaggi provocatori e violazioni sono severamente vietati nella nostra chat. Le violazioni comporteranno l'immediata disattivazione del microfono o altre azioni disciplinari. Grazie per averci aiutato a mantenere una community positiva!",

      Camera: "Fotocamera",
      serverDesc: "Agente del servizio clienti Voghion",
      serverWaitTip: "Supporto Connessione",

      serverWaitDesc:
        "Gentile utente, ti metteremo in contatto con il servizio clienti, ti preghiamo di attendere pazientemente.",

      contactServiceText:
        "Se non riesci a trovare l'ordine o il prodotto, per favore",

      contactService: "Contattaci",
      ServiceNotification: "Notifica di servizio",
      empty: "Qui è vuoto",
      VipNotification: "Notifica VIP",
      refundRejected: "RIMBORSO RIFIUTATO",
      waitRefund: "ASPETTA RIMBORSO",
      cancel: "ANNULLA",
      received: "RICEVUTO",
      end: "FINE",
      inviting: "INVITANTE",
      qualityInspection: "CONTROLLO QUALITÀ",
      qualityInspectionFailed: "CONTROLLO QUALITÀ FALLITO",
      preparingForShipment: "PREPARAZIONE PER LA SPEDIZIONE",
      approved: "APPROVATO",
      rejected: "RESPINTO",
      check_the_user_manual: "Controllare il manuale utente",
      newin: "Novità",
      uploading: "Caricamento in corso",
      uploadError: "Errore di caricamento",

      ai: {
        recordInvisible:
          "Oops! La tua voce sembra essere diventata invisibile ~ Avvicinati al microfono e riprova! 🎤🤔",

        failedResolveAudio: "Impossibile risolvere l'audio",
        serverBusy: "Spiacenti, il server è occupato. Riprova più tardi.",
        clearHistory: "Cancellare tutta la cronologia chat?",
        cancel: "Annulla",
        clear: "Trasparente",
        newTopic: "Nuovo argomento",
        Refresh: "Aggiorna",
        holdToTalk: "Tieni premuto per parlare",
        releaseToCancel: "Rilasciare per annullare",
        swipeUpToCancel: "Scorri verso l'alto per annullare",
        askMTQuestion: "Fai una domanda a MT",
        describeYourNeeds: "Descrivi le tue esigenze",
        speakTimeTooShort: "Il tempo di parola è troppo breve",
        Camera: "Fotocamera",
        Photo: "Foto",
        sold: "venduto",

        updateTitle:
          "Nuova versione disponibile! Aggiorna ora per le ultime funzionalità.",

        confirm: "Confermare",
        thinking: "Pensiero.",
        suggestMore: "Suggerisci altro",
        feedbackSubmitted: "Feedback inviato",
        serverError: "Errore del server, riprova più tardi",
        copied: "Copiato",
        mostPopular: "Più popolare",
        TopSales: "Più venduti",
        Price: "Prezzo",
        recommendation: "Raccomandazione",
        title: "Chiedi al negozio",
        subTitle: "Chiedi allo shopping, acquista in modo più intelligente.",
        askAnything: "Chiedi qualsiasi cosa…",
        slogan: "Centro commerciale basato sull'intelligenza artificiale.",
      },

      loading: "Caricamento...",
      view_more: "vedere di più",

      signIn: {
        main: "Registrazione",
        register: "Registrati",
        email: "E-mail",
        password: "Parola d'ordine",
        forgotPassword: "Ha dimenticato la password",
        forgotDesc:
          "Conferma il tuo indirizzo email e ti invieremo un link per reimpostare la password.",
        phoneNumber: "Numero di telefono",
        emailPlaceholder: "Per favore inserisci l'e-mail",
        passwordPlaceholder: "Per favore inserisci la password",
        passwordInvalid: "La password è composta da 5-16 caratteri",
        success: "Accesso riuscito, la pagina verrà aggiornata",
        resendSuccess: "Nuovo invio riuscito",
        signOut: "disconnessione",
        otherWays: "Oppure continua con altre modalità",
        termsTips: "Accetto a Voghion",
        newsletterTips: "Iscriviti alla Newsletter",
        privacyTips:
          "Utilizziamo cookie e tecnologie simili che sono essenziali per fornirti i nostri servizi. Per maggiori dettagli consultare la nostra",
        terms: "Termini di utilizzo",
        and: "E",
        privacy: "Politica sulla privacy e sui cookie",
        confirmAcceptPrivacy: "Conferma la privacy per l'accesso",
        agreeAccpetSms: "Devi accettare di ricevere SMS",

        sendResetEmailSuccess: {
          title: "Ti abbiamo inviato un'e-mail",

          content: `Se non hai trovato l'email, <br>
          • l'email potrebbe essere in ritardo di qualche minuto.<br>
          • controlla la cartella spam.<br>
          • prova a cliccare`,

          resend: "Rinvio",
          back: "Torna a Accedi",
        },

        registerTitle: "Crea il tuo {platform} account",
        registerAutoLoginTitle:
          "Il tuo indirizzo email è registrato. Accedi per accedere a tutte le funzionalità di Zoomies.",
        submitTips: "Inserisci la tua email e la tua domanda",
      },

      common: {
        continue: "Continua",
        submit: "Invia",
        save: "Salva",
      },

      notLogin: {
        question: "Ciao, ho una domanda:",
        emailTip: "Quella e-mail non sembra del tutto corretta",
        pageTip:
          "Vi preghiamo di fornirci le vostre domande dettagliate, con descrizione testuale e screenshot, se possibile. Vi aiuteremo al più presto! Se abbandonate la discussione, riceverete una risposta via email.",
        or: "Oppure",
        login: "login",
        continue: "per continuare",
      },

      noMoreInformation: "nessuna informazione in più",
    },
  },
  lt: {
    message: {
      title: "Žinutės",
      order: "Užsakymai",
      orderDesc: "Sekite naujienas apie užsakymo būseną.",
      promo: "Akcijos",
      promoDesc: "Galimi {count} kodai",
      orderTitle: "Užsakyti žinutes",
      errorTitle: "Vidinė serverio klaida",

      errorDesc:
        "Serveryje įvyko vidinė klaida arba netinkama konfigūracija ir nepavyko įvykdyti jūsų užklausos.",

      reload: "Įkelti iš naujo",

      noMoreGoods:
        "Ne daugiau, spustelėkite kitą skirtuką ir peržiūrėkite daugiau",

      goodsEmptyTitle: "Prekių nėra",
      goodsEmptyDesc: "Spustelėkite kitą skirtuką ir peržiūrėkite daugiau",
      orderEmptyTitle: "Čia tuščia",
      orderEmptyDesc: "Pažiūrėkite, ką dar norėtumėte nusipirkti",
      viewMore: "Peržiūrėti daugiau",
      latestProgress: "Naujausia pažanga",
      reason: "Priežastis",
      sold: "Parduota",
      noMore: "daugiau informacijos nera",
      loadError: "įkėlimo klaida, spustelėkite, kad bandytumėte dar kartą",
      clearMessageSuccess: "Visi pranešimai pažymėti kaip perskaityti",
      orderTime: "Užsakymo laikas",
      orderId: "Užsakymo ID",
      send: "Siųsti",
      networkOutage: "Tinklas neveikia, išeikite ir vėl įeikite!",
      versionTooLow: "Programos versija per žema.",
      submit: "Pateikti",
      unpaid: "NEMOKAMA",
      closed: "UŽDARYTA",
      shipped: "ATSIŲSTAS",
      complete: "BAIGTA",
      returning: "GRĄŽINANTIS",
      processing: "APDOROJIMAS",
      pending: "KOL",
      refunded: "GRĄŽINTA",
      refunding: "GRĄŽINIMAS",
      tobeshipped: "BŪTINA SIUNTI",

      sentence1:
        "Prieš kalbėdami su klientų aptarnavimo tarnyba, prisijunkite naudodami „Zoomies“.",

      login: "PRISIJUNGTI",
      dialogtitle: "Prašome pasirinkti, ko norite paklausti",
      viewed: "Peržiūrėta",
      favorites: "Mėgstamiausi",
      cart: "Krepšelis",
      Order: "Įsakymas",
      networkError: "Tinklo anomalija",

      pushNotifications:
        "Įjunkite pranešimus apie naujausio užsakymo būsenos naujinius.",

      pushNotificationsOpen: "ATIDARYTI",
      warnSpeakTitle: "Sistemos pranešimai",
      warnSpeakP1: "Sveiki atvykę į Zoomies!",

      warnSpeakP2:
        "Priekabiavimas, atviras turinys, smurtas, provokuojančios žinutės ir pažeidimai mūsų pokalbyje yra griežtai draudžiami. Už pažeidimus bus nedelsiant taikomos tylos arba kitos drausminės priemonės. Dėkojame, kad padedate palaikyti pozityvią bendruomenę!",

      Camera: "Fotoaparatas",
      serverDesc: "Voghion klientų aptarnavimo agentas",
      serverWaitTip: "Prisijungimo palaikymas",

      serverWaitDesc:
        "Gerbiamas naudotojau, deriname jus su klientų aptarnavimo tarnyba, kantriai palaukite.",

      contactServiceText: "Jei nerandate užsakymo ar prekės, prašome",
      contactService: "susisiekite su mumis",
      ServiceNotification: "Paslaugos pranešimas",
      empty: "Čia tuščia",
      VipNotification: "Vip pranešimas",
      refundRejected: "GRĄŽINIMAS ATMESTA",
      waitRefund: "PALAUKITE GRĄŽINIMO",
      cancel: "ATŠAUKTI",
      received: "GAUTA",
      end: "PABAIGA",
      inviting: "KVIETIMAS",
      qualityInspection: "KOKYBĖS TIKRINIMAS",
      qualityInspectionFailed: "KOKYBĖS TIKRINIMAS NEPAVEIKO",
      preparingForShipment: "PARUOŠIMAS SIUNTIMUI",
      approved: "PATVIRTINTA",
      rejected: "ATMESTA",
      check_the_user_manual: "Patikrinkite vartotojo vadovą",
      newin: "Naujas",
      uploading: "Įkėlimas",
      uploadError: "Įkėlimo klaida",

      ai: {
        recordInvisible:
          "Oi! Atrodo, kad jūsų balsas tapo nematomas ~ Prašome priartėti prie mikrofono ir bandykite dar kartą! 🎤🤔",

        failedResolveAudio: "Nepavyko išspręsti garso įrašo",

        serverBusy:
          "Atsiprašome, serveris užimtas, bandykite dar kartą vėliau.",

        clearHistory: "Išvalyti visą pokalbių istoriją?",
        cancel: "Atšaukti",
        clear: "Išvalyti",
        newTopic: "Nauja tema",
        Refresh: "Atnaujinti",
        holdToTalk: "Palaikykite, kad galėtumėte kalbėti",
        releaseToCancel: "Atleiskite, kad atšauktumėte",
        swipeUpToCancel: "Braukite aukštyn, kad atšauktumėte",
        askMTQuestion: "Užduokite MT klausimą",
        describeYourNeeds: "Aprašykite savo poreikius",
        speakTimeTooShort: "Kalbėjimo laikas per trumpas",
        Camera: "Fotoaparatas",
        Photo: "Nuotrauka",
        sold: "parduota",

        updateTitle:
          "Nauja versija pasiekiama! Atnaujinkite dabar, kad gautumėte naujausias funkcijas.",

        confirm: "Patvirtinti",
        thinking: "Mąstymas.",
        suggestMore: "Siūlyti daugiau",
        feedbackSubmitted: "Pateiktas atsiliepimas",
        serverError: "Serverio klaida, bandykite dar kartą vėliau",
        copied: "Nukopijuota",
        mostPopular: "Populiariausias",
        TopSales: "Populiariausi pardavimai",
        Price: "Kaina",
        recommendation: "Rekomendacija",
        title: "AskShop",
        subTitle: "Klauskite apsipirkimo, apsipirkite išmaniau.",
        askAnything: "Klauskite bet ko…",
        slogan: "AI shopping hub.",
      },

      loading: "Įkeliama...",
      view_more: "Peržiūrėti daugiau",

      signIn: {
        main: "Prisijungti",
        register: "Registruotis",
        email: "El. paštas",
        password: "Slaptažodis",
        forgotPassword: "Pamiršote slaptažodį",
        forgotDesc:
          "Patvirtinkite savo el. pašto adresą ir atsiųsime slaptažodžio nustatymo iš naujo nuorodą.",
        phoneNumber: "Telefono numeris",
        emailPlaceholder: "Prašome įvesti el",
        passwordPlaceholder: "Įveskite slaptažodį",
        passwordInvalid: "Slaptažodis susideda iš 5-16 skaitmenų simbolių",
        success: "Prisijungimas sėkmingas, puslapis bus atnaujintas",
        resendSuccess: "Sėkmingas pakartotinis siuntimas",
        signOut: "Atsijungti",
        otherWays: "Arba tęskite kitus būdus",
        termsTips: "Priimu į Voghioną",
        newsletterTips: "Užsiregistruokite naujienlaiškiui",
        privacyTips:
          "Mes naudojame slapukus ir panašias technologijas, kurios yra būtinos teikiant jums paslaugas. Daugiau informacijos rasite mūsų",
        terms: "Naudojimo sąlygos",
        and: "ir",
        privacy: "Privatumo ir slapukų politika",
        confirmAcceptPrivacy: "Norėdami prisijungti, patvirtinkite privatumą",
        agreeAccpetSms: "Turite sutikti, kad gautumėte SMS",

        sendResetEmailSuccess: {
          title: "Išsiuntėme jums el. laišką",

          content: `Jei neradote el. pašto, <br>
          • el. laiškas gali būti atidėtas kelioms minutėms.<br>
          • patikrinkite šlamšto aplanką.<br>
          • pabandykite spustelėti`,

          resend: "PERSIŪSTI",
          back: "Atgal į Prisijungti",
        },

        registerTitle: "Sukurkite savo {platform} paskyrą",
        registerAutoLoginTitle:
          "Jūsų el. paštas jau yra užregistruotas. Prisijunkite, kad galėtumėte naudotis visomis Zoomies funkcijomis.",
        submitTips: "Įveskite savo el. paštą ir klausimą.",
      },

      common: {
        continue: "Tęsti",
        submit: "Pateikti",
        save: "Sutaupyti",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Arba",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "daugiau informacijos nera",
    },
  },
  lv: {
    message: {
      title: "Ziņojumi",
      order: "Pasūtījumi",
      orderDesc: "Sekojiet līdzi pasūtījuma statusam.",
      promo: "Akcijas",
      promoDesc: "{count} kodi ir pieejami",
      orderTitle: "Pasūtiet ziņas",
      errorTitle: "Iekšējā servera kļūda",

      errorDesc:
        "Serverī radās iekšēja kļūda vai nepareiza konfigurācija, un tas nevarēja izpildīt jūsu pieprasījumu.",

      reload: "Pārlādēt",
      noMoreGoods: "Ne vairāk, noklikšķiniet uz citas cilnes un skatiet vairāk",
      goodsEmptyTitle: "Nav pieejamas preces",
      goodsEmptyDesc: "Noklikšķiniet uz citas cilnes un skatiet vairāk",
      orderEmptyTitle: "Šeit ir tukšs",
      orderEmptyDesc: "Skatiet, ko vēl vēlaties iegādāties",
      viewMore: "Skatīt vairāk",
      latestProgress: "Jaunākais progress",
      reason: "Iemesls",
      sold: "Pārdots",
      noMore: "vairāk informācijas nav",
      loadError: "ielādes kļūda, noklikšķiniet, lai mēģinātu vēlreiz",
      clearMessageSuccess: "Visi ziņojumi atzīmēti kā veiksmīgi",
      orderTime: "Pasūtījuma laiks",
      orderId: "Pasūtījuma ID",
      send: "Sūtīt",
      networkOutage: "Tīkls nedarbojas, lūdzu, izejiet un ievadiet vēlreiz!",
      versionTooLow: "Lietotnes versija ir pārāk zema.",
      submit: "Iesniegt",
      unpaid: "NEAPMAKSĀTS",
      closed: "SLĒGTS",
      shipped: "NOsūtīts",
      complete: "PILNĪGS",
      returning: "ATGRIEŠANĀS",
      processing: "APSTRĀDE",
      pending: "GAIDA",
      refunded: "ATMAKSĀTA",
      refunding: "ATMAKSĀŠANA",
      tobeshipped: "NOSŪTĪT",

      sentence1:
        "Lūdzu, piesakieties pirms tērzēšanas ar klientu apkalpošanas dienestu, izmantojot Zoomies.",

      login: "PIESLĒGTIES",
      dialogtitle: "Lūdzu, atlasiet, ko vēlaties jautāt",
      viewed: "Skatīts",
      favorites: "Izlase",
      cart: "Rati",
      Order: "Pasūtiet",
      networkError: "Tīkla anomālija",

      pushNotifications:
        "Ieslēdziet paziņojumus par jaunākā pasūtījuma statusa atjauninājumiem.",

      pushNotificationsOpen: "ATVĒRTS",
      warnSpeakTitle: "Sistēmas ziņojumi",
      warnSpeakP1: "Laipni lūdzam vietnē Zoomies!",

      warnSpeakP2:
        "Uzmākšanās, atklāts saturs, vardarbība, provokatīvi ziņojumi un pārkāpumi mūsu tērzēšanā ir stingri aizliegti. Par pārkāpumiem nekavējoties tiks piemērota klusuma vai citas disciplināras darbības. Paldies, ka palīdzat mums uzturēt pozitīvu kopienu!",

      Camera: "Kamera",
      serverDesc: "Voghion klientu apkalpošanas aģents",
      serverWaitTip: "Atbalsts savienojuma izveidei",

      serverWaitDesc:
        "Cienījamais lietotāj, mēs saskaņojam jūs ar klientu apkalpošanas dienestu, lūdzu, uzgaidiet pacietīgi.",

      contactServiceText: "Ja nevarat atrast pasūtījumu vai preci, lūdzu",
      contactService: "sazinieties ar mums",
      ServiceNotification: "Paziņojums par pakalpojumu",
      empty: "Šeit ir tukšs",
      VipNotification: "VIP paziņojums",
      refundRejected: "ATMAKSAS NORAIDĪTA",
      waitRefund: "GAIDIET ATMAKSAS",
      cancel: "ATCELT",
      received: "SAŅEMTS",
      end: "BEIGAS",
      inviting: "AICINĀŠANA",
      qualityInspection: "KVALITĀTES PĀRBAUDE",
      qualityInspectionFailed: "KVALITĀTES PĀRBAUDE NEizdevās",
      preparingForShipment: "SAGATAVOŠANĀS SŪTĪŠANAI",
      approved: "APSTIPRINĀTS",
      rejected: "NORAIDĪTS",
      check_the_user_manual: "Pārbaudiet lietotāja rokasgrāmatu",
      newin: "Jauns iekšā",
      uploading: "Augšupielāde",
      uploadError: "Augšupielādes kļūda",

      ai: {
        entrySubTitle:
          "Vai nepieciešama palīdzība lēmuma pieņemšanā? Jautājiet MT",

        title: "Mākslīgā intelekta tērzēšana",
        subTitle: "Mākslīgais intelekts, kas iepērkas kopā ar jums.",

        recordInvisible:
          "Ups! Šķiet, ka jūsu balss ir kļuvusi neredzama ~ Lūdzu, pieejiet tuvāk mikrofonam un mēģiniet vēlreiz! 🎤🤔",

        failedResolveAudio: "Neizdevās atrisināt audio problēmu",

        serverBusy:
          "Atvainojiet, serveris ir aizņemts, lūdzu, mēģiniet vēlreiz vēlāk.",

        clearHistory: "Vai notīrīt visu tērzēšanas vēsturi?",
        cancel: "Atcelt",
        clear: "Notīrīt",
        newTopic: "Jauna tēma",
        Refresh: "atjaunot",
        holdToTalk: "Turiet, lai runātu",
        releaseToCancel: "Atlaidiet, lai atceltu",
        swipeUpToCancel: "Pavelciet uz augšu, lai atceltu",
        askMTQuestion: "Uzdodiet MT jautājumu",
        describeYourNeeds: "Aprakstiet savas vajadzības",
        speakTimeTooShort: "Runas laiks ir pārāk īss",
        Camera: "Kamera",
        Photo: "Fotoattēls",
        sold: "pārdots",

        updateTitle:
          "Pieejama jauna versija! Atjauniniet tūlīt, lai iegūtu jaunākās funkcijas.",

        confirm: "Apstiprināt",
        thinking: "Domāšana.",
        suggestMore: "Ieteikt vairāk",
        feedbackSubmitted: "Atsauksmes iesniegtas",
        serverError: "Servera kļūda, mēģiniet vēlreiz vēlāk",
        copied: "Nokopēts",
        mostPopular: "Populārākais",
        TopSales: "Labākie pārdošanas apjomi",
        Price: "Cena",
        recommendation: "Ieteikums",
        askAnything: "Jautājiet jebko…",
        slogan: "AI shopping hub.",
      },

      loading: "Notiek ielāde...",
      view_more: "skatīt vairāk",

      signIn: {
        main: "Ielogoties",
        register: "Reģistrēties",
        email: "E-pasts",
        password: "Parole",
        forgotPassword: "Aizmirsi paroli",
        forgotDesc:
          "Apstipriniet savu e-pasta adresi, un mēs nosūtīsim paroles atiestatīšanas saiti.",
        phoneNumber: "Telefona numurs",
        emailPlaceholder: "Lūdzu, ievadiet e-pastu",
        passwordPlaceholder: "Lūdzu, ievadiet paroli",
        passwordInvalid: "Parole sastāv no 5-16 cipariem",
        success: "Pierakstīties veiksmīgi, lapa tiks atsvaidzināta",
        resendSuccess: "Atkārtoti nosūtīta veiksmīgi",
        signOut: "Izrakstīties",
        otherWays: "Vai arī turpiniet ar citiem veidiem",
        termsTips: "Es pieņemu Voghion",
        newsletterTips: "Pierakstieties biļetenam",
        privacyTips:
          "Mēs izmantojam sīkfailus un līdzīgas tehnoloģijas, kas ir būtiskas mūsu pakalpojumu sniegšanai. Lai iegūtu sīkāku informāciju, skatiet mūsu",
        terms: "Lietošanas noteikumi",
        and: "un",
        privacy: "Privātuma un sīkdatņu politika",
        confirmAcceptPrivacy:
          "Lai pierakstītos, lūdzu, apstipriniet konfidencialitāti",
        agreeAccpetSms: "Jums ir jāpiekrīt SMS saņemšanai",

        sendResetEmailSuccess: {
          title: "Mēs nosūtījām jums e-pastu",

          content: `Ja neesat atradis e-pastu, <br>
          • e-pasts var aizkavēties uz dažām minūtēm.<br>
          • lūdzu, pārbaudiet surogātpasta mapi.<br>
          • mēģiniet noklikšķināt`,

          resend: "ATKĀRTOTI",
          back: "Atpakaļ uz pierakstīšanos",
        },

        registerTitle: "Izveidojiet savu {platform} kontu",
        registerAutoLoginTitle:
          "Jūsu e-pasta adrese jau ir reģistrēta. Lūdzu, piesakieties, lai izmantotu visas Zoomies funkcijas.",
        submitTips: "Lūdzu, ievadiet savu e-pasta adresi un savu jautājumu.",
      },

      common: {
        continue: "Turpināt",
        submit: "Iesniegt",
        save: "Saglabāt",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Vai",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "vairāk informācijas nav",
    },
  },
  mt: {
    message: {
      title: "Messaġġi",
      order: "Ordnijiet",
      orderDesc: "Żomm aġġornat dwar l-istatus tal-ordni.",
      promo: "Promos",
      promoDesc: "{count} kodiċijiet huma disponibbli",
      orderTitle: "Ordna Messaġġi",
      errorTitle: "Żball Intern Server",

      errorDesc:
        "Is-server sab żball intern jew konfigurazzjoni ħażina u ma setax ilesti t-talba tiegħek.",

      reload: "Reload",
      noMoreGoods: "Mhux aktar, ikklikkja tab oħra u ara aktar",
      goodsEmptyTitle: "Ebda merkanzija disponibbli",
      goodsEmptyDesc: "Ikklikkja tab oħra u ara aktar",
      orderEmptyTitle: "Huwa vojt hawn",
      orderEmptyDesc: "Ara x'iktar tixtieq tixtri",
      viewMore: "Ara aktar",
      latestProgress: "L-aħħar progress",
      reason: "Raġuni",
      sold: "Mibjugħa",
      noMore: "ebda aktar informazzjoni",
      loadError: "żball tat-tagħbija, ikklikkja biex terġa' tipprova",

      clearMessageSuccess:
        "Il-messaġġi kollha mmarkati bħala moqrija b'suċċess",

      orderTime: "Ħin tal-Ordni",
      orderId: "ID tal-Ordni",
      send: "Ibgħat",

      networkOutage:
        "In-netwerk huwa mwaqqaf, jekk jogħġbok oħroġ u erġa' daħħal!",

      versionTooLow: "Il-verżjoni tal-app hija baxxa wisq.",
      submit: "Issottometti",
      unpaid: "MHUX ĦLAS",
      closed: "MAGĦLUQ",
      shipped: "BIL-BAĦAR",
      complete: "KOMPLIT",
      returning: "RITORN",
      processing: "PROĊESSAR",
      pending: "PENDENTI",
      refunded: "RIFONDUT",
      refunding: "RIMBORŻ",
      tobeshipped: "GĦANDHOM JIĠI BGĦAT",

      sentence1:
        "Jekk jogħġbok idħol qabel ma tiċċettja mas-servizz tal-konsumatur billi tuża Zoomies.",

      login: "IDĦOL",
      dialogtitle: "Jekk jogħġbok agħżel dak li trid tistaqsi",
      viewed: "Ara",
      favorites: "Favoriti",
      cart: "Karrettun",
      Order: "Ordni",
      networkError: "Anormalità tan-netwerk",

      pushNotifications:
        "Ixgħel notifiki għal aġġornamenti dwar l-aħħar status tal-ordni tiegħek.",

      pushNotificationsOpen: "Miftuħa",
      warnSpeakTitle: "Messaġġi tas-Sistema",
      warnSpeakP1: "Merħba għal Zoomies!",

      warnSpeakP2:
        "Il-fastidju, il-kontenut espliċitu, il-vjolenza, il-messaġġi provokattivi, u l-ksur huma strettament ipprojbiti fiċ-chat tagħna. Vjolazzjonijiet se jirriżultaw f'azzjonijiet dixxiplinarji ta' mute immedjat jew oħrajn. Grazzi talli għinna nżommu komunità pożittiva!",

      Camera: "Kamera",
      serverDesc: "Voghion Customer Service Agent",
      serverWaitTip: "Appoġġ Konnessjoni",

      serverWaitDesc:
        "Għażiż utent, qed inqabbluk mas-servizz tal-konsumatur, jekk jogħġbok stenna bil-paċenzja.",

      contactServiceText:
        "Jekk ma tistax issib ordni jew prodott, jekk jogħġbok",

      contactService: "ikkuntattjana",
      ServiceNotification: "Notifika tas-Servizz",
      empty: "Huwa vojt hawn",
      VipNotification: "Notifika Vip",
      refundRejected: "RIFUŻJONI MIĊĦUT",
      waitRefund: "STENNA RIFUŻJONI",
      cancel: "IKANNELLA",
      received: "RIĊEVUTA",
      end: "TMIEM",
      inviting: "JISTIEDEN",
      qualityInspection: "SPEZZJONI TAL-KWALITÀ",
      qualityInspectionFailed: "L-ISPEZZJONI TAL-KWALITÀ FALLA",
      preparingForShipment: "TĦEJJIJA GĦALL-VAR",
      approved: "APPROVAT",
      rejected: "MIĊĦUT",
      check_the_user_manual: "Iċċekkja l-manwal tal-utent",
      newin: "Ġdid fi",
      uploading: "Ittella'",
      uploadError: "Żball fit-tlugħ",

      ai: {
        serverBusy:
          "Skużani, is-server huwa okkupat, jekk jogħġbok erġa' pprova aktar tard.",

        clearHistory: "Tħassar l-istorja kollha taċ-chat?",
        cancel: "Ikkanċella",
        clear: "Ċara",
        newTopic: "Suġġett Ġdid",
        Refresh: "Aġġorna",
        holdToTalk: "Żomm biex titkellem",
        releaseToCancel: "Itlaq biex tikkanċella",
        swipeUpToCancel: "Skrolla 'l fuq biex tikkanċella",
        askMTQuestion: "Staqsi mistoqsija lil MT",
        describeYourNeeds: "Iddeskrivi l-bżonnijiet tiegħek",
        speakTimeTooShort: "Il-ħin għat-taħdit huwa qasir wisq",
        Camera: "Kamera",
        Photo: "Ritratt",
        sold: "mibjugħa",

        updateTitle:
          "Verżjoni ġdida disponibbli! Aġġorna issa għall-aħħar karatteristiċi.",

        confirm: "Ikkonferma",
        thinking: "Ħsieb.",
        suggestMore: "Issuġġerixxi Aktar",
        feedbackSubmitted: "Rispons sottomess",
        serverError: "Żball fis-Server, erġa' pprova aktar tard",
        copied: "Ikkupjat",
        mostPopular: "L-aktar Popolari",
        TopSales: "Top Bejgħ",
        Price: "Prezz",
        recommendation: "Rakkomandazzjoni",
        title: "AskShop",
        subTitle: "Staqsi dwar ix-Xiri, Ixtri b'Mod Aktar Intelliġenti.",

        recordInvisible:
          "Ups! Leħnek jidher li sar inviżibbli ~ Jekk jogħġbok ersaq eqreb lejn il-mikrofonu u erġa' pprova! 🎤🤔",

        failedResolveAudio: "Ma rnexxiex nirrisolvi l-awdjo",
        askAnything: "Staqsi kwalunkwe ħaġa…",
        slogan: "Ċentru tax-xiri bl-AI.",
      },

      loading: "Tagħbija...",
      view_more: "ara aktar",

      signIn: {
        main: "Idħol",
        register: "Irreġistra",
        email: "Email",
        password: "Password",
        forgotPassword: "Insejt il-password",
        forgotDesc:
          "Ikkonferma l-indirizz tal-email tiegħek u aħna nibagħtu link għall-issettjar tal-password.",
        phoneNumber: "Numru tat-telefon",
        emailPlaceholder: "Jekk jogħġbok daħħal email",
        passwordPlaceholder: "Jekk jogħġbok daħħal il-password",
        passwordInvalid: "Il-password tikkonsisti minn 5-16-il ċifra karattri",
        success: "Idħol b'suċċess, il-paġna tiġi aggornata",
        resendSuccess: "Ibgħat mill-ġdid b'suċċess",
        signOut: "Iffirma",
        otherWays: "Jew kompli b'modi oħra",
        termsTips: "Naċċetta lil Voghion",
        newsletterTips: "Irreġistra għan-Newsletter",
        privacyTips:
          "Aħna nużaw cookies u teknoloġiji simili li huma essenzjali biex nipprovdulek is-servizzi tagħna. Għal aktar dettalji, ara tagħna",
        terms: "Termini ta 'Użu",
        and: "u",
        privacy: "Privatezza u politika tal-cookie",
        confirmAcceptPrivacy:
          "Jekk jogħġbok ikkonferma l-privatezza biex tidħol",
        agreeAccpetSms: "Int trid taqbel li tirċievi SMS",

        sendResetEmailSuccess: {
          title: "Bgħattilkom email",

          content: `Jekk ma sibtx l-email, <br>
          • l-email jista' jittardja għal ftit minuti.<br>
          • jekk jogħġbok iċċekkja l-folder tal-ispam tiegħek.<br>
          • ipprova kklikkja`,

          resend: "RESEND",
          back: "Lura għal Sign In",
        },

        registerTitle: "Oħloq il-kont {platform} tiegħek",
        registerAutoLoginTitle:
          "L-email tiegħek hija rreġistrata magħna. Jekk jogħġbok idħol biex taċċessa l-karatteristiċi kollha ta' Zoomies.",
        submitTips:
          "Jekk jogħġbok daħħal l-email tiegħek u l-mistoqsija tiegħek",
      },

      common: {
        continue: "Kompli",
        submit: "Issottometti",
        save: "Ħlief",
      },

      notLogin: {
        question: "Bongu, għandi mistoqsija:",
        emailTip: "Dak l-email ma jidhirx sew.",
        pageTip:
          "Jekk jogħġbok ipprovdi l-mistoqsijiet dettaljati tiegħek b'deskrizzjoni fit-test u screenshots jekk possibbli. Aħna ngħinuk mill-aktar fis possibbli! Jekk titlaq, se tirċievi tweġiba bl-email.",
        or: "Jew",
        login: "idħol",
        continue: "biex tkompli",
      },

      noMoreInformation: "ebda aktar informazzjoni",
    },
  },
  nl: {
    message: {
      title: "Berichten",
      order: "Bestellingen",
      orderDesc: "Blijf op de hoogte van de bestelstatus.",
      promo: "Promo's",
      promoDesc: "Er zijn {count}-codes beschikbaar",
      orderTitle: "Bestel berichten",
      errorTitle: "Interne Server Fout",

      errorDesc:
        "De server heeft een interne fout of verkeerde configuratie aangetroffen en kan uw verzoek niet voltooien.",

      reload: "Herladen",
      noMoreGoods: "Niet meer, klik op een ander tabblad en bekijk meer",
      goodsEmptyTitle: "Geen goederen beschikbaar",
      goodsEmptyDesc: "Klik op een ander tabblad en bekijk meer",
      orderEmptyTitle: "Het is hier leeg",
      orderEmptyDesc: "Kijk wat je nog meer zou willen kopen",
      viewMore: "Bekijk meer",
      latestProgress: "Laatste voortgang",
      reason: "Reden",
      sold: "Verkocht",
      noMore: "geen informatie meer",
      loadError: "laadfout, klik om het opnieuw te proberen",
      clearMessageSuccess: "Alle berichten gemarkeerd als succesvol gelezen",
      orderTime: "Bestellingstijd",
      orderId: "Order ID",
      send: "Versturen",

      networkOutage:
        "Het netwerk is uitgevallen. Sluit af en ga opnieuw naar binnen!",

      versionTooLow: "De app-versie is te laag.",
      submit: "Indienen",
      unpaid: "ONBETAALD",
      closed: "GESLOTEN",
      shipped: "VERZONDEN",
      complete: "COMPLEET",
      returning: "RETOURNEREN",
      processing: "VERWERKEN",
      pending: "IN BEHANDELING",
      refunded: "TERUGBETAALD",
      refunding: "TERUGBETALING",
      tobeshipped: "TE VERZENDEN",

      sentence1:
        "Meld u aan voordat u met de klantenservice kunt chatten via Zoomies.",

      login: "LOG IN",
      dialogtitle: "Selecteer wat u wilt vragen",
      viewed: "Bekeken",
      favorites: "Favorieten",
      cart: "Winkelwagen",
      Order: "Bestellen",
      networkError: "Netwerkafwijking",

      pushNotifications:
        "Schakel meldingen in voor updates over uw laatste bestelstatus.",

      pushNotificationsOpen: "OPEN",
      warnSpeakTitle: "Systeemberichten",
      warnSpeakP1: "Welkom bij Zoomies!",

      warnSpeakP2:
        "Pesterijen, expliciete content, geweld, provocerende berichten en inbreuken zijn strikt verboden in onze chat. Overtredingen zullen resulteren in onmiddellijke mute of andere disciplinaire maatregelen. Bedankt voor uw hulp bij het behouden van een positieve community!",

      Camera: "Camera",
      serverDesc: "Voghion Klantenservicemedewerker",
      serverWaitTip: "Ondersteuning Verbinding maken",

      serverWaitDesc:
        "Beste gebruiker, wij brengen u in contact met de klantenservice. Even geduld a.u.b.",

      contactServiceText:
        "Als u de bestelling of het product niet kunt vinden, neem dan contact met ons op.",

      contactService: "Neem contact met ons op",
      ServiceNotification: "Servicemelding",
      empty: "Het is hier leeg",
      VipNotification: "Vip-melding",
      refundRejected: "TERUGBETALING AFGEWEZEN",
      waitRefund: "WACHT TERUGBETALING",
      cancel: "ANNULEREN",
      received: "ONTVANGEN",
      end: "EINDE",
      inviting: "UITNODIGEND",
      qualityInspection: "KWALITEITSINSPECTIE",
      qualityInspectionFailed: "KWALITEITSINSPECTIE MISLUKT",
      preparingForShipment: "VOORBEREIDING OP VERZENDING",
      approved: "GOEDGEKEURD",
      rejected: "AFGEWEZEN",
      check_the_user_manual: "Controleer de gebruikershandleiding",
      newin: "Nieuw in",
      uploading: "Uploaden",
      uploadError: "Uploadfout",

      ai: {
        recordInvisible:
          "Oeps! Je stem lijkt onzichtbaar te zijn geworden. Ga dichter bij de microfoon staan en probeer het opnieuw! 🎤🤔",

        failedResolveAudio:
          "Het is niet gelukt om het audioprobleem op te lossen",

        serverBusy: "Sorry, de server is bezet. Probeer het later opnieuw.",
        clearHistory: "Alle chatgeschiedenis wissen?",
        cancel: "Annuleren",
        clear: "Duidelijk",
        newTopic: "Nieuw onderwerp",
        Refresh: "Vernieuwen",
        holdToTalk: "Vasthouden om te praten",
        releaseToCancel: "Vrijgeven om te annuleren",
        swipeUpToCancel: "Veeg omhoog om te annuleren",
        askMTQuestion: "Stel MT een vraag",
        describeYourNeeds: "Beschrijf uw behoeften",
        speakTimeTooShort: "Spreektijd te kort",
        Camera: "Camera",
        Photo: "Foto",
        sold: "verkocht",

        updateTitle:
          "Nieuwe versie beschikbaar! Update nu voor de nieuwste functies.",

        confirm: "Bevestigen",
        thinking: "Denken.",
        suggestMore: "Stel meer voor",
        feedbackSubmitted: "Feedback ingediend",
        serverError: "Serverfout, probeer het later opnieuw",
        copied: "Gekopieerd",
        mostPopular: "Meest populair",
        TopSales: "Topverkoop",
        Price: "Prijs",
        recommendation: "Aanbeveling",
        title: "VraagShop",
        subTitle: "Vraag Winkelen, Winkel Slimmer.",
        askAnything: "Vraag gerust…",
        slogan: "AI-winkelcentrum.",
      },

      loading: "Bezig met laden...",
      view_more: "Bekijk meer",

      signIn: {
        main: "Aanmelden",
        register: "Register",
        email: "E-mail",
        password: "Wachtwoord",
        forgotPassword: "Wachtwoord vergeten",
        forgotDesc:
          "Bevestig uw e-mailadres en wij sturen u een link voor het opnieuw instellen van uw wachtwoord.",
        phoneNumber: "Telefoonnummer",
        emailPlaceholder: "Voer uw e-mailadres in",
        passwordPlaceholder: "Voer het wachtwoord in",
        passwordInvalid: "Het wachtwoord bestaat uit 5-16 cijfers",
        success: "Inloggen is gelukt, de pagina wordt vernieuwd",
        resendSuccess: "Opnieuw verzenden gelukt",
        signOut: "Afmelden",
        otherWays: "Of ga verder met andere manieren",
        termsTips: "Ik accepteer Voghion",
        newsletterTips: "Aanmelden voor Nieuwsbrief",
        privacyTips:
          "Wij gebruiken cookies en soortgelijke technologieën die essentieel zijn om u onze diensten te kunnen leveren. Voor meer details, zie onze",
        terms: "Gebruiksvoorwaarden",
        and: "En",
        privacy: "Privacy- en cookiebeleid",
        confirmAcceptPrivacy: "Bevestig de privacy om in te loggen",
        agreeAccpetSms:
          "U moet akkoord gaan met het ontvangen van sms-berichten",

        sendResetEmailSuccess: {
          title: "Wij hebben u een e-mail gestuurd",

          content: `Als u de e-mail niet hebt gevonden, <br>
          • kan de e-mail enkele minuten vertraging oplopen.<br>
          • Controleer uw spamfolder.<br>
          • Probeer te klikken`,

          resend: "OPNIEUW VERSTUREN",
          back: "Terug naar Inloggen",
        },

        registerTitle: "Maak uw {platform}-account aan",
        registerAutoLoginTitle:
          "Je e-mailadres is bij ons geregistreerd. Log in om toegang te krijgen tot alle Zoomies-functies.",
        submitTips: "Vul uw e-mailadres en uw vraag in",
      },

      common: {
        continue: "Doorgaan",
        submit: "Indienen",
        save: "Redden",
      },

      notLogin: {
        question: "Hallo, ik heb een vraag:",
        emailTip: "Die e-mail ziet er niet helemaal goed uit",
        pageTip:
          "Zou u uw gedetailleerde vragen, indien mogelijk met een tekstuele beschrijving en screenshots, willen toesturen? We helpen u zo snel mogelijk! Als u weggaat, ontvangt u een e-mail met een reactie.",
        or: "Of",
        login: "inloggen",
        continue: "doorgaan",
      },

      noMoreInformation: "geen informatie meer",
    },
  },
  no: {
    message: {
      title: "Meldinger",
      order: "Bestillinger",
      orderDesc: "Hold deg oppdatert på ordrestatus.",
      promo: "Kampanjer",
      promoDesc: "{count}-koder er tilgjengelige",
      orderTitle: "Bestill meldinger",
      errorTitle: "intern server feil",

      errorDesc:
        "Serveren oppdaget en intern feil eller feilkonfigurasjon og kunne ikke fullføre forespørselen din.",

      reload: "Last inn på nytt",
      noMoreGoods: "Ikke mer, klikk på en annen fane og se mer",
      goodsEmptyTitle: "Ingen varer tilgjengelig",
      goodsEmptyDesc: "Klikk på en annen fane og se mer",
      orderEmptyTitle: "Det er tomt her",
      orderEmptyDesc: "Se hva annet du ønsker å kjøpe",
      viewMore: "Se mer",
      latestProgress: "Siste fremgang",
      reason: "Grunnen til",
      sold: "Solgt",
      noMore: "ingen mer informasjon",
      loadError: "lastfeil, klikk for å prøve på nytt",
      clearMessageSuccess: "Merket alle meldinger som lest vellykket",
      orderTime: "Bestillingstid",
      orderId: "Bestillings ID",
      send: "Sende",
      networkOutage: "Nettverket er nede, vennligst gå ut og gå inn på nytt!",
      versionTooLow: "Appversjonen er for lav.",
      submit: "Innsending",
      unpaid: "UBETALT",
      closed: "LUKKET",
      shipped: "SENDES",
      complete: "FULLSTENDIG",
      returning: "RETURNERER",
      processing: "BEHANDLING",
      pending: "AVVENTER",
      refunded: "REFUNDERT",
      refunding: "REFUSJON",
      tobeshipped: "SKAL FRAKTES",

      sentence1:
        "Vennligst logg inn før du chatter med kundeservice ved å bruke Zoomies.",

      login: "LOGG INN",
      dialogtitle: "Velg hva du vil spørre om",
      viewed: "Vist",
      favorites: "Favoritter",
      cart: "Handlevogn",
      Order: "Ordre",
      networkError: "Nettverksavvik",

      pushNotifications:
        "Slå på varsler for oppdateringer om den siste ordrestatusen din.",

      pushNotificationsOpen: "ÅPNE",
      warnSpeakTitle: "Systemmeldinger",
      warnSpeakP1: "Velkommen til Zoomies!",

      warnSpeakP2:
        "Trakassering, eksplisitt innhold, vold, provoserende meldinger og krenkelser er strengt forbudt i chatten vår. Brudd vil resultere i umiddelbare mute eller andre disiplinære handlinger. Takk for at du hjelper oss å opprettholde et positivt fellesskap!",

      Camera: "Kamera",
      serverDesc: "Voghion kundeservicemedarbeider",
      serverWaitTip: "Støtte tilkobling",

      serverWaitDesc:
        "Kjære bruker, vi matcher deg med kundeservice, vennligst vent tålmodig.",

      contactServiceText:
        "Hvis du ikke finner bestilling eller produkt, vennligst",

      contactService: "kontakt oss",
      ServiceNotification: "Tjenestevarsling",
      empty: "Det er tomt her",
      VipNotification: "VIP-varsling",
      refundRejected: "REFUSJON AVSATT",
      waitRefund: "VENT REFUSJON",
      cancel: "AVBRYT",
      received: "MOTTATT",
      end: "SLUTT",
      inviting: "INVITERER",
      qualityInspection: "KVALITETSINSPEKSJON",
      qualityInspectionFailed: "KVALITETSINSPEKSJON MISLYKKES",
      preparingForShipment: "FORBEREDELSER FOR FORSENDELSE",
      approved: "GODKJENT",
      rejected: "AVVISET",
      check_the_user_manual: "Sjekk bruksanvisningen",
      newin: "Ny i",
      uploading: "Opplasting",
      uploadError: "Opplastingsfeil",

      ai: {
        recordInvisible:
          "Ups! Stemmen din ser ut til å ha blitt usynlig ~ Gå nærmere mikrofonen og prøv igjen! 🎤🤔",

        failedResolveAudio: "Kunne ikke løse lyden",
        serverBusy: "Beklager, serveren er opptatt. Prøv igjen senere.",
        clearHistory: "Slette all chatlogg?",
        cancel: "Avbryt",
        clear: "Klar",
        newTopic: "Nytt emne",
        Refresh: "Forfriske",
        holdToTalk: "Hold for å snakke",
        releaseToCancel: "Slipp for å avbryte",
        swipeUpToCancel: "Sveip opp for å avbryte",
        askMTQuestion: "Still et spørsmål til MT",
        describeYourNeeds: "Beskriv dine behov",
        speakTimeTooShort: "For kort taletid",
        Camera: "Kamera",
        Photo: "Foto",
        sold: "solgt",

        updateTitle:
          "Ny versjon tilgjengelig! Oppdater nå for de nyeste funksjonene.",

        confirm: "Bekrefte",
        thinking: "Tenkning.",
        suggestMore: "Foreslå mer",
        feedbackSubmitted: "Tilbakemelding sendt inn",
        serverError: "Serverfeil, prøv igjen senere",
        copied: "Kopiert",
        mostPopular: "Mest populær",
        TopSales: "Toppsalg",
        Price: "Pris",
        recommendation: "Anbefaling",
        title: "AskShop",
        subTitle: "Spør Shopping, handle smartere.",
        askAnything: "Spør om hva som helst…",
        slogan: "AI shopping hub.",
      },

      loading: "Laster inn...",
      view_more: "se mer",

      signIn: {
        main: "Logg inn",
        register: "Registrere",
        email: "E-post",
        password: "Passord",
        forgotPassword: "Glemt passord",
        forgotDesc:
          "Bekreft e-postadressen din, så sender vi en lenke for tilbakestilling av passord.",
        phoneNumber: "Telefonnummer",
        emailPlaceholder: "Vennligst skriv inn e-post",
        passwordPlaceholder: "Vennligst skriv inn passord",
        passwordInvalid: "Passordet består av 5-16 sifre tegn",
        success: "Logg på vellykket, siden vil bli oppdatert",
        resendSuccess: "Sendingen var vellykket",
        signOut: "Logg ut",
        otherWays: "Eller fortsett med andre måter",
        termsTips: "Jeg aksepterer til Voghion",
        newsletterTips: "Registrer deg for å få nyhetsbrev",
        privacyTips:
          "Vi bruker informasjonskapsler og lignende teknologier som er avgjørende for å kunne tilby deg våre tjenester. For mer informasjon, se vår",
        terms: "Vilkår for bruk",
        and: "og",
        privacy: "Retningslinjer for personvern og informasjonskapsler",
        confirmAcceptPrivacy: "Bekreft personvern for pålogging",
        agreeAccpetSms: "Du må godta å motta SMS",

        sendResetEmailSuccess: {
          title: "Vi har sendt deg en e-post",

          content: `Hvis du ikke har funnet e-post, <br>
          • e-post kan bli forsinket i noen minutter.<br>
          • Vennligst sjekk søppelpostmappen.<br>
          • prøv å klikke`,

          resend: "SEND PÅ NYTT",
          back: "Tilbake til Logg på",
        },

        registerTitle: "Opprett din {platform}-konto",
        registerAutoLoginTitle:
          "E-posten din er allerede registrert hos oss. Logg inn for å få tilgang til alle Zoomies-funksjonene.",
        submitTips:
          "Vennligst skriv inn e-postadressen din og spørsmålet ditt.",
      },

      common: {
        continue: "Fortsette",
        submit: "Sende inn",
        save: "Lagre",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Eller",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "ingen mer informasjon",
    },
  },
  pl: {
    message: {
      title: "Wiadomości",
      order: "Zamówienia",
      orderDesc: "Bądź na bieżąco ze statusem zamówienia.",
      promo: "Promocje",
      promoDesc: "Dostępne są kody {count}",
      orderTitle: "Zamów Wiadomości",
      errorTitle: "Wewnętrzny błąd serwera",

      errorDesc:
        "Serwer napotkał błąd wewnętrzny lub błędną konfigurację i nie mógł zrealizować Twojego żądania.",

      reload: "Przeładować",
      noMoreGoods: "Nie więcej, kliknij inną kartę i zobacz więcej",
      goodsEmptyTitle: "Brak towaru",
      goodsEmptyDesc: "Kliknij inną kartę i zobacz więcej",
      orderEmptyTitle: "Jest tu pusto",
      orderEmptyDesc: "Zobacz co jeszcze chciałbyś kupić",
      viewMore: "Zobacz więcej",
      latestProgress: "Najnowsze postępy",
      reason: "Powód",
      sold: "Sprzedany",
      noMore: "nie ma więcej informacji",
      loadError: "błąd ładowania, kliknij, aby spróbować ponownie",
      clearMessageSuccess: "Oznaczono wszystkie wiadomości jako przeczytane",
      orderTime: "Czas realizacji",
      orderId: "Identyfikator zamówienia",
      send: "Wysłać",
      networkOutage: "Sieć nie działa. Proszę wyjść i wejść ponownie!",
      versionTooLow: "Wersja aplikacji jest za niska.",
      submit: "Składać",
      unpaid: "NIE ZAPŁACONY",
      closed: "ZAMKNIĘTE",
      shipped: "WYSŁANY",
      complete: "KOMPLETNY",
      returning: "POWRACAJĄCY",
      processing: "PRZETWARZANIE",
      pending: "AŻ DO",
      refunded: "ZWROT",
      refunding: "ZWROT",
      tobeshipped: "DO WYSYŁKI",

      sentence1:
        "Zaloguj się przed rozmową z obsługą klienta za pomocą Zoomies.",

      login: "ZALOGUJ SIE",
      dialogtitle: "Wybierz, o co chcesz zapytać",
      viewed: "Oglądane",
      favorites: "Ulubione",
      cart: "Wózek",
      Order: "Zamówienie",
      networkError: "Nieprawidłowość w sieci",

      pushNotifications:
        "Włącz powiadomienia o aktualizacjach statusu najnowszego zamówienia.",

      pushNotificationsOpen: "OTWARTE",
      warnSpeakTitle: "Wiadomości systemowe",
      warnSpeakP1: "Witamy w Zoomies!",

      warnSpeakP2:
        "Nękanie, treści o charakterze pornograficznym, przemoc, prowokacyjne wiadomości i naruszenia są surowo zabronione na naszym czacie. Naruszenia będą skutkować natychmiastowym wyciszeniem lub innymi działaniami dyscyplinarnymi. Dziękujemy za pomoc w utrzymaniu pozytywnej społeczności!",

      Camera: "Aparat fotograficzny",
      serverDesc: "Agent obsługi klienta Voghion",
      serverWaitTip: "Wsparcie Łączenie",

      serverWaitDesc:
        "Szanowny użytkowniku, skontaktujemy Cię z działem obsługi klienta, prosimy o cierpliwość.",

      contactServiceText: "Jeśli nie możesz znaleźć zamówienia lub produktu,",
      contactService: "Skontaktuj się z nami",
      ServiceNotification: "Powiadomienie serwisowe",
      empty: "Jest tu pusto",
      VipNotification: "Powiadomienie VIP",
      refundRejected: "ZWROT ODRZUCONY",
      waitRefund: "CZEKAJ NA ZWROT",
      cancel: "ANULOWAĆ",
      received: "OTRZYMANE",
      end: "KONIEC",
      inviting: "ATRAKCYJNY",
      qualityInspection: "KONTROLA JAKOŚCI",
      qualityInspectionFailed: "KONTROLA JAKOŚCI NIE POWIODŁA SIĘ",
      preparingForShipment: "PRZYGOTOWANIE DO WYSYŁKI",
      approved: "ZATWIERDZONY",
      rejected: "ODRZUCONY",
      check_the_user_manual: "Sprawdź instrukcję obsługi",
      newin: "Nowy w",
      uploading: "Przesyłanie",
      uploadError: "Błąd przesyłania",

      ai: {
        recordInvisible:
          "Ups! Twój głos wydaje się być niewidzialny ~ Proszę podejść bliżej mikrofonu i spróbować ponownie! 🎤🤔",

        failedResolveAudio: "Nie udało się rozwiązać problemu z dźwiękiem",

        serverBusy:
          "Przepraszamy, serwer jest zajęty. Spróbuj ponownie później.",

        clearHistory: "Wyczyścić całą historię czatów?",
        cancel: "anulować",
        clear: "Wyczyść",
        newTopic: "Nowy temat",
        Refresh: "Odświeżać",
        holdToTalk: "Przytrzymaj, aby rozmawiać",
        releaseToCancel: "Zwolnij, aby anulować",
        swipeUpToCancel: "Przesuń w górę, aby anulować",
        askMTQuestion: "Zadaj pytanie MT",
        describeYourNeeds: "Opisz swoje potrzeby",
        speakTimeTooShort: "Czas mówienia jest za krótki",
        Camera: "Aparat fotograficzny",
        Photo: "Zdjęcie",
        sold: "sprzedany",

        updateTitle:
          "Nowa wersja dostępna! Zaktualizuj teraz, aby uzyskać najnowsze funkcje.",

        confirm: "Potwierdź",
        thinking: "Myślący.",
        suggestMore: "Zaproponuj więcej",
        feedbackSubmitted: "Opinia wysłana",
        serverError: "Błąd serwera, spróbuj ponownie później",
        copied: "Skopiowano",
        mostPopular: "Najbardziej popularny",
        TopSales: "Najlepsza sprzedaż",
        Price: "Cena",
        recommendation: "Zalecenie",
        title: "ZapytajShop",
        subTitle: "Zapytaj o zakupy, kupuj mądrzej.",
        askAnything: "Zapytaj o cokolwiek…",
        slogan: "Centrum zakupów AI.",
      },

      loading: "Załadunek...",
      view_more: "Zobacz więcej",

      signIn: {
        main: "Zalogować się",
        register: "Rejestr",
        email: "E-mail",
        password: "Hasło",
        forgotPassword: "Zapomniałeś hasła",
        forgotDesc:
          "Potwierdź swój adres e-mail, a my wyślemy link do resetowania hasła.",
        phoneNumber: "Numer telefonu",
        emailPlaceholder: "Wpisz adres e-mail",
        passwordPlaceholder: "Proszę wprowadzić hasło",
        passwordInvalid: "Hasło składa się z 5-16 znaków cyfrowych",
        success: "Logowanie powiodło się, strona zostanie odświeżona",
        resendSuccess: "Wyślij ponownie pomyślnie",
        signOut: "Wyloguj się",
        otherWays: "Lub kontynuuj w inny sposób",
        termsTips: "Akceptuję Voghion",
        newsletterTips: "Zarejestruj się aby otrzymać newsletter",
        privacyTips:
          "Używamy plików cookie i podobnych technologii, które są niezbędne do świadczenia naszych usług. Więcej szczegółów znajdziesz w naszym",
        terms: "Warunki korzystania",
        and: "I",
        privacy: "Polityka prywatności i plików cookie",
        confirmAcceptPrivacy: "Potwierdź prywatność logowania",
        agreeAccpetSms: "Musisz wyrazić zgodę na otrzymywanie wiadomości SMS",

        sendResetEmailSuccess: {
          title: "Wysłaliśmy Ci e-mail",

          content: `Jeśli nie znalazłeś wiadomości e-mail, <br>
          • wiadomość e-mail może zostać opóźniona o kilka minut.<br>
          • sprawdź folder spam.<br>
          • spróbuj kliknąć`,

          resend: "WYSŁAĆ PONOWNIE",
          back: "Wróć do logowania",
        },

        registerTitle: "Utwórz swoje konto {platform}",
        registerAutoLoginTitle:
          "Twój adres e-mail jest u nas zarejestrowany. Zaloguj się, aby uzyskać dostęp do pełnych funkcji Zoomies.",
        submitTips: "Proszę podać swój adres e-mail i pytanie",
      },

      common: {
        continue: "Kontynuować",
        submit: "Składać",
        save: "Ratować",
      },

      notLogin: {
        question: "Cześć, mam pytanie:",
        emailTip: "Ten e-mail nie wygląda na poprawny",
        pageTip:
          "Proszę o podanie szczegółowych pytań z opisem tekstowym i zrzutami ekranu, jeśli to możliwe. Pomożemy jak najszybciej! Jeśli odejdziesz, otrzymasz odpowiedź e-mailem.",
        or: "Lub",
        login: "Zaloguj się",
        continue: "kontynuować",
      },

      noMoreInformation: "nie ma więcej informacji",
    },
  },
  pt: {
    message: {
      title: "Mensagens",
      order: "Pedidos",
      orderDesc: "Mantenha-se atualizado sobre o status do pedido.",
      promo: "Promoções",
      promoDesc: "{count} códigos estão disponíveis",
      orderTitle: "Encomendar mensagens",
      errorTitle: "Erro do Servidor Interno",

      errorDesc:
        "O servidor encontrou um erro interno ou configuração incorreta e não conseguiu concluir sua solicitação.",

      reload: "recarregar",
      noMoreGoods: "Chega, clique em outra guia e veja mais",
      goodsEmptyTitle: "Nenhuma mercadoria disponível",
      goodsEmptyDesc: "Clique em outra guia e veja mais",
      orderEmptyTitle: "Está vazio aqui",
      orderEmptyDesc: "Veja o que mais você gostaria de comprar",
      viewMore: "Veja mais",
      latestProgress: "Último progresso",
      reason: "Razão",
      sold: "Vendido",
      noMore: "não há mais informações",
      loadError: "erro de carregamento, clique para tentar novamente",
      clearMessageSuccess: "Marcadas todas as mensagens como lidas com sucesso",
      orderTime: "Hora do pedido",
      orderId: "ID do pedido",
      send: "Enviar",
      networkOutage: "A rede está fora do ar, saia e entre novamente!",
      versionTooLow: "A versão do aplicativo é muito baixa.",
      submit: "Enviar",
      unpaid: "NÃO PAGO",
      closed: "FECHADO",
      shipped: "ENVIADO",
      complete: "COMPLETO",
      returning: "RETORNANDO",
      processing: "EM PROCESSAMENTO",
      pending: "PENDENTE",
      refunded: "DEVOLVEU",
      refunding: "REEMBOLSO",
      tobeshipped: "PARA SER ENVIADO",

      sentence1:
        "Faça login antes de conversar com o atendimento ao cliente usando Zoomies.",

      login: "CONECTE-SE",
      dialogtitle: "Selecione o que deseja perguntar",
      viewed: "Visto",
      favorites: "Favoritos",
      cart: "Carrinho",
      Order: "Ordem",
      networkError: "Anormalidade de rede",

      pushNotifications:
        "Ative as notificações para atualizações sobre o status do seu pedido mais recente.",

      pushNotificationsOpen: "ABRIR",
      warnSpeakTitle: "Mensagens do sistema",
      warnSpeakP1: "Bem-vindo ao Zoomies!",

      warnSpeakP2:
        "Assédio, conteúdo explícito, violência, mensagens provocativas e infrações são estritamente proibidos em nosso chat. Violações resultarão em silenciamento imediato ou outras ações disciplinares. Obrigado por nos ajudar a manter uma comunidade positiva!",

      Camera: "Câmera",
      serverDesc: "Agente de Atendimento ao Cliente Voghion",
      serverWaitTip: "Suporte Conectando",

      serverWaitDesc:
        "Caro usuário, estamos conectando você ao serviço de atendimento ao cliente. Aguarde pacientemente.",

      contactServiceText:
        "Se não conseguir encontrar o pedido ou o produto, por favor",

      contactService: "Contate-nos",
      ServiceNotification: "Notificação de serviço",
      empty: "Está vazio aqui",
      VipNotification: "Notificação VIP",
      refundRejected: "REEMBOLSO REJEITADO",
      waitRefund: "ESPERAR REEMBOLSO",
      cancel: "CANCELAR",
      received: "RECEBIDO",
      end: "FIM",
      inviting: "CONVIDATIVO",
      qualityInspection: "INSPEÇÃO DE QUALIDADE",
      qualityInspectionFailed: "INSPEÇÃO DE QUALIDADE FALHOU",
      preparingForShipment: "PREPARANDO PARA ENVIO",
      approved: "APROVADO",
      rejected: "REJEITADO",
      check_the_user_manual: "Verifique o manual do usuário",
      newin: "Novo em",
      uploading: "Enviando",
      uploadError: "Erro de upload",

      ai: {
        recordInvisible:
          "Ops! Parece que sua voz ficou invisível ~ Por favor, aproxime-se do microfone e tente novamente! 🎤🤔",

        failedResolveAudio: "Falha ao resolver o áudio",

        serverBusy:
          "Desculpe, o servidor está ocupado, tente novamente mais tarde.",

        clearHistory: "Limpar todo o histórico de bate-papo?",
        cancel: "Cancelar",
        clear: "Claro",
        newTopic: "Novo Tópico",
        Refresh: "Atualizar",
        holdToTalk: "Segure para falar",
        releaseToCancel: "Liberação para cancelar",
        swipeUpToCancel: "Deslize para cima para cancelar",
        askMTQuestion: "Faça uma pergunta ao MT",
        describeYourNeeds: "Descreva suas necessidades",
        speakTimeTooShort: "Tempo de fala muito curto",
        Camera: "Câmera",
        Photo: "foto",
        sold: "vendido",

        updateTitle:
          "Nova versão disponível! Atualize agora para obter os recursos mais recentes.",

        confirm: "Confirme",
        thinking: "Pensamento.",
        suggestMore: "Sugira mais",
        feedbackSubmitted: "Feedback enviado",
        serverError: "Erro no servidor, tente novamente mais tarde",
        copied: "Copiado",
        mostPopular: "Mais popular",
        TopSales: "Principais vendas",
        Price: "Preço",
        recommendation: "Recomendação",
        title: "AskShop",
        subTitle: "Pergunte ao Shopping, compre de forma mais inteligente.",
        askAnything: "Pergunte qualquer coisa…",
        slogan: "Centro de compras de IA.",
      },

      loading: "Carregando...",
      view_more: "Veja mais",

      signIn: {
        main: "Entrar",
        register: "Registro",
        email: "E-mail",
        password: "Senha",
        forgotPassword: "Esqueceu sua senha",
        forgotDesc:
          "Confirme seu endereço de e-mail e enviaremos um link de redefinição de senha.",
        phoneNumber: "Número de telefone",
        emailPlaceholder: "Por favor insira o e-mail",
        passwordPlaceholder: "Por favor insira a senha",
        passwordInvalid: "A senha consiste em caracteres de 5 a 16 dígitos",
        success: "Login bem-sucedido, a página será atualizada",
        resendSuccess: "Reenvio bem-sucedido",
        signOut: "sair",
        otherWays: "Ou continue com outras maneiras",
        termsTips: "Eu aceito Voghion",
        newsletterTips: "Inscreva-se no boletim informativo",
        privacyTips:
          "Utilizamos cookies e tecnologias semelhantes que são essenciais para lhe fornecer os nossos serviços. Para mais detalhes, consulte nosso",
        terms: "Termos de uso",
        and: "e",
        privacy: "Política de privacidade e cookies",
        confirmAcceptPrivacy: "Confirme a privacidade para fazer login",
        agreeAccpetSms: "Você tem que concordar em receber SMS",

        sendResetEmailSuccess: {
          title: "Enviamos um e-mail para você",

          content: `Se você não encontrou o e-mail, <br>
          • o e-mail pode atrasar por alguns minutos. <br>
          • verifique sua pasta de spam. <br>
          • tente clicar`,

          resend: "REENVIAR",
          back: "Voltar para fazer login",
        },

        registerTitle: "Crie sua conta {platform}",
        registerAutoLoginTitle:
          "Seu e-mail está registrado conosco. Faça login para acessar todos os recursos do Zoomies.",
        submitTips: "Por favor, insira seu e-mail e sua pergunta",
      },

      common: {
        continue: "Continuar",
        submit: "Enviar",
        save: "Salvar",
      },

      notLogin: {
        question: "Olá, tenho uma pergunta:",
        emailTip: "Esse e-mail não parece muito certo",
        pageTip:
          "Por favor, envie suas perguntas detalhadas, com descrição em texto e capturas de tela, se possível. Responderemos o mais rápido possível! Se você sair, receberá uma resposta por e-mail.",
        or: "Ou",
        login: "Conecte-se",
        continue: "continuar",
      },

      noMoreInformation: "não há mais informações",
    },
  },
  ru: {
    message: {
      title: "Сообщения",
      order: "Заказы",
      orderDesc: "Будьте в курсе статуса заказа.",
      promo: "Промоакции",
      promoDesc: "{count} коды доступны",
      orderTitle: "Сообщения о заказе",
      errorTitle: "Внутренняя ошибка сервера",

      errorDesc:
        "На сервере произошла внутренняя ошибка или неправильная конфигурация, и он не смог выполнить ваш запрос.",

      reload: "Перезагрузить",
      noMoreGoods: "Хватит, перейдите на другую вкладку и посмотрите больше",
      goodsEmptyTitle: "Нет доступных товаров",
      goodsEmptyDesc: "Откройте другую вкладку и просмотрите больше",
      orderEmptyTitle: "Здесь пусто",
      orderEmptyDesc: "Посмотрите, что еще вы хотели бы купить",
      viewMore: "Посмотреть больше",
      latestProgress: "Последний прогресс",
      reason: "Причина",
      sold: "Продал",
      noMore: "больше нет информации",
      loadError: "ошибка загрузки, нажмите, чтобы повторить попытку",
      clearMessageSuccess: "Все сообщения отмечены как прочитанные успешно",
      orderTime: "Время заказа",
      orderId: "номер заказа",
      send: "Отправлять",
      networkOutage: "Сеть не работает, пожалуйста, выйдите и войдите снова!",
      versionTooLow: "Версия приложения слишком низкая.",
      submit: "Отправить",
      unpaid: "БЕЗОПЛАТЫ",
      closed: "ЗАКРЫТО",
      shipped: "ОТПРАВЛЕННЫЙ",
      complete: "ПОЛНЫЙ",
      returning: "ВОЗВРАЩЕНИЕ",
      processing: "ОБРАБОТКА",
      pending: "В ОЖИДАНИИ",
      refunded: "ВОЗВРАЩЕНО",
      refunding: "ВОЗВРАТ ДЕНЕЖНЫХ СРЕДСТВ",
      tobeshipped: "ДЛЯ ОТПРАВКИ",

      sentence1:
        "Пожалуйста, войдите в систему, прежде чем общаться со службой поддержки клиентов с помощью Zoomies.",

      login: "АВТОРИЗОВАТЬСЯ",
      dialogtitle: "Пожалуйста, выберите, что вы хотите спросить",
      viewed: "Просмотрено",
      favorites: "Избранное",
      cart: "Корзина",
      Order: "Заказ",
      networkError: "Сетевая аномалия",

      pushNotifications:
        "Включите уведомления для получения обновлений о статусе вашего последнего заказа.",

      pushNotificationsOpen: "ОТКРЫТЬ",
      warnSpeakTitle: "Системные сообщения",
      warnSpeakP1: "Добро пожаловать в Zoomies!",

      warnSpeakP2:
        "В нашем чате строго запрещены домогательства, откровенный контент, насилие, провокационные сообщения и нарушения. Нарушения приведут к немедленному отключению звука или другим дисциплинарным мерам. Спасибо, что помогаете нам поддерживать позитивное сообщество!",

      Camera: "Камера",
      serverDesc: "Агент по работе с клиентами Voghion",
      serverWaitTip: "Поддержка подключения",

      serverWaitDesc:
        "Уважаемый пользователь, мы свяжем вас со службой поддержки клиентов, пожалуйста, подождите.",

      contactServiceText:
        "Если вы не можете найти заказ или товар, пожалуйста,",

      contactService: "связаться с нами",
      ServiceNotification: "Уведомление о сервисе",
      empty: "Здесь пусто",
      VipNotification: "VIP-уведомление",
      refundRejected: "ВОЗВРАТ ОТКЛОНЕН",
      waitRefund: "ЖДИТЕ ВОЗВРАТ",
      cancel: "ОТМЕНА",
      received: "ПОЛУЧЕННЫЙ",
      end: "КОНЕЦ",
      inviting: "ПРИГЛАШЕНИЕ",
      qualityInspection: "КОНТРОЛЬ КАЧЕСТВА",
      qualityInspectionFailed: "КОНТРОЛЬ КАЧЕСТВА НЕ ПРОЙДЕН",
      preparingForShipment: "ПОДГОТОВКА К ОТГРУЗКЕ",
      approved: "ОДОБРЕННЫЙ",
      rejected: "ОТКЛОНЕННЫЙ",
      check_the_user_manual: "Проверьте руководство пользователя.",
      newin: "Новое в",
      uploading: "Загрузка",
      uploadError: "Ошибка загрузки",

      ai: {
        recordInvisible:
          "Упс! Кажется, ваш голос стал невидимым ~ Пожалуйста, подойдите ближе к микрофону и попробуйте еще раз! 🎤🤔",

        failedResolveAudio: "Не удалось разрешить аудио",
        serverBusy: "Извините, сервер занят, попробуйте еще раз позже.",
        clearHistory: "Очистить всю историю чата?",
        cancel: "Отмена",
        clear: "Чисто",
        newTopic: "Новая тема",
        Refresh: "Обновить",
        holdToTalk: "Удерживайте, чтобы говорить",
        releaseToCancel: "Отпустите, чтобы отменить",
        swipeUpToCancel: "Проведите пальцем вверх, чтобы отменить",
        askMTQuestion: "Задайте вопрос МТ",
        describeYourNeeds: "Опишите ваши потребности",
        speakTimeTooShort: "Слишком мало времени на разговор",
        Camera: "Камера",
        Photo: "Фото",
        sold: "продал",

        updateTitle:
          "Доступна новая версия! Обновите сейчас, чтобы получить новейшие функции.",

        confirm: "Подтверждать",
        thinking: "Думаю.",
        suggestMore: "Предложить больше",
        feedbackSubmitted: "Отзыв отправлен",
        serverError: "Ошибка сервера, попробуйте позже",
        copied: "Скопировано",
        mostPopular: "Самый популярный",
        TopSales: "Лучшие продажи",
        Price: "Цена",
        recommendation: "Рекомендация",
        title: "AskShop",
        subTitle: "Спросите о покупках, совершайте покупки с умом.",
        askAnything: "Спросите что угодно…",
        slogan: "AI shopping hub.",
      },

      loading: "Загрузка...",
      view_more: "посмотреть больше",

      signIn: {
        main: "Войти",
        register: "регистр",
        email: "Электронная почта",
        password: "Пароль",
        forgotPassword: "Забыли пароль",
        forgotDesc:
          "Подтвердите свой адрес электронной почты, и мы вышлем ссылку для сброса пароля.",
        phoneNumber: "Номер телефона",
        emailPlaceholder: "Пожалуйста, введите адрес электронной почты",
        passwordPlaceholder: "Пожалуйста, введите пароль",
        passwordInvalid: "Пароль состоит из 5-16 цифр.",
        success: "Вход выполнен успешно, страница будет обновлена",
        resendSuccess: "Повторная отправка успешна",
        signOut: "выход",
        otherWays: "Или продолжите другими способами",
        termsTips: "Я принимаю Вогион",
        newsletterTips: "Подписаться на рассылку",
        privacyTips:
          "Мы используем файлы cookie и аналогичные технологии, которые необходимы для предоставления вам наших услуг. Более подробную информацию смотрите в нашем",
        terms: "Условия эксплуатации",
        and: "и",
        privacy: "Политика конфиденциальности и использования файлов cookie",
        confirmAcceptPrivacy:
          "Пожалуйста, подтвердите конфиденциальность для входа в систему",
        agreeAccpetSms: "Вы должны согласиться на получение СМС",

        sendResetEmailSuccess: {
          title: "Мы отправили вам письмо",

          content: `Если вы не нашли письмо, <br>
          • электронное письмо может задерживаться на несколько минут.<br>
          • пожалуйста, проверьте папку со спамом.<br>
          • попробуйте нажать`,

          resend: "ОТПРАВИТЬ",
          back: "Вернуться к входу",
        },

        registerTitle: "Создайте свою учетную запись {platform}",
        registerAutoLoginTitle:
          "Ваш адрес электронной почты уже зарегистрирован. Пожалуйста, войдите в систему, чтобы получить доступ ко всем функциям Zoomies.",
        submitTips:
          "Пожалуйста, введите свой адрес электронной почты и ваш вопрос",
      },

      common: {
        continue: "Продолжать",
        submit: "Представлять на рассмотрение",
        save: "Сохранять",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Или же",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "больше нет информации",
    },
  },
  sk: {
    message: {
      title: "Správy",
      order: "objednávky",
      orderDesc: "Informujte sa o stave objednávky.",
      promo: "Reklamy",
      promoDesc: "K dispozícii sú kódy {count}",
      orderTitle: "Objednať správy",
      errorTitle: "Interná chyba servera",

      errorDesc:
        "Server zaznamenal internú chybu alebo nesprávnu konfiguráciu a nemohol dokončiť vašu požiadavku.",

      reload: "Znovu načítať",
      noMoreGoods: "Už nič, kliknite na inú kartu a zobrazte viac",
      goodsEmptyTitle: "Nie je dostupný žiadny tovar",
      goodsEmptyDesc: "Kliknite na inú kartu a zobrazte viac",
      orderEmptyTitle: "Je tu prázdno",
      orderEmptyDesc: "Pozrite sa, čo by ste ešte chceli kúpiť",
      viewMore: "Vidieť viac",
      latestProgress: "Najnovší pokrok",
      reason: "Dôvod",
      sold: "Predané",
      noMore: "žiadne ďalšie informácie",
      loadError: "chyba načítania, kliknutím to skúste znova",
      clearMessageSuccess: "Všetky správy boli označené ako úspešné prečítané",
      orderTime: "Čas objednávky",
      orderId: "Číslo objednávky",
      send: "Odoslať",
      networkOutage: "Sieť nefunguje, opustite ju a znova vstúpte!",
      versionTooLow: "Verzia aplikácie je príliš nízka.",
      submit: "Odoslať",
      unpaid: "NEZAPLATENÉ",
      closed: "ZATVORENÉ",
      shipped: "POSLANÉ",
      complete: "KOMPLET",
      returning: "VRÁTENIE",
      processing: "SPRACOVANIE",
      pending: "ČAKÁ",
      refunded: "VRÁTENÉ",
      refunding: "VRÁTENIE PEŇAZÍ",
      tobeshipped: "BUDE ODOSLANÉ",

      sentence1:
        "Pred chatovaním so zákazníckym servisom pomocou Zoomies sa prihláste.",

      login: "PRIHLÁSIŤ SA",
      dialogtitle: "Vyberte, na čo sa chcete opýtať",
      viewed: "Zobrazené",
      favorites: "Obľúbené",
      cart: "Košík",
      Order: "objednať",
      networkError: "Abnormality siete",

      pushNotifications:
        "Zapnite upozornenia na aktualizácie najnovšieho stavu vašej objednávky.",

      pushNotificationsOpen: "OTVORENÉ",
      warnSpeakTitle: "Systémové správy",
      warnSpeakP1: "Vitajte v Zoomies!",

      warnSpeakP2:
        "V našom chate je prísne zakázané obťažovanie, explicitný obsah, násilie, provokatívne správy a porušovanie práv. Porušenie bude mať za následok okamžité ignorovanie alebo iné disciplinárne opatrenia. Ďakujeme, že nám pomáhate udržiavať pozitívnu komunitu!",

      Camera: "fotoaparát",
      serverDesc: "Agent zákazníckeho servisu Voghion",
      serverWaitTip: "Podpora pripojenia",

      serverWaitDesc:
        "Vážený používateľ, spájame vás so zákazníckym servisom, čakajte prosím trpezlivo.",

      contactServiceText: "Ak nemôžete nájsť objednávku alebo produkt, prosím",
      contactService: "kontaktujte nás",
      ServiceNotification: "Servisné oznámenie",
      empty: "Je tu prázdno",
      VipNotification: "VIP upozornenie",
      refundRejected: "VRÁTENIE PLATBY ZAMIETNUTÉ",
      waitRefund: "POČKAJTE VRÁTENIE PEŇAZÍ",
      cancel: "ZRUŠIŤ",
      received: "PRIJATÉ",
      end: "KONIEC",
      inviting: "POZVÁNKA",
      qualityInspection: "KONTROLA KVALITY",
      qualityInspectionFailed: "KONTROLA KVALITY ZLYHALA",
      preparingForShipment: "PRIPRAVUJE SA NA ODOSIELANIE",
      approved: "SCHVÁLENÉ",
      rejected: "ZAMIETNUTÉ",
      check_the_user_manual: "Skontrolujte používateľskú príručku",
      newin: "Nové v",
      uploading: "Nahrávanie",
      uploadError: "Chyba nahrávania",

      ai: {
        recordInvisible:
          "Ups! Zdá sa, že tvoj hlas je neviditeľný ~ Priblíž sa k mikrofónu a skús to znova! 🎤🤔",

        failedResolveAudio: "Nepodarilo sa vyriešiť zvuk",

        serverBusy:
          "Prepáčte, server je zaneprázdnený, skúste to znova neskôr.",

        clearHistory: "Vymazať celú históriu chatu?",
        cancel: "Zrušiť",
        clear: "Vymazať",
        newTopic: "Nová téma",
        Refresh: "Obnoviť",
        holdToTalk: "Podržaním hovoru",
        releaseToCancel: "Uvoľnite pre zrušenie",
        swipeUpToCancel: "Prejdením prstom nahor zrušíte",
        askMTQuestion: "Položte MT otázku",
        describeYourNeeds: "Popíšte svoje potreby",
        speakTimeTooShort: "Príliš krátky čas na rozprávanie",
        Camera: "fotoaparát",
        Photo: "Fotografia",
        sold: "predané",

        updateTitle:
          "K dispozícii je nová verzia! Aktualizujte teraz a získajte najnovšie funkcie.",

        confirm: "Potvrďte",
        thinking: "Myslenie.",
        suggestMore: "Navrhnúť viac",
        feedbackSubmitted: "Spätná väzba odoslaná",
        serverError: "Chyba servera, skúste to znova neskôr",
        copied: "Skopírované",
        mostPopular: "Najpopulárnejší",
        TopSales: "Najpredávanejšie",
        Price: "cena",
        recommendation: "Odporúčanie",
        title: "AskShop",
        subTitle: "Nakupujte múdrejšie, opýtajte sa nás.",
        askAnything: "Opýtaj sa čokoľvek…",
        slogan: "AI shopping hub.",
      },

      loading: "Načítava sa...",
      view_more: "vidieť viac",

      signIn: {
        main: "Prihlásiť sa",
        register: "Registrovať",
        email: "Email",
        password: "heslo",
        forgotPassword: "Zabudol si heslo",
        forgotDesc:
          "Potvrďte svoju e-mailovú adresu a my vám pošleme odkaz na obnovenie hesla.",
        phoneNumber: "Telefónne číslo",
        emailPlaceholder: "Zadajte e-mail",
        passwordPlaceholder: "Zadajte heslo",
        passwordInvalid: "Heslo pozostáva z 5-16 číslic",
        success: "Prihlásenie bolo úspešné, stránka sa obnoví",
        resendSuccess: "Opätovné odoslanie bolo úspešné",
        signOut: "Odhlásiť Sa",
        otherWays: "Alebo pokračujte inými spôsobmi",
        termsTips: "Prijímam Voghiona",
        newsletterTips: "Prihlásiť sa na odber noviniek",
        privacyTips:
          "Používame cookies a podobné technológie, ktoré sú nevyhnutné na poskytovanie našich služieb. Viac podrobností nájdete v našom",
        terms: "Podmienky používania",
        and: "a",
        privacy: "Zásady ochrany osobných údajov a súborov cookie",
        confirmAcceptPrivacy: "Pred prihlásením potvrďte súkromie",
        agreeAccpetSms: "S prijímaním SMS musíte súhlasiť",

        sendResetEmailSuccess: {
          title: "Poslali sme vám e-mail",

          content: `Ak ste nenašli e-mail, <br>
          • e-mail sa môže o niekoľko minút oneskoriť.<br>
          • skontrolujte priečinok so spamom.<br>
          • skúste kliknúť`,

          resend: "ZNOVU ODOSLAŤ",
          back: "Späť na Prihlásenie",
        },

        registerTitle: "Vytvorte si účet {platform}",
        registerAutoLoginTitle:
          "Vaša e-mailová adresa je u nás zaregistrovaná. Prihláste sa, aby ste mohli využívať všetky funkcie Zoomies.",
        submitTips: "Vyplňte prosím svoju e-mailovú adresu a váš dotaz.",
      },

      common: {
        continue: "ďalej",
        submit: "Predložiť",
        save: "Uložiť",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Alebo",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "žiadne ďalšie informácie",
    },
  },
  sl: {
    message: {
      title: "Sporočila",
      order: "Naročila",
      orderDesc: "Bodite obveščeni o statusu naročila.",
      promo: "Promocije",
      promoDesc: "{count} kode so na voljo",
      orderTitle: "Naročila Sporočila",
      errorTitle: "napaka notranjega strežnika",

      errorDesc:
        "Strežnik je naletel na notranjo napako ali napačno konfiguracijo in ni mogel dokončati vaše zahteve.",

      reload: "Ponovno naloži",
      noMoreGoods: "Nič več, kliknite drug zavihek in si oglejte več",
      goodsEmptyTitle: "Blago ni na voljo",
      goodsEmptyDesc: "Kliknite drug zavihek in si oglejte več",
      orderEmptyTitle: "Tukaj je prazno",
      orderEmptyDesc: "Poglejte, kaj bi še radi kupili",
      viewMore: "Poglej več",
      latestProgress: "Zadnji napredek",
      reason: "Razlog",
      sold: "prodano",
      noMore: "ni več informacij",
      loadError: "napaka pri nalaganju, kliknite za ponovni poskus",
      clearMessageSuccess: "Vsa sporočila označena kot uspešno prebrana",
      orderTime: "Čas naročila",
      orderId: "Številka naročila",
      send: "Pošlji",
      networkOutage: "Omrežje je prekinjeno, zapustite in ponovno vstopite!",
      versionTooLow: "Različica aplikacije je prenizka.",
      submit: "Oddaj",
      unpaid: "NEPLAČANO",
      closed: "ZAPRTO",
      shipped: "POSLANO",
      complete: "POPOLNO",
      returning: "VRAČANJE",
      processing: "OBRAVNAVATI",
      pending: "V TEKU",
      refunded: "POVRNJENO",
      refunding: "POVRAČILO",
      tobeshipped: "ZA POŠILJO",

      sentence1:
        "Prosimo, prijavite se, preden klepetate s službo za pomoč strankam z uporabo Zoomies.",

      login: "VPIŠI SE",
      dialogtitle: "Prosimo izberite, kaj želite vprašati",
      viewed: "Ogledano",
      favorites: "Priljubljene",
      cart: "Voziček",
      Order: "naročilo",
      networkError: "Nenormalnost omrežja",

      pushNotifications:
        "Vklopite obvestila za posodobitve stanja vašega zadnjega naročila.",

      pushNotificationsOpen: "ODPRTO",
      warnSpeakTitle: "Sistemska sporočila",
      warnSpeakP1: "Dobrodošli v Zoomies!",

      warnSpeakP2:
        "Nadlegovanje, eksplicitna vsebina, nasilje, provokativna sporočila in kršitve so v našem klepetu strogo prepovedani. Kršitve bodo povzročile takojšnjo utišanje ali druge disciplinske ukrepe. Hvala, ker nam pomagate ohranjati pozitivno skupnost!",

      Camera: "Kamera",
      serverDesc: "Agent za pomoč strankam Voghion",
      serverWaitTip: "Podpora za povezovanje",

      serverWaitDesc:
        "Dragi uporabnik, povezujemo vas s službo za stranke, prosimo, počakajte potrpežljivo.",

      contactServiceText: "Če ne najdete naročila ali izdelka, prosim",
      contactService: "kontaktirajte nas",
      ServiceNotification: "Servisno obvestilo",
      empty: "Tukaj je prazno",
      VipNotification: "Vip obvestilo",
      refundRejected: "VRAČILO ZAVRNJENO",
      waitRefund: "POČAKAJTE POVRAČILO",
      cancel: "PREKLIC",
      received: "PREJETO",
      end: "KONEC",
      inviting: "VABLJIV",
      qualityInspection: "PREGLED KAKOVOSTI",
      qualityInspectionFailed: "PREGLED KAKOVOSTI NI USPEŠEN",
      preparingForShipment: "PRIPRAVA ZA POŠILJO",
      approved: "ODOBRENA",
      rejected: "ZAVRNJENO",
      check_the_user_manual: "Preverite uporabniški priročnik",
      newin: "Novo v",
      uploading: "Nalaganje",
      uploadError: "Napaka pri nalaganju",

      ai: {
        recordInvisible:
          "Ups! Zdi se, da je tvoj glas postal neviden ~ Prosim, približaj se mikrofonu in poskusi znova! 🎤🤔",

        failedResolveAudio: "Zvoka ni bilo mogoče razrešiti",
        serverBusy: "Žal je strežnik zaseden, poskusite znova pozneje.",
        clearHistory: "Želite izbrisati vso zgodovino klepeta?",
        cancel: "Prekliči",
        clear: "Počisti",
        newTopic: "Nova tema",
        Refresh: "Osveži",
        holdToTalk: "Zadržite za pogovor",
        releaseToCancel: "Spustite za preklic",
        swipeUpToCancel: "Povlecite navzgor za preklic",
        askMTQuestion: "Postavite MT vprašanje",
        describeYourNeeds: "Opišite svoje potrebe",
        speakTimeTooShort: "Čas za govor je prekratek",
        Camera: "Kamera",
        Photo: "Fotografija",
        sold: "prodano",

        updateTitle:
          "Na voljo je nova različica! Posodobite zdaj za najnovejše funkcije.",

        confirm: "Potrdi",
        thinking: "Razmišljanje.",
        suggestMore: "Predlagaj več",
        feedbackSubmitted: "Povratne informacije so bile poslane",
        serverError: "Napaka strežnika, poskusite znova pozneje",
        copied: "Kopirano",
        mostPopular: "Najbolj priljubljena",
        TopSales: "Najboljša prodaja",
        Price: "Cena",
        recommendation: "Priporočilo",
        title: "AskShop",
        subTitle: "Vprašajte pri nakupovanju, nakupujte pametneje.",
        askAnything: "Vprašajte karkoli …",
        slogan: "AI shopping hub.",
      },

      loading: "Nalaganje...",
      view_more: "Poglej več",

      signIn: {
        main: "Prijava",
        register: "Registrirajte se",
        email: "E-naslov",
        password: "Geslo",
        forgotPassword: "Ste pozabili geslo",
        forgotDesc:
          "Potrdite svoj e-poštni naslov in poslali vam bomo povezavo za ponastavitev gesla.",
        phoneNumber: "Telefonska številka",
        emailPlaceholder: "Vnesite e-pošto",
        passwordPlaceholder: "Prosim vnesite geslo",
        passwordInvalid: "Geslo je sestavljeno iz 5-16 mestnih znakov",
        success: "Prijava je bila uspešna, stran bo osvežena",
        resendSuccess: "Ponovno pošiljanje uspešno",
        signOut: "Odjava",
        otherWays: "Ali nadaljujte z drugimi načini",
        termsTips: "Sprejemam Voghion",
        newsletterTips: "Naroči se na novice",
        privacyTips:
          "Uporabljamo piškotke in podobne tehnologije, ki so bistvenega pomena za zagotavljanje naših storitev. Za več podrobnosti glejte naše",
        terms: "Pogoji uporabe",
        and: "in",
        privacy: "Politika zasebnosti in piškotkov",
        confirmAcceptPrivacy: "Za prijavo potrdite zasebnost",
        agreeAccpetSms: "Za prejemanje SMS se morate strinjati",

        sendResetEmailSuccess: {
          title: "Poslali smo vam e-pošto",

          content: `Če niste našli e-pošte, <br>
          • e-pošta lahko zakasni za nekaj minut.<br>
          • preverite svojo mapo z vsiljeno pošto.<br>
          • poskusite klikniti`,

          resend: "PONOVNO POSLATI",
          back: "Nazaj na prijavo",
        },

        registerTitle: "Ustvarite svoj {platform} račun",
        registerAutoLoginTitle:
          "Vaš e-poštni naslov je že registriran. Prijavite se za dostop do vseh funkcij Zoomies.",
        submitTips: "Vpišite svojo e-pošto in vprašanje.",
      },

      common: {
        continue: "Nadaljuj",
        submit: "Predloži",
        save: "Shrani",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Ali",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "ni več informacij",
    },
  },
  sv: {
    message: {
      title: "Meddelanden",
      order: "Order",
      orderDesc: "Håll dig uppdaterad om orderstatus.",
      promo: "Kampanjer",
      promoDesc: "{count}-koder är tillgängliga",
      orderTitle: "Beställ meddelanden",
      errorTitle: "internt serverfel",

      errorDesc:
        "Servern stötte på ett internt fel eller felkonfiguration och kunde inte slutföra din begäran.",

      reload: "Ladda om",
      noMoreGoods: "Inte mer, klicka på en annan flik och se mer",
      goodsEmptyTitle: "Inga varor tillgängliga",
      goodsEmptyDesc: "Klicka på en annan flik och se mer",
      orderEmptyTitle: "Det är tomt här",
      orderEmptyDesc: "Se vad mer du skulle vilja köpa",
      viewMore: "Visa mer",
      latestProgress: "Senaste framsteg",
      reason: "Anledning",
      sold: "Såld",
      noMore: "ingen mer information",
      loadError: "laddningsfel, klicka för att försöka igen",
      clearMessageSuccess: "Markerade alla meddelanden som lästa",
      orderTime: "Beställningstid",
      orderId: "Beställnings-ID",
      send: "Skicka",
      networkOutage: "Nätverket är nere, vänligen avsluta och gå in igen!",
      versionTooLow: "Appversionen är för låg.",
      submit: "Skicka in",
      unpaid: "OBETALD",
      closed: "STÄNGD",
      shipped: "SÄNDAS",
      complete: "KOMPLETT",
      returning: "ÅTERVÄNDANDE",
      processing: "BEHANDLING",
      pending: "I VÄNTAN PÅ",
      refunded: "ÅTERBETALAD",
      refunding: "ÅTERBETALNING",
      tobeshipped: "ATT SKICKAS",
      sentence1: "Logga in innan du chattar med kundtjänst med Zoomies.",
      login: "LOGGA IN",
      dialogtitle: "Välj vad du vill fråga",
      viewed: "Tittade",
      favorites: "Favoriter",
      cart: "Vagn",
      Order: "Ordning",
      networkError: "Nätverksavvikelse",

      pushNotifications:
        "Aktivera aviseringar för uppdateringar om din senaste beställningsstatus.",

      pushNotificationsOpen: "ÖPPNA",
      warnSpeakTitle: "Systemmeddelanden",
      warnSpeakP1: "Välkommen till Zoomies!",

      warnSpeakP2:
        "Trakasserier, explicit innehåll, våld, provocerande meddelanden och intrång är strängt förbjudna i vår chatt. Överträdelser kommer att resultera i omedelbara tysta eller andra disciplinära åtgärder. Tack för att du hjälper oss att upprätthålla en positiv gemenskap!",

      Camera: "Kamera",
      serverDesc: "Voghions kundtjänstombud",
      serverWaitTip: "Support Anslutning",

      serverWaitDesc:
        "Kära användare, vi matchar dig med kundtjänst, vänta tålmodigt.",

      contactServiceText:
        "Om du inte kan hitta beställning eller produkt, vänligen",

      contactService: "kontakta oss",
      ServiceNotification: "Servicemeddelande",
      empty: "Det är tomt här",
      VipNotification: "Vip-avisering",
      refundRejected: "ÅTERBETALNING AVVISAD",
      waitRefund: "VÄNTA ÅTERBETALNING",
      cancel: "ANNULLERA",
      received: "MOTTAGEN",
      end: "AVSLUTA",
      inviting: "INBJUDANDE",
      qualityInspection: "KVALITETSINSPEKTION",
      qualityInspectionFailed: "KVALITETSINSPEKTION MISSLYCKADES",
      preparingForShipment: "FÖRBEREDELSER FÖR SÄNDNING",
      approved: "GODKÄND",
      rejected: "AVVISAD",
      check_the_user_manual: "Kontrollera bruksanvisningen",
      newin: "Ny i",
      uploading: "Uppladdning",
      uploadError: "Uppladdningsfel",

      ai: {
        recordInvisible:
          "Hoppsan! Din röst verkar ha blivit osynlig ~ Gå närmare mikrofonen och försök igen! 🎤🤔",

        failedResolveAudio: "Misslyckades med att lösa ljudet",
        serverBusy: "Tyvärr är servern upptagen, försök igen senare.",
        clearHistory: "Rensa all chatthistorik?",
        cancel: "Avbryt",
        clear: "Klart",
        newTopic: "Nytt ämne",
        Refresh: "Uppdatera",
        holdToTalk: "Håll för att prata",
        releaseToCancel: "Släpp för att avbryta",
        swipeUpToCancel: "Svep uppåt för att avbryta",
        askMTQuestion: "Ställ en fråga till MT",
        describeYourNeeds: "Beskriv dina behov",
        speakTimeTooShort: "Taltiden är för kort",
        Camera: "Kamera",
        Photo: "Foto",
        sold: "såld",

        updateTitle:
          "Ny version tillgänglig! Uppdatera nu för de senaste funktionerna.",

        confirm: "Bekräfta",
        thinking: "Tänkande.",
        suggestMore: "Föreslå mer",
        feedbackSubmitted: "Feedback inskickad",
        serverError: "Serverfel, försök igen senare",
        copied: "Kopierad",
        mostPopular: "Mest populär",
        TopSales: "Toppförsäljning",
        Price: "Pris",
        recommendation: "Rekommendation",
        title: "AskShop",
        subTitle: "Fråga Shopping, Handla smartare.",
        askAnything: "Fråga vad som helst…",
        slogan: "AI shopping hub.",
      },

      loading: "Belastning...",
      view_more: "visa mer",

      signIn: {
        main: "Logga in",
        register: "Registrera",
        email: "E-post",
        password: "Lösenord",
        forgotPassword: "glömt ditt lösenord",
        forgotDesc:
          "Bekräfta din e-postadress så skickar vi en länk för återställning av lösenord.",
        phoneNumber: "Telefonnummer",
        emailPlaceholder: "Vänligen ange e-post",
        passwordPlaceholder: "Vänligen ange lösenord",
        passwordInvalid: "Lösenordet består av 5-16 siffror",
        success: "Inloggningen lyckades, sidan kommer att uppdateras",
        resendSuccess: "Återsändningen lyckades",
        signOut: "Logga ut",
        otherWays: "Eller fortsätt med andra sätt",
        termsTips: "Jag accepterar till Voghion",
        newsletterTips: "Registrera dig för nyhetsbrev",
        privacyTips:
          "Vi använder cookies och liknande tekniker som är nödvändiga för att tillhandahålla dig våra tjänster. För mer information, se vår",
        terms: "Villkor",
        and: "och",
        privacy: "Integritets- och cookiepolicy",
        confirmAcceptPrivacy: "Bekräfta integritet för att logga in",
        agreeAccpetSms: "Du måste acceptera att ta emot SMS",

        sendResetEmailSuccess: {
          title: "Vi har skickat ett mejl till dig",

          content: `Om du inte har hittat e-post, <br>
          • e-post kan bli försenat i några minuter.<br>
          • vänligen kontrollera vår skräppostmapp.<br>
          • försök att klicka`,

          resend: "SKICKA IGEN",
          back: "Tillbaka till Logga in",
        },

        registerTitle: "Skapa ditt {platform}-konto",
        registerAutoLoginTitle:
          "Din e-postadress är redan registrerad. Logga in för att få tillgång till alla Zoomies-funktioner.",
        submitTips: "Vänligen ange din e-postadress och din fråga.",
      },

      common: {
        continue: "Fortsätta",
        submit: "Skicka in",
        save: "Spara",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Eller",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "ingen mer information",
    },
  },
  tr: {
    message: {
      title: "Mesajlar",
      order: "Emirler",
      orderDesc: "Sipariş durumu hakkında güncel bilgileri tutun.",
      promo: "Promosyonlar",
      promoDesc: "{count} kodları mevcut",
      orderTitle: "Sipariş Mesajları",
      errorTitle: "İç Sunucu Hatası",

      errorDesc:
        "Sunucu dahili bir hatayla veya yanlış yapılandırmayla karşılaştı ve isteğinizi tamamlayamadı.",

      reload: "Tekrar yükle",

      noMoreGoods:
        "Artık yok, başka bir sekmeye tıklayın ve daha fazlasını görüntüleyin",

      goodsEmptyTitle: "Mevcut ürün yok",

      goodsEmptyDesc:
        "Başka bir sekmeye tıklayın ve daha fazlasını görüntüleyin",

      orderEmptyTitle: "burası boş",
      orderEmptyDesc: "Başka ne satın almak istediğinizi görün",
      viewMore: "Daha fazla göster",
      latestProgress: "Son ilerleme",
      reason: "Sebep",
      sold: "Satılmış",
      noMore: "daha fazla bilgi yok",
      loadError: "yükleme hatası, yeniden denemek için tıklayın",

      clearMessageSuccess:
        "Tüm iletiler başarılı olarak okundu olarak işaretlendi",

      orderTime: "Sipariş zamanı",
      orderId: "Sipariş Kimliği",
      send: "Göndermek",
      networkOutage: "Ağ kapalı, lütfen çıkıp tekrar girin!",
      versionTooLow: "Uygulama sürümü çok düşük.",
      submit: "Göndermek",
      unpaid: "ÖDENMEMİŞ",
      closed: "KAPALI",
      shipped: "GÖNDERİLDİ",
      complete: "TAMAMLAMAK",
      returning: "GERİ DÖNÜŞ",
      processing: "İŞLEME",
      pending: "ASKIDA OLMASI",
      refunded: "İADE EDİLDİ",
      refunding: "İADE",
      tobeshipped: "GÖNDERİLECEK",

      sentence1:
        "Zoomies kullanarak müşteri hizmetleriyle sohbet etmeden önce lütfen giriş yapın.",

      login: "GİRİŞ YAPMAK",
      dialogtitle: "Lütfen sormak istediklerinizi seçin",
      viewed: "Görüntülendi",
      favorites: "Favoriler",
      cart: "Araba",
      Order: "Sipariş",
      networkError: "Ağ anormalliği",

      pushNotifications:
        "En son sipariş durumunuzla ilgili güncellemeler için bildirimleri açın.",

      pushNotificationsOpen: "AÇIK",
      warnSpeakTitle: "Sistem Mesajları",
      warnSpeakP1: "Zoomies'e Hoş Geldiniz!",

      warnSpeakP2:
        "Sohbetimizde taciz, açık içerik, şiddet, kışkırtıcı mesajlar ve ihlal kesinlikle yasaktır. İhlaller anında susturma veya diğer disiplin işlemleriyle sonuçlanacaktır. Olumlu bir topluluk sürdürmemize yardımcı olduğunuz için teşekkür ederiz!",

      Camera: "Kamera",
      serverDesc: "Voghion Müşteri Hizmetleri Temsilcisi",
      serverWaitTip: "Destek Bağlantısı",

      serverWaitDesc:
        "Değerli kullanıcımız, sizi müşteri hizmetlerimizle eşleştiriyoruz, lütfen sabırlı olun.",

      contactServiceText: "Siparişi veya ürünü bulamazsanız lütfen",
      contactService: "bize Ulaşın",
      ServiceNotification: "Servis Bildirimi",
      empty: "burası boş",
      VipNotification: "Vip Bildirimi",
      refundRejected: "İADE REDDEDİLDİ",
      waitRefund: "İADE BEKLEYİN",
      cancel: "İPTAL ETMEK",
      received: "KABUL EDİLMİŞ",
      end: "SON",
      inviting: "DAVET EDİCİ",
      qualityInspection: "KALİTE DENETİMİ",
      qualityInspectionFailed: "KALİTE DENETİMİ BAŞARISIZ OLDU",
      preparingForShipment: "SEVKİYATA HAZIRLIK",
      approved: "ONAYLI",
      rejected: "REDDEDİLMİŞ",
      check_the_user_manual: "Kullanım kılavuzunu kontrol edin",
      newin: "Yeni",
      uploading: "Yükleme",
      uploadError: "Yükleme hatası",

      ai: {
        recordInvisible:
          "Oops! Sesinizin görünmez olduğu anlaşılıyor ~ Lütfen mikrofona yaklaşın ve tekrar deneyin! 🎤🤔",

        failedResolveAudio: "Ses çözülemedi",
        serverBusy: "Üzgünüz, sunucu meşgul, lütfen daha sonra tekrar deneyin.",
        clearHistory: "Tüm sohbet geçmişini temizle?",
        cancel: "İptal etmek",
        clear: "Temiz",
        newTopic: "Yeni Konu",
        Refresh: "Yenile",
        holdToTalk: "Konuşmak için tutun",
        releaseToCancel: "İptal etmek için serbest bırakın",
        swipeUpToCancel: "İptal etmek için yukarı kaydırın",
        askMTQuestion: "MT'ye bir soru sor",
        describeYourNeeds: "İhtiyaçlarınızı açıklayın",
        speakTimeTooShort: "Konuşma süresi çok kısa",
        Camera: "Kamera",
        Photo: "Fotoğraf",
        sold: "satılmış",

        updateTitle:
          "Yeni sürüm mevcut! En son özellikler için hemen güncelleyin.",

        confirm: "Onaylamak",
        thinking: "Düşünmek.",
        suggestMore: "Daha Fazlasını Önerin",
        feedbackSubmitted: "Geri bildirim gönderildi",
        serverError: "Sunucu Hatası, daha sonra tekrar deneyin",
        copied: "Kopyalandı",
        mostPopular: "En popüler",
        TopSales: "En Çok Satış",
        Price: "Fiyat",
        recommendation: "Tavsiye",
        title: "AskShop",
        subTitle: "Alışverişe Sor, Daha Akıllıca Alışveriş Yap.",
        askAnything: "Herhangi bir şey sor…",
        slogan: "Yapay zeka alışveriş merkezi.",
      },

      loading: "Yükleniyor...",
      view_more: "daha fazla göster",

      signIn: {
        main: "Kayıt olmak",
        register: "Kayıt olmak",
        email: "E-posta",
        password: "Şifre",
        forgotPassword: "Parolanızı mı unuttunuz",
        forgotDesc:
          "E-posta adresinizi onaylayın, size bir şifre sıfırlama bağlantısı göndereceğiz.",
        phoneNumber: "Telefon numarası",
        emailPlaceholder: "Lütfen e-posta girin",
        passwordPlaceholder: "Lütfen şifrenizi girin",
        passwordInvalid: "Şifre 5-16 haneli karakterlerden oluşur",
        success: "Başarılı bir şekilde oturum açın, sayfa yenilenecek",
        resendSuccess: "Başarılı bir şekilde yeniden gönder",
        signOut: "oturumu Kapat",
        otherWays: "Veya başka yöntemlerle devam edin",
        termsTips: "Voghion'u kabul ediyorum",
        newsletterTips: "Bülten için Kaydolun",
        privacyTips:
          "Size hizmetlerimizi sunmak için gerekli olan çerezleri ve benzer teknolojileri kullanıyoruz. Daha fazla ayrıntı için, bkz.",
        terms: "Kullanım Şartları",
        and: "Ve",
        privacy: "Gizlilik ve çerez politikası",
        confirmAcceptPrivacy: "Lütfen oturum açmak için gizliliği onaylayın",
        agreeAccpetSms: "SMS almayı kabul etmeniz gerekiyor",

        sendResetEmailSuccess: {
          title: "Size bir e-posta gönderdik",

          content: `E-postayı bulamadıysanız, <br>
          • e-posta birkaç dakika gecikebilir.<br>
          • lütfen spam klasörünüzü kontrol edin.<br>
          • tıklamayı deneyin`,

          resend: "YENİDEN GÖNDER",
          back: "Oturum Açmaya Geri Dön",
        },

        registerTitle: "{platform} hesabınızı oluşturun",
        registerAutoLoginTitle:
          "E-postanız bizde kayıtlı. Lütfen Zoomies'in tüm özelliklerine erişmek için giriş yapın.",
        submitTips: "Lütfen e-postanızı ve sorunuzu girin",
      },

      common: {
        continue: "Devam etmek",
        submit: "Göndermek",
        save: "Kaydetmek",
      },

      notLogin: {
        question: "Merhaba, bir sorum var:",
        emailTip: "Bu e-posta pek doğru görünmüyor",
        pageTip:
          "Lütfen mümkünse detaylı sorularınızı metin açıklaması ve ekran görüntüleri ile birlikte sağlayın. En kısa sürede yardımcı olacağız! Ayrılırsanız, size bir yanıt e-postayla gönderilecektir.",
        or: "Veya",
        login: "giriş yapmak",
        continue: "devam etmek",
      },

      noMoreInformation: "daha fazla bilgi yok",
    },
  },
  ca: {
    message: {
      title: "Missatges",
      order: "Comandes",
      networkError: "Anormalitat de la xarxa",
      orderDesc: "Manteniu-vos actualitzat sobre l'estat de la comanda.",
      promo: "Promocions",
      promoDesc: "Els codis {count} estan disponibles",
      orderTitle: "Missatges de comanda",
      errorTitle: "Error intern del servidor",

      errorDesc:
        "El servidor ha trobat un error intern o una configuració incorrecta i no ha pogut completar la vostra sol·licitud.",

      reload: "Torna a carregar",
      noMoreGoods: "No més, feu clic a una altra pestanya i visualitzeu-ne més",
      goodsEmptyTitle: "No hi ha productes disponibles",
      goodsEmptyDesc: "Feu clic a una altra pestanya i visualitzeu-ne més",
      orderEmptyTitle: "Aquí està buit",
      orderEmptyDesc: "Mira què més t'agradaria comprar",
      viewMore: "Veure més",
      latestProgress: "Últims avenços",
      reason: "Raó",
      sold: "Vengut",
      noMore: "No més",
      loadError: "error de càrrega, feu clic per tornar-ho a provar",

      clearMessageSuccess:
        "S'han marcat tots els missatges com a llegits correctament",

      orderTime: "Hora de comanda",
      orderId: "Identificador de comanda",
      send: "Enviar",

      sentence1:
        "Inicieu sessió abans de xatejar amb el servei d'atenció al client mitjançant Zoomies.",

      networkOutage: "La xarxa està caiguda, sortiu i torneu a entrar!",
      versionTooLow: "La versió de l'aplicació és massa baixa.",
      submit: "Envia",
      inviting: "CONVIDANT",
      unpaid: "NO PAGAT",
      qualityInspection: "INSPECCIÓ DE QUALITAT",
      qualityInspectionFailed: "LA INSPECCIÓ DE QUALITAT FALLADA",
      preparingForShipment: "PREPARACIÓ PER A L'ENVIAMENT",
      approved: "APROVAT",
      closed: "TANCAT",
      shipped: "ENVIAT",
      complete: "COMPLET",
      returning: "TORNANT",
      processing: "TRAMITACIÓ",
      pending: "PENDENT",
      refunded: "REEMBOLSAT",
      refundRejected: "S'ha rebutjat la devolució",
      waitRefund: "ESPEREU LA DEVOLUCIÓ",
      cancel: "CANCEL·LA",
      received: "REBUT",
      rejected: "REBUTAT",
      end: "FINALITZACIÓ",
      refunding: "REEMBORSAMENT",
      tobeshipped: "A ENVIAR",
      login: "INICIAR SESIÓ",
      dialogtitle: "Seleccioneu el que voleu preguntar",
      Camera: "Càmera",
      Order: "Ordre",
      viewed: "Vist",
      favorites: "Preferits",
      cart: "Carro",

      pushNotifications:
        "Activa les notificacions d'actualitzacions sobre l'estat de la teva comanda més recent.",

      pushNotificationsOpen: "OBERT",
      contactServiceText: "Si no trobeu la comanda o el producte, si us plau",
      contactService: "contacta amb nosaltres",
      serverDesc: "Agent d'atenció al client de Voghion",
      serverWaitTip: "Suport a la connexió",

      serverWaitDesc:
        "Benvolgut usuari, us estem relacionant amb el servei d'atenció al client, espereu pacientment.",

      warnSpeakTitle: "Missatges del sistema",
      warnSpeakP1: "Benvinguts a Zoomies!",

      warnSpeakP2:
        "L'assetjament, el contingut explícit, la violència, els missatges provocadors i les infraccions estan estrictament prohibits al nostre xat. Les infraccions donaran lloc a accions disciplinàries immediates o altres. Gràcies per ajudar-nos a mantenir una comunitat positiva!",

      ServiceNotification: "Notificació del servei",
      VipNotification: "Notificació VIP",
      empty: "Aquí està buit",
      check_the_user_manual: "Consulteu el manual d'usuari",
      newin: "Novetats",
      uploading: "Pujada",
      uploadError: "Error de pujada",

      ai: {
        recordInvisible:
          "Ups! Sembla que la teva veu s'ha tornat invisible ~ Si us plau, acosta't al micròfon i torna-ho a intentar! 🎤🤔",

        failedResolveAudio: "No s'ha pogut resoldre l'àudio",

        serverBusy:
          "Ho sentim, el servidor està ocupat, si us plau, torna-ho a intentar més tard.",

        clearHistory: "Voleu esborrar tot l'historial de xat?",
        cancel: "Cancel·la",
        clear: "Clar",
        newTopic: "Tema nou",
        Refresh: "Actualitza",
        holdToTalk: "Espera per parlar",
        releaseToCancel: "Allibera per cancel·lar",
        swipeUpToCancel: "Llisca cap amunt per cancel·lar",
        askMTQuestion: "Fes una pregunta a MT",
        describeYourNeeds: "Descriviu les vostres necessitats",
        speakTimeTooShort: "Temps de parla massa curt",
        Camera: "Càmera",
        Photo: "Foto",
        sold: "venut",

        updateTitle:
          "Nova versió disponible! Actualitza ara per a les darreres funcions.",

        confirm: "Confirma",
        thinking: "Pensant.",
        suggestMore: "Suggereix més",
        feedbackSubmitted: "Comentaris enviats",
        serverError: "Error del servidor, torna-ho a intentar més tard",
        copied: "Copiat",
        mostPopular: "El més popular",
        TopSales: "Principals vendes",
        Price: "Preu",
        recommendation: "Recomanació",
        title: "AskShop",
        subTitle: "Pregunta a Shopping, compra de manera més intel·ligent.",
        askAnything: "Pregunta qualsevol cosa…",
        slogan: "AI shopping hub.",
      },

      loading: "Loading...",
      view_more: "view more",

      signIn: {
        main: "Inicia sessió",
        register: "Registra't",
        email: "Correu electrònic",
        password: "Contrasenya",
        forgotPassword: "He oblidat la contrasenya",
        forgotDesc:
          "Confirmeu la vostra adreça de correu electrònic i us enviarem un enllaç de restabliment de la contrasenya.",
        phoneNumber: "Número de telèfon",
        emailPlaceholder: "Introduïu el correu electrònic",
        passwordPlaceholder: "Introduïu la contrasenya",
        passwordInvalid: "La contrasenya consta de caràcters de 5 a 16 dígits",
        success: "Inicieu la sessió correctament, la pàgina s'actualitzarà",
        resendSuccess: "Tornar a enviar correctament",
        signOut: "Tanca la sessió",
        otherWays: "O continuar amb altres maneres",
        termsTips: "Accepto a Voghion",
        newsletterTips: "Subscriu-te al butlletí",
        privacyTips:
          "Utilitzem cookies i tecnologies similars que són essencials per oferir-te els nostres serveis. Per a més detalls, consulteu el nostre",
        terms: "Condicions d'ús",
        and: "i",
        privacy: "Política de privadesa i cookies",
        confirmAcceptPrivacy:
          "Si us plau, confirmeu la privadesa per iniciar la sessió",
        agreeAccpetSms: "Has d'acceptar rebre SMS",

        sendResetEmailSuccess: {
          title: "T'hem enviat un correu electrònic",

          content: `Si no has trobat el correu electrònic, <br>
          • El correu electrònic es pot retardar uns minuts.<br>
          • si us plau, comproveu la vostra carpeta de correu brossa.<br>
          • prova de fer clic`,

          resend: "REENVIAR",
          back: "Torna a Iniciar sessió",
        },

        registerTitle: "Creeu el vostre compte {platform}",
        registerAutoLoginTitle:
          "El teu correu electrònic ja està registrat amb nosaltres. Inicia sessió per accedir a totes les funcions de Zoomies.",
        submitTips:
          "Si us plau, introdueix el teu correu electrònic i la teva pregunta..",
      },

      common: {
        continue: "Continua",
        submit: "Envia",
        save: "Desa",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Or",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "no more information",
    },
  },
  ro: {
    message: {
      title: "Mesaje",
      order: "Comenzi",
      networkError: "Anormalitate de rețea",
      orderDesc: "Fiți la curent cu starea comenzii.",
      promo: "Promoții",
      promoDesc: "codurile {count} sunt disponibile",
      orderTitle: "Comanda Mesaje",
      errorTitle: "Internal Server Error",

      errorDesc:
        "Serverul a întâmpinat o eroare internă sau o configurare greșită și nu a putut finaliza solicitarea dvs.",

      reload: "Reîncărcați",
      noMoreGoods: "Nu mai mult, faceți clic pe altă filă și vedeți mai multe",
      goodsEmptyTitle: "Nu există mărfuri disponibile",
      goodsEmptyDesc: "Faceți clic pe altă filă și vedeți mai multe",
      orderEmptyTitle: "Aici este gol",
      orderEmptyDesc: "Vezi ce altceva ai vrea să cumperi",
      viewMore: "Vezi mai multe",
      latestProgress: "Ultimul progres",
      reason: "Motiv",
      sold: "Vândut",
      noMore: "Nu mai mult",
      loadError: "eroare de încărcare, faceți clic pentru a reîncerca",
      clearMessageSuccess: "Toate mesajele au marcat ca citite cu succes",
      orderTime: "Ora Comenzii",
      orderId: "ID comandă",
      send: "Trimite",

      sentence1:
        "Vă rugăm să vă conectați înainte de a discuta cu serviciul pentru clienți folosind Zoomies.",

      networkOutage:
        "Rețeaua este oprită, vă rugăm să ieșiți și să intrați din nou!",

      versionTooLow: "Versiunea aplicației este prea scăzută.",
      submit: "Trimiteți",
      inviting: "INVITARE",
      unpaid: "NEPLĂTITĂ",
      qualityInspection: "INSPECȚIA DE CALITATE",
      qualityInspectionFailed: "INSPECȚIA DE CALITATE A ESCUT",
      preparingForShipment: "PREGĂTIREA PENTRU EXPEDIERE",
      approved: "APROBAT",
      closed: "ÎNCHIS",
      shipped: "EXPEDIAT",
      complete: "COMPLET",
      returning: "REVENIRE",
      processing: "PRELUCRARE",
      pending: "ÎN AȘTEPTARE",
      refunded: "RAmbursat",
      refundRejected: "RESTAURARE RESPINSĂ",
      waitRefund: "Așteptați rambursarea",
      cancel: "ANULA",
      received: "PRIMIT",
      rejected: "RESPINS",
      end: "Sfârşit",
      refunding: "RAmbursare",
      tobeshipped: "A FI EXPEDIAT",
      login: "LOG IN",
      dialogtitle: "Vă rugăm să selectați ceea ce doriți să întrebați",
      Camera: "Camera foto",
      Order: "Comanda",
      viewed: "Vizualizat",
      favorites: "Favorite",
      cart: "Cart",

      pushNotifications:
        "Activați notificările pentru actualizări privind starea celei mai recente comenzi.",

      pushNotificationsOpen: "DESCHIDE",
      contactServiceText: "Dacă nu găsiți comanda sau produsul, vă rugăm",
      contactService: "contactaţi-ne",
      serverDesc: "Agent Serviciu Clienți Voghion",
      serverWaitTip: "Suport Conectare",

      serverWaitDesc:
        "Stimate utilizator, vă oferim servicii pentru clienți, vă rugăm să așteptați cu răbdare.",

      warnSpeakTitle: "Mesaje de sistem",
      warnSpeakP1: "Bun venit la Zoomies!",

      warnSpeakP2:
        "Hărțuirea, conținutul explicit, violența, mesajele provocatoare și încălcarea drepturilor de autor sunt strict interzise în chat-ul nostru. Încălcările vor avea ca rezultat mutarea imediată sau alte acțiuni disciplinare. Vă mulțumim că ne ajutați să menținem o comunitate pozitivă!",

      ServiceNotification: "Notificare de service",
      VipNotification: "Notificare VIP",
      empty: "Aici este gol",
      check_the_user_manual: "Verificați manualul de utilizare",
      newin: "Nou în",
      uploading: "Încărcare",
      uploadError: "Eroare de încărcare",

      ai: {
        recordInvisible:
          "Oops! Se pare că vocea ta a devenit invizibilă ~ Te rog apropie-te de microfon și încearcă din nou! 🎤🤔",

        failedResolveAudio: "Nu s-a putut rezolva sunetul",

        serverBusy:
          "Ne pare rău, serverul este ocupat, vă rugăm să încercați din nou mai târziu.",

        clearHistory: "Ștergeți tot istoricul conversațiilor?",
        cancel: "Anula",
        clear: "Clar",
        newTopic: "Subiect nou",
        Refresh: "Reîmprospăta",
        holdToTalk: "Apăsați pentru a vorbi",
        releaseToCancel: "Eliberați pentru a anula",
        swipeUpToCancel: "Glisează în sus pentru a anula",
        askMTQuestion: "Pune o întrebare lui MT",
        describeYourNeeds: "Descrieți nevoile dumneavoastră",
        speakTimeTooShort: "Timpul de vorbire este prea scurt",
        Camera: "Camera foto",
        Photo: "Fotografie",
        sold: "vândut",

        updateTitle:
          "Versiune nouă disponibilă! Actualizați acum pentru cele mai recente funcții.",

        confirm: "Confirma",
        thinking: "Gândire.",
        suggestMore: "Sugerează mai multe",
        feedbackSubmitted: "Feedback trimis",
        serverError: "Eroare server, încercați din nou mai târziu",
        copied: "Copiat",
        mostPopular: "Cele mai populare",
        TopSales: "Topul vânzărilor",
        Price: "Preţ",
        recommendation: "Recomandare",
        title: "AskShop",
        subTitle: "Întreabă la cumpărături, cumpără mai inteligent.",
        askAnything: "Întreabă orice…",
        slogan: "AI shopping hub.",
      },

      loading: "Loading...",
      view_more: "view more",

      signIn: {
        main: "Conectare",
        register: "Registru",
        email: "E-mail",
        password: "Parolă",
        forgotPassword: "Aţi uitat parola",
        forgotDesc:
          "Confirmați-vă adresa de e-mail și vă vom trimite un link de resetare a parolei.",
        phoneNumber: "Număr de telefon",
        emailPlaceholder: "Vă rugăm să introduceți adresa de e-mail",
        passwordPlaceholder: "Vă rugăm să introduceți parola",
        passwordInvalid: "Parola este formată din caractere din 5-16 cifre",
        success: "Conectare cu succes, pagina va fi reîmprospătată",
        resendSuccess: "Retrimiteți cu succes",
        signOut: "Sign out",
        otherWays: "Sau continua cu alte moduri",
        termsTips: "Accept la Voghion",
        newsletterTips: "Înscrieți-vă pentru Newsletter",
        privacyTips:
          "Folosim cookie-uri și tehnologii similare care sunt esențiale pentru a vă oferi serviciile noastre. Pentru mai multe detalii, consultați",
        terms: "Termeni de utilizare",
        and: "şi",
        privacy: "Politica de confidențialitate și cookie-uri",
        confirmAcceptPrivacy:
          "Vă rugăm să confirmați confidențialitatea pentru conectare",
        agreeAccpetSms: "Trebuie să fiți de acord să primiți SMS-uri",

        sendResetEmailSuccess: {
          title: "V-am trimis un e-mail",

          content: `Dacă nu ați găsit e-mail, <br>
          • e-mailul poate fi întârziat cu câteva minute.<br>
          • vă rugăm să verificați dosarul de spam.<br>
          • încercați să faceți clic`,

          resend: "RETRIMITERE",
          back: "Înapoi la Conectare",
        },

        registerTitle: "Creați-vă contul {platform}",
        registerAutoLoginTitle:
          "Adresa ta de e-mail este deja înregistrată. Te rugăm să te conectezi pentru a accesa toate funcționalitățile Zoomies.",
        submitTips: "Te rugăm să introduci adresa ta de e-mail și întrebarea.",
      },

      common: {
        continue: "Continua",
        submit: "Trimiteți",
        save: "Salva",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Sau",
        login: "log in",
        continue: "to continue",
      },

      noMoreInformation: "no more information",
    },
  },
  bg: {
    message: {
      title: "Съобщения",
      order: "Поръчки",
      networkError: "Аномалия в мрежата",
      orderDesc: "Бъдете в течение за състоянието на поръчката.",
      promo: "Промоции",
      promoDesc: "Налични са {count} кодове",
      orderTitle: "Съобщения за поръчки",
      errorTitle: "Вътрешна грешка на сървъра",

      errorDesc:
        "Сървърът се натъкна на вътрешна грешка или неправилна конфигурация и не успя да изпълни вашата заявка.",

      reload: "Презареди",
      noMoreGoods: "Няма повече, щракнете върху друг раздел и вижте повече",
      goodsEmptyTitle: "Няма налични стоки",
      goodsEmptyDesc: "Щракнете върху друг раздел и вижте още",
      orderEmptyTitle: "Тук е празно",
      orderEmptyDesc: "Вижте какво друго искате да купите",
      viewMore: "Вижте повече",
      latestProgress: "Последен напредък",
      reason: "Причина",
      sold: "Продаден",
      noMore: "Не повече",
      loadError: "грешка при зареждане, щракнете за нов опит",
      clearMessageSuccess: "Маркирани всички съобщения като успешно прочетени",
      orderTime: "Време за поръчка",
      orderId: "ID на поръчката",
      send: "Изпратете",

      sentence1:
        "Моля, влезте, преди да разговаряте с отдела за обслужване на клиенти с помощта на Zoomies.",

      networkOutage: "Мрежата не работи, моля излезте и влезте отново!",
      versionTooLow: "Версията на приложението е твърде ниска.",
      submit: "Изпратете",
      inviting: "ПОКАНИ",
      unpaid: "НЕПЛАТЕНО",
      qualityInspection: "ПРОВЕРКА НА КАЧЕСТВОТО",
      qualityInspectionFailed: "ПРОВЕРКАТА НА КАЧЕСТВОТО Е НЕУСПЕШНА",
      preparingForShipment: "ПОДГОТОВКА ЗА ИЗПРАЩАНЕ",
      approved: "ОДОБРЕНО",
      closed: "ЗАТВОРЕНО",
      shipped: "ИЗПРАТЕНО",
      complete: "ЗАВЪРШЕН",
      returning: "ВРЪЩАНЕ",
      processing: "ОБРАБОТКА",
      pending: "В ИЗЧАКВАНЕ",
      refunded: "ВЪЗСТАНОВЕНО",
      refundRejected: "ОТХВЪРЛЕНО ВЪЗСТАНОВЯВАНЕ",
      waitRefund: "ИЗЧАКАЙТЕ ВЪЗСТАНОВЯВАНЕ",
      cancel: "ОТМЕНЯНЕ",
      received: "ПОЛУЧЕНО",
      rejected: "ОТХВЪРЛЕНО",
      end: "КРАЙ",
      refunding: "ВЪЗСТАНОВЯВАНЕ НА СУМА",
      tobeshipped: "ДА СЕ ИЗПРАТИ",
      login: "ВЛЕЗТЕ",
      dialogtitle: "Моля, изберете какво искате да попитате",
      Camera: "Камера",
      Order: "ред",
      viewed: "Разгледано",
      favorites: "Любими",
      cart: "Количка",

      pushNotifications:
        "Включете известията за актуализации относно последния статус на вашата поръчка.",

      pushNotificationsOpen: "ОТВОРЕНО",
      contactServiceText: "Ако не можете да намерите поръчка или продукт, моля",
      contactService: "свържете се с нас",
      serverDesc: "Агент за обслужване на клиенти на Voghion",
      serverWaitTip: "Поддръжка за свързване",

      serverWaitDesc:
        "Уважаеми потребителю, свързваме ви с отдела за обслужване на клиенти, моля, изчакайте търпеливо.",

      warnSpeakTitle: "Системни съобщения",
      warnSpeakP1: "Добре дошли в Zoomies!",

      warnSpeakP2:
        "Тормозът, изричното съдържание, насилието, провокативните съобщения и нарушенията са строго забранени в нашия чат. Нарушенията ще доведат до незабавно заглушаване или други дисциплинарни действия. Благодарим ви, че ни помагате да поддържаме положителна общност!",

      ServiceNotification: "Сервизно известие",
      VipNotification: "Vip известие",
      empty: "Тук е празно",
      check_the_user_manual: "Проверете ръководството за потребителя",
      newin: "Ново в",
      uploading: "Качване",
      uploadError: "Грешка при качване",

      ai: {
        entrySubTitle:
          "Нуждаете се от помощ при вземането на решение? Попитайте MT",

        title: "Чат с изкуствен интелект",
        subTitle: "Изкуствен интелект, който пазарува с вас.",

        recordInvisible:
          "Опа! Гласът ти сякаш е станал невидим ~ Моля, приближи се до микрофона и опитай отново! 🎤🤔",

        failedResolveAudio: "Неуспешно разрешаване на аудио",

        serverBusy:
          "За съжаление, сървърът е зает, моля опитайте отново по-късно.",

        clearHistory: "Да се ​​изчисти ли цялата история на чата?",
        cancel: "Отказ",
        clear: "Изчисти",
        newTopic: "Нова тема",
        Refresh: "Опресняване",
        holdToTalk: "Задръжте, за да говорите",
        releaseToCancel: "Освободете, за да отмените",
        swipeUpToCancel: "Плъзнете нагоре, за да отмените",
        askMTQuestion: "Задайте въпрос на МТ",
        describeYourNeeds: "Опишете вашите нужди",
        speakTimeTooShort: "Времето за говорене е твърде кратко",
        Camera: "Камера",
        Photo: "Снимка",
        sold: "продаден",

        updateTitle:
          "Налична е нова версия! Актуализирайте сега за най-новите функции.",

        confirm: "Потвърди",
        thinking: "Мислене.",
        suggestMore: "Предложете още",
        feedbackSubmitted: "Изпратена обратна връзка",
        serverError: "Грешка на сървъра, опитайте отново по-късно",
        copied: "Копирано",
        mostPopular: "Най-популярни",
        TopSales: "Най-продавани",
        Price: "Цена",
        recommendation: "Препоръка",
        askAnything: "Питай каквото и да е…",
        slogan: "AI shopping hub.",
      },

      loading: "Loading...",
      view_more: "view more",

      signIn: {
        main: "влезте",
        register: "Регистрирайте се",
        email: "Имейл",
        password: "Парола",
        forgotPassword: "Забравена парола",
        forgotDesc:
          "Потвърдете своя имейл адрес и ние ще изпратим връзка за повторно задаване на парола.",
        phoneNumber: "Телефонен номер",
        emailPlaceholder: "Моля, въведете имейл",
        passwordPlaceholder: "Моля, въведете парола",
        passwordInvalid: "Паролата се състои от 5-16 цифри",
        success: "Успешно влизане, страницата ще бъде обновена",
        resendSuccess: "Повторното изпращане успешно",
        signOut: "Излезте",
        otherWays: "Или продължете по други начини",
        termsTips: "Приемам на Voghion",
        newsletterTips: "Запишете се за бюлетин",
        privacyTips:
          "Ние използваме бисквитки и подобни технологии, които са от съществено значение, за да ви предоставим нашите услуги. За повече подробности вижте нашия",
        terms: "Условия за ползване",
        and: "и",
        privacy: "Политика за поверителност и бисквитки",
        confirmAcceptPrivacy: "Моля, потвърдете поверителността за влизане",
        agreeAccpetSms: "Трябва да се съгласите да получавате SMS",

        sendResetEmailSuccess: {
          title: "Изпратихме ви имейл",

          content: `Ако не сте намерили имейл, <br>
          • имейлът може да се забави с няколко минути.<br>
          • моля, проверете папката си със спам.<br>
          • опитайте да щракнете`,

          resend: "ПОВТОРНО ИЗПРАЩАНЕ",
          back: "Назад към вход",
        },

        registerTitle: "Създайте своя {platform} акаунт",
        registerAutoLoginTitle:
          "Вашият имейл вече е регистриран при нас. Моля, влезте в профила си, за да получите достъп до всички функции на Zoomies.",
        submitTips: "Моля, въведете своя имейл и въпроса си.",
      },

      common: {
        continue: "Продължи",
        submit: "Изпратете",
        save: "Запазване",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Or",
        login: "log in",
        continue: "to continue",
      },
      noMoreInformation: "no more information",
    },
  },
  hu: {
    message: {
      title: "Üzenetek",
      order: "Megrendelések",
      networkError: "Hálózati rendellenesség",
      orderDesc: "Legyen naprakész a rendelés állapotáról.",
      promo: "Promóciók",
      promoDesc: "{count} kódok állnak rendelkezésre",
      orderTitle: "Üzenetek rendelése",
      errorTitle: "Belső szerverhiba",

      errorDesc:
        "A szerver belső hibát vagy hibás konfigurációt észlelt, és nem tudta teljesíteni a kérést.",

      reload: "Újratöltés",

      noMoreGoods:
        "Nincs több, kattintson egy másik lapra, és tekintsen meg többet",

      goodsEmptyTitle: "Nincs áru",

      goodsEmptyDesc:
        "Kattintson egy másik fülre, és tekintse meg a továbbiakat",

      orderEmptyTitle: "Itt üres",
      orderEmptyDesc: "Nézze meg, mit szeretne még vásárolni",
      viewMore: "Továbbiak megtekintése",
      latestProgress: "Legújabb fejlemények",
      reason: "Ok",
      sold: "Eladott",
      noMore: "Nincs több",
      loadError: "betöltési hiba, kattintson az újrapróbálkozáshoz",
      clearMessageSuccess: "Az összes üzenetet sikeresnek jelölte olvasottként",
      orderTime: "Rendelési idő",
      orderId: "Rendelési azonosító",
      send: "Elküld",

      sentence1:
        "Kérjük, jelentkezzen be, mielőtt csevegne az ügyfélszolgálattal a Zoomies használatával.",

      networkOutage: "A hálózat nem működik, lépjen ki, és lépjen be újra!",
      versionTooLow: "Az alkalmazás verziója túl alacsony.",
      submit: "Beküld",
      inviting: "HÍVOGATÓ",
      unpaid: "KIFIZETETLEN",
      qualityInspection: "MINŐSÉG ELLENŐRZÉS",
      qualityInspectionFailed: "A MINŐSÉGELLENŐRZÉS SIKERTELEN",
      preparingForShipment: "SZÁLLÍTÁSRA ELŐKÉSZÜLÉS",
      approved: "JÓVÁHAGYOTT",
      closed: "ZÁRT",
      shipped: "SZÁLLÍTVA",
      complete: "TELJES",
      returning: "VISSZATÉRÉS",
      processing: "FELDOLGOZÁS",
      pending: "FÜGGŐBEN LEVŐ",
      refunded: "VISSZATÉRÍTETT",
      refundRejected: "VISSZATÉRÍTÉS ELUTASÍTVA",
      waitRefund: "VÁRJ VISSZAFIZETÉST",
      cancel: "MÉGSEM",
      received: "FOGADVA",
      rejected: "ELUTASÍTVA",
      end: "VÉGE",
      refunding: "VISSZATÉRÍTÉS",
      tobeshipped: "SZÁLLÍTANDÓ",
      login: "BEJELENTKEZÉS",
      dialogtitle: "Kérjük, válassza ki, mit szeretne kérdezni",
      Camera: "Kamera",
      Order: "Rendelés",
      viewed: "Megtekintve",
      favorites: "Kedvencek",
      cart: "Kosár",

      pushNotifications:
        "Kapcsolja be az értesítéseket a legutóbbi rendelés állapotával kapcsolatos frissítésekről.",

      pushNotificationsOpen: "NYITOTT",
      contactServiceText: "Ha nem talál rendelést vagy terméket, kérem",
      contactService: "lépjen kapcsolatba velünk",
      serverDesc: "Voghion ügyfélszolgálati ügynök",
      serverWaitTip: "Csatlakozás támogatása",

      serverWaitDesc:
        "Kedves felhasználó! Az ügyfélszolgálattal egyeztetjük Önt, kérjük, várjon türelmesen.",

      warnSpeakTitle: "Rendszerüzenetek",
      warnSpeakP1: "Üdvözöljük a Zoomies oldalán!",

      warnSpeakP2:
        "A zaklatás, a nyílt tartalom, az erőszak, a provokatív üzenetek és a jogsértés szigorúan tilos csevegésünkben. A szabálysértések azonnali elnémítást vagy egyéb fegyelmi eljárást vonnak maguk után. Köszönjük, hogy hozzájárult a pozitív közösség fenntartásához!",

      ServiceNotification: "Szolgáltatási értesítés",
      VipNotification: "VIP értesítés",
      empty: "Itt üres",
      check_the_user_manual: "Ellenőrizze a felhasználói kézikönyvet",
      newin: "Újdonságok",
      uploading: "Feltöltés folyamatban",
      uploadError: "Feltöltési hiba",

      ai: {
        recordInvisible:
          "Hoppá! Úgy tűnik, a hangod láthatatlanná vált ~ Kérlek, menj közelebb a mikrofonhoz, és próbáld újra! 🎤🤔",

        failedResolveAudio: "Nem sikerült feloldani a hangot",

        serverBusy:
          "Sajnáljuk, a szerver foglalt, kérjük, próbálja meg később.",

        clearHistory: "Törli az összes csevegési előzményt?",
        cancel: "Mégse",
        clear: "Világos",
        newTopic: "Új téma",
        Refresh: "Frissítés",
        holdToTalk: "Tartsa lenyomva a beszélgetéshez",
        releaseToCancel: "Engedje el a megszakításhoz",
        swipeUpToCancel: "Húzza felfelé a megszakításhoz",
        askMTQuestion: "Tegyen fel kérdést MT-nek",
        describeYourNeeds: "Írd le az igényeidet",
        speakTimeTooShort: "Túl rövid a beszédidő",
        Camera: "Kamera",
        Photo: "Fénykép",
        sold: "eladott",

        updateTitle:
          "Új verzió elérhető! Frissítsen most a legújabb funkciókért.",

        confirm: "Megerősítés",
        thinking: "Gondolkodás.",
        suggestMore: "További javaslatok",
        feedbackSubmitted: "Visszajelzés elküldve",
        serverError: "Szerverhiba, próbáld újra később",
        copied: "Másolva",
        mostPopular: "Legnépszerűbb",
        TopSales: "Legnépszerűbb",
        Price: "Ár",
        recommendation: "Ajánlás",
        title: "AskShop",
        subTitle: "Kérdezd a vásárlást, vásárolj okosabban.",
        askAnything: "Kérdezz bármit…",
        slogan: "AI shopping hub.",
      },

      loading: "Loading...",
      view_more: "view more",

      signIn: {
        main: "Jelentkezzen be",
        register: "Nyilvántartás",
        email: "Email",
        password: "Jelszó",
        forgotPassword: "Elfelejtett jelszó",
        forgotDesc:
          "Erősítse meg e-mail címét, és küldünk egy jelszó-visszaállító linket.",
        phoneNumber: "Telefonszám",
        emailPlaceholder: "Kérjük, adja meg az e-mail címet",
        passwordPlaceholder: "Kérjük, adja meg a jelszót",
        passwordInvalid: "A jelszó 5-16 számjegyből áll",
        success: "Sikeres bejelentkezés, az oldal frissül",
        resendSuccess: "Sikeres újraküldés",
        signOut: "Jelentkezzen ki",
        otherWays: "Vagy folytassa más módszerekkel",
        termsTips: "Elfogadom Voghionba",
        newsletterTips: "Iratkozzon fel Hírlevélre",
        privacyTips:
          "Cookie-kat és hasonló technológiákat használunk, amelyek elengedhetetlenek szolgáltatásaink biztosításához. További részletekért tekintse meg a mi",
        terms: "Felhasználási feltételek",
        and: "és",
        privacy: "Adatvédelmi és süti szabályzat",
        confirmAcceptPrivacy:
          "Kérjük, erősítse meg az adatvédelmet a bejelentkezéshez",
        agreeAccpetSms: "El kell fogadnia az SMS fogadását",

        sendResetEmailSuccess: {
          title: "Küldtünk egy e-mailt",

          content: `Ha nem talált e-mailt, <br>
          • az e-mailek néhány percet késhetnek.<br>
          • Kérjük, ellenőrizze a spam mappát.<br>
          • próbáljon meg kattintani`,

          resend: "ÚJRAKÜLDÉS",
          back: "Vissza a Bejelentkezéshez",
        },

        registerTitle: "Hozza létre {platform} fiókját",
        registerAutoLoginTitle:
          "Az e-mail címed már regisztrálva van nálunk. Kérjük, jelentkezz be, hogy elérhesd a Zoomies összes funkcióját.",
        submitTips: "Kérjük, adja meg az e-mail-címét és a kérdését.",
      },

      common: {
        continue: "Folytatás",
        submit: "Beküld",
        save: "Megtakarítás",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Vagy",
        login: "log in",
        continue: "to continue",
      },
      noMoreInformation: "no more information",
    },
  },
  lb: {
    message: {
      title: "Messagen",
      order: "Bestellungen",
      networkError: "Netz Anomalie",
      orderDesc: "Bleift um Bestellungsstatus aktualiséiert.",
      promo: "Promotiounen",
      promoDesc: "{count} Coden sinn verfügbar",
      orderTitle: "Uerdnung Messagen",
      errorTitle: "Interne Server Feeler",

      errorDesc:
        "De Server huet en interne Feeler oder Mësskonfiguratioun begéint a konnt Är Ufro net fäerdeg maachen.",

      reload: "Reload",
      noMoreGoods: "Net méi, klickt op eng aner Tab a kuckt méi",
      goodsEmptyTitle: "Keng Wueren verfügbar",
      goodsEmptyDesc: "Klickt op eng aner Tab a kuckt méi",
      orderEmptyTitle: "Hei ass eidel",
      orderEmptyDesc: "Gesinn wat soss Dir wëllt kafen",
      viewMore: "Kuckt méi",
      latestProgress: "Läscht Fortschrëtter",
      reason: "Grond",
      sold: "Verkaaft",
      noMore: "Net méi",
      loadError: "lued Feeler, klickt fir erëm ze probéieren",
      clearMessageSuccess: "Markéiert all Messagen als erfollegräich gelies",
      orderTime: "Uerdnung Zäit",
      orderId: "Bestellung ID",
      send: "Schécken",

      sentence1:
        "Mellt Iech w.e.g. un ier Dir mam Clientsservice mam Zoomies chatt.",

      networkOutage:
        "D'Netzwierk ass erof, gitt w.e.g. eraus a gitt erëm eran!",

      versionTooLow: "D'App Versioun ass ze niddreg.",
      submit: "Ofginn",
      inviting: "INVITÉIERT",
      unpaid: "ONBETALT",
      qualityInspection: "QUALITÉIT INSPEKTION",
      qualityInspectionFailed: "QUALITÉIT INSPEKTION FEILECH",
      preparingForShipment: "Virbereedung FIR SHIPMENT",
      approved: "GEWËSCHT",
      closed: "GESLOTEN",
      shipped: "GESCHICHT",
      complete: "KOMPLETT",
      returning: "RETURNÉIEREN",
      processing: "VERWERKING",
      pending: "PENDING",
      refunded: "REFUNDERT",
      refundRejected: "REFUND VERWEISEN",
      waitRefund: "WAIT REFUND",
      cancel: "ANNULÉIEREN",
      received: "KREEFT",
      rejected: "REJECTERT",
      end: "END",
      refunding: "REFUNDERING",
      tobeshipped: "BIS VERSCHÉCKT",
      login: "Aloggen",
      dialogtitle: "Wielt w.e.g. wat Dir wëllt froen",
      Camera: "Kamera",
      Order: "Uerdnung",
      viewed: "Gekuckt",
      favorites: "Favoritten",
      cart: "Weenchen",

      pushNotifications:
        "Aktivéiert Notifikatiounen fir Aktualiséierungen op Äre leschten Bestellungsstatus.",

      pushNotificationsOpen: "OPEN",
      contactServiceText: "Wann Dir keng Bestellung oder Produkt fannt, w.e.g",
      contactService: "kontaktéiert eis",
      serverDesc: "Voghion Client Service Agent",
      serverWaitTip: "Ënnerstëtzung Verbindung",

      serverWaitDesc:
        "Léif Benotzer, mir passen Iech mam Clientsservice, waart w.e.g. geduldig.",

      warnSpeakTitle: "System Messagen",
      warnSpeakP1: "Wëllkomm zu Zoomies!",

      warnSpeakP2:
        "Belästegung, explizit Inhalt, Gewalt, provokativ Messagen, a Verstouss sinn streng an eisem Chat verbueden. Violatioune féieren zu direkten Mute oder aner Disziplinaraktiounen. Merci datt Dir eis hëlleft eng positiv Gemeinschaft ze halen!",

      ServiceNotification: "Service Notifikatioun",
      VipNotification: "Vip Notifikatioun",
      empty: "Hei ass eidel",
      check_the_user_manual: "Kuckt d'Benotzerhandbuch",
      newin: "Nei eran",
      uploading: "Eroplueden",
      uploadError: "Eropluedungsfehler",

      ai: {
        recordInvisible:
          "Oops! Deng Stëmm schéngt onsichtbar gi ze sinn ~ Gitt w.e.g. méi no beim Mikrofon a probéiert et nach eng Kéier! 🎤🤔",

        failedResolveAudio: "Konnt den Audio net opléisen",

        serverBusy:
          "Entschëllegt, de Server ass beschäftegt, probéiert et w.e.g. méi spéit nach eng Kéier.",

        clearHistory: "De ganze Chat-Verlaf läschen?",
        cancel: "Ofbriechen",
        clear: "Kloer",
        newTopic: "Neit Thema",
        Refresh: "Erfrëschen",
        holdToTalk: "Halt un fir ze schwätzen",
        releaseToCancel: "Fräiloossen fir ze annuléieren",
        swipeUpToCancel: "Swipe no uewen fir ze annuléieren",
        askMTQuestion: "Stellt eng Fro un den MT",
        describeYourNeeds: "Beschreift Är Besoinen",
        speakTimeTooShort: "Riedzäit ze kuerz",
        Camera: "Kamera",
        Photo: "Foto",
        sold: "verkaf",

        updateTitle:
          "Nei Versioun verfügbar! Aktualiséiert elo fir déi lescht Funktiounen.",

        confirm: "Bestätegen",
        thinking: "Denken.",
        suggestMore: "Méi proposéieren",
        feedbackSubmitted: "Feedback geschéckt",
        serverError: "Serverfehler, probéiert et méi spéit nach eng Kéier",
        copied: "Kopéiert",
        mostPopular: "Am populärsten",
        TopSales: "Top Verkaf",
        Price: "Präis",
        recommendation: "Empfehlung",
        title: "AskShop",
        subTitle: "Frot Akafen, kaaft méi intelligent.",
        askAnything: "Frot iergend eppes…",
        slogan: "AI shopping hub.",
      },

      loading: "Loading...",
      view_more: "view more",

      signIn: {
        main: "Zeechen an",
        register: "Aschreiwen",
        email: "E-Mail",
        password: "Passwuert",
        forgotPassword: "Passwuert vergiess",
        forgotDesc:
          "Confirméiert Är E-Mailadress a mir schécken e Passwuert zréckgesat Link.",
        phoneNumber: "Telefonsnummer",
        emailPlaceholder: "Gitt w.e.g. E-Mail un",
        passwordPlaceholder: "Gitt weg Passwuert un",
        passwordInvalid: "D'Passwuert besteet aus 5-16 Zifferen",
        success: "Umellen erfollegräich, Säit gëtt erfrëscht",
        resendSuccess: "Neischécken erfollegräich",
        signOut: "Zeechen aus",
        otherWays: "Oder weider mat anere Weeër",
        termsTips: "Ech akzeptéieren Voghion",
        newsletterTips: "Zeechen fir Newsletter",
        privacyTips:
          "Mir benotze Cookien an ähnlech Technologien déi wesentlech sinn fir Iech eis Servicer ze bidden. Fir méi Detailer, kuckt eis",
        terms: "Benotzungsconditiounen",
        and: "an",
        privacy: "Privatsphär & Cookie Politik",
        confirmAcceptPrivacy:
          "Confirméiert w.e.g. Privatsphär fir Iech umellen",
        agreeAccpetSms: "Dir musst averstanen SMS ze kréien",

        sendResetEmailSuccess: {
          title: "Mir hunn Iech eng E-Mail geschéckt",

          content: `Wann Dir keng E-Mail fonnt hutt, <br>
          • E-Mail kann e puer Minutten verspéit ginn.<br>
          • kuckt w.e.g. Äre Spam Dossier.<br>
          • probéieren ze klickt`,

          resend: "RESEND",
          back: "Zréck op Umellen",
        },

        registerTitle: "Erstellt Äre {platform} Kont",
        registerAutoLoginTitle:
          "Deng E-Mail-Adress ass schonn bei eis registréiert. Logg dech w.e.g. an, fir all d'Funktiounen vu Zoomies kënnen ze benotzen.",
        submitTips: "Gëff w.e.g. deng E-Mail-Adress an deng Fro un.",
      },

      common: {
        continue: "Fuert weider",
        submit: "Ofginn",
        save: "Spueren",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Oder",
        login: "log in",
        continue: "to continue",
      },
      noMoreInformation: "no more information",
    },
  },
  cs: {
    message: {
      title: "Zprávy",
      order: "Objednávky",
      networkError: "Abnormalita sítě",
      orderDesc: "Sledujte aktuální stav objednávky.",
      promo: "Propagační akce",
      promoDesc: "K dispozici jsou kódy {count}",
      orderTitle: "Objednat zprávy",
      errorTitle: "Interní chyba serveru",

      errorDesc:
        "Server zaznamenal vnitřní chybu nebo nesprávnou konfiguraci a nemohl dokončit váš požadavek.",

      reload: "Znovu načíst",
      noMoreGoods: "Už nic, klikněte na jinou kartu a zobrazte další",
      goodsEmptyTitle: "Žádné zboží není k dispozici",
      goodsEmptyDesc: "Klikněte na jinou kartu a zobrazte další",
      orderEmptyTitle: "Tady je prázdno",
      orderEmptyDesc: "Podívejte se, co byste ještě chtěli koupit",
      viewMore: "Zobrazit více",
      latestProgress: "Nejnovější pokrok",
      reason: "Důvod",
      sold: "Prodáno",
      noMore: "Už ne",
      loadError: "chyba načítání, kliknutím to zkuste znovu",
      clearMessageSuccess: "Všechny zprávy byly označeny jako úspěšně přečtené",
      orderTime: "Čas objednávky",
      orderId: "ID objednávky",
      send: "Poslat",

      sentence1:
        "Před chatováním se zákaznickým servisem pomocí Zoomies se prosím přihlaste.",

      networkOutage: "Síť nefunguje, opusťte prosím a znovu se přihlaste!",
      versionTooLow: "Verze aplikace je příliš nízká.",
      submit: "Předložit",
      inviting: "POZVÁNÍ",
      unpaid: "NEZAPLACENO",
      qualityInspection: "KONTROLA KVALITY",
      qualityInspectionFailed: "KONTROLA KVALITY SE NEDALA",
      preparingForShipment: "PŘÍPRAVA K ZÁSILCE",
      approved: "SCHVÁLENÝ",
      closed: "ZAVŘENO",
      shipped: "POSLANO",
      complete: "KOMPLETNÍ",
      returning: "VRÁCENÍ SE",
      processing: "ZPRACOVÁNÍ",
      pending: "ČEKÁ",
      refunded: "VRÁCENO",
      refundRejected: "VRÁCENÍ PLATBY ZAMÍTNUTO",
      waitRefund: "ČEKEJTE NA VRÁCENÍ PENĚZ",
      cancel: "ZRUŠIT",
      received: "PŘIJATO",
      rejected: "ODMÍTNUTO",
      end: "KONEC",
      refunding: "VRÁCENÍ PENĚZ",
      tobeshipped: "K ODESLÁNÍ",
      login: "PŘIHLÁSIT SE",
      dialogtitle: "Vyberte, na co se chcete zeptat",
      Camera: "Fotoaparát",
      Order: "Objednávka",
      viewed: "Zobrazeno",
      favorites: "Oblíbené",
      cart: "Vozík",

      pushNotifications:
        "Zapněte upozornění na aktualizace o nejnovějším stavu vaší objednávky.",

      pushNotificationsOpen: "OTEVŘENO",

      contactServiceText:
        "Pokud nemůžete najít objednávku nebo produkt, prosím",

      contactService: "kontaktujte nás",
      serverDesc: "Zástupce zákaznického servisu Voghion",
      serverWaitTip: "Podpora připojení",

      serverWaitDesc:
        "Vážený uživateli, přizpůsobujeme vám zákaznický servis, trpělivě vyčkejte.",

      warnSpeakTitle: "Systémové zprávy",
      warnSpeakP1: "Vítejte v Zoomies!",

      warnSpeakP2:
        "Obtěžování, explicitní obsah, násilí, provokativní zprávy a porušování práv jsou v našem chatu přísně zakázány. Porušení bude mít za následek okamžité ztlumení nebo jiná disciplinární opatření. Děkujeme, že nám pomáháte udržovat pozitivní komunitu!",

      ServiceNotification: "Oznámení služby",
      VipNotification: "VIP oznámení",
      empty: "Tady je prázdno",
      check_the_user_manual: "Zkontrolujte uživatelskou příručku",
      newin: "Nové v",
      uploading: "Nahrávání",
      uploadError: "Chyba nahrávání",

      ai: {
        recordInvisible:
          "Jejda! Zdá se, že tvůj hlas se stal neviditelným ~ Prosím, přibliž se k mikrofonu a zkus to znovu! 🎤🤔",

        failedResolveAudio: "Nepodařilo se vyřešit zvuk",

        serverBusy:
          "Omlouváme se, server je zaneprázdněný, zkuste to prosím znovu později.",

        clearHistory: "Vymazat veškerou historii chatu?",
        cancel: "Zrušit",
        clear: "Jasný",
        newTopic: "Nové téma",
        Refresh: "Obnovit",
        holdToTalk: "Podržení pro hovor",
        releaseToCancel: "Uvolněte pro zrušení",
        swipeUpToCancel: "Přejetím prstem nahoru zrušíte",
        askMTQuestion: "Položte MT otázku",
        describeYourNeeds: "Popište své potřeby",
        speakTimeTooShort: "Příliš krátká doba promluvy",
        Camera: "Fotoaparát",
        Photo: "Fotografie",
        sold: "prodáno",

        updateTitle:
          "Nová verze k dispozici! Aktualizujte nyní a získejte nejnovější funkce.",

        confirm: "Potvrdit",
        thinking: "Myslící.",
        suggestMore: "Navrhnout více",
        feedbackSubmitted: "Zpětná vazba odeslána",
        serverError: "Chyba serveru, zkuste to znovu později",
        copied: "Zkopírováno",
        mostPopular: "Nejoblíbenější",
        TopSales: "Nejprodávanější",
        Price: "Cena",
        recommendation: "Doporučení",
        title: "Zeptejte seShop",
        subTitle: "Zeptejte se při nakupování, nakupujte chytřeji.",
        askAnything: "Zeptejte se na cokoli…",
        slogan: "AI shopping hub.",
      },

      loading: "Loading...",
      view_more: "view more",

      signIn: {
        main: "Přihlaste se",
        register: "Rejstřík",
        email: "E-mail",
        password: "Heslo",
        forgotPassword: "Zapomenuté heslo",
        forgotDesc:
          "Potvrďte svou e-mailovou adresu a my vám zašleme odkaz pro obnovení hesla.",
        phoneNumber: "Telefonní číslo",
        emailPlaceholder: "Zadejte prosím email",
        passwordPlaceholder: "Zadejte prosím heslo",
        passwordInvalid: "Heslo se skládá z 5-16 číslic",
        success: "Přihlášení proběhlo úspěšně, stránka bude obnovena",
        resendSuccess: "Opětovné odeslání bylo úspěšné",
        signOut: "Odhlaste se",
        otherWays: "Nebo pokračujte jinými způsoby",
        termsTips: "Přijímám Voghiona",
        newsletterTips: "Přihlaste se k odběru Newsletteru",
        privacyTips:
          "Používáme soubory cookie a podobné technologie, které jsou nezbytné pro poskytování našich služeb. Další podrobnosti naleznete v našem",
        terms: "Podmínky použití",
        and: "a",
        privacy: "Zásady ochrany osobních údajů a souborů cookie",
        confirmAcceptPrivacy: "Pro přihlášení potvrďte prosím soukromí",
        agreeAccpetSms: "Pro příjem SMS musíte souhlasit",

        sendResetEmailSuccess: {
          title: "Poslali jsme vám e-mail",

          content: `Pokud jste nenašli e-mail, <br>
          • e-mail se může o několik minut zpozdit.<br>
          • zkontrolujte prosím složku se spamem.<br>
          • zkuste kliknout`,

          resend: "ZNOVU ODESLAT",
          back: "Zpět k přihlášení",
        },

        registerTitle: "Vytvořte si účet {platform}",
        registerAutoLoginTitle:
          "Vaše e-mailová adresa je u nás již zaregistrována. Přihlaste se, prosím, pro přístup ke všem funkcím Zoomies.",
        submitTips: "Zadejte prosím svůj e-mail a svůj dotaz.",
      },

      common: {
        continue: "Pokračovat",
        submit: "Předložit",
        save: "Uložit",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Nebo",
        login: "log in",
        continue: "to continue",
      },
      noMoreInformation: "no more information",
    },
  },
  hr: {
    message: {
      title: "Poruke",
      order: "Narudžbe",
      networkError: "Nenormalnost mreže",
      orderDesc: "Budite u tijeku sa statusom narudžbe.",
      promo: "Promocije",
      promoDesc: "{count} kodovi su dostupni",
      orderTitle: "Naručite poruke",
      errorTitle: "Interna pogreška poslužitelja",

      errorDesc:
        "Poslužitelj je naišao na internu grešku ili pogrešnu konfiguraciju i nije mogao dovršiti vaš zahtjev.",

      reload: "Ponovno učitaj",
      noMoreGoods: "Nema više, kliknite drugu karticu i pogledajte više",
      goodsEmptyTitle: "Nema raspoložive robe",
      goodsEmptyDesc: "Pritisnite drugu karticu i pogledajte više",
      orderEmptyTitle: "Ovdje je prazno",
      orderEmptyDesc: "Pogledajte što biste još htjeli kupiti",
      viewMore: "Pogledaj više",
      latestProgress: "Najnoviji napredak",
      reason: "Razlog",
      sold: "prodano",
      noMore: "Nema više",
      loadError: "pogreška pri učitavanju, kliknite za ponovni pokušaj",
      clearMessageSuccess: "Sve poruke označene kao uspješno pročitane",
      orderTime: "Vrijeme narudžbe",
      orderId: "ID narudžbe",
      send: "Poslati",

      sentence1:
        "Molimo prijavite se prije razgovora s korisničkom službom koristeći Zoomies.",

      networkOutage: "Mreža je u prekidu, izađite i ponovno uđite!",
      versionTooLow: "Verzija aplikacije je preniska.",
      submit: "Pošalji",
      inviting: "POZIVANJE",
      unpaid: "NEPLAĆENO",
      qualityInspection: "KONTROLA KVALITETE",
      qualityInspectionFailed: "INSPEKCIJA KVALITETE NIJE uspjela",
      preparingForShipment: "PRIPREMA ZA ISPORUKU",
      approved: "ODOBRENO",
      closed: "ZATVORENO",
      shipped: "POSLANO",
      complete: "DOVRŠEN",
      returning: "VRAĆANJE",
      processing: "OBRADA",
      pending: "NA ČEKANJU",
      refunded: "POVRAT NOVCA",
      refundRejected: "POVRAT NOVCA ODBIJEN",
      waitRefund: "PRIČEKAJ POVRAT",
      cancel: "OTKAZATI",
      received: "PRIMLJENO",
      rejected: "ODBIJENO",
      end: "KRAJ",
      refunding: "POVRAT NOVCA",
      tobeshipped: "ZA ŠALJU",
      login: "PRIJAVITE SE",
      dialogtitle: "Odaberite što želite pitati",
      Camera: "Fotoaparat",
      Order: "Redoslijed",
      viewed: "Gledano",
      favorites: "Favoriti",
      cart: "Košarica",

      pushNotifications:
        "Uključite obavijesti za ažuriranja o najnovijem statusu narudžbe.",

      pushNotificationsOpen: "OTVORITI",
      contactServiceText: "Ako ne možete pronaći narudžbu ili proizvod, molimo",
      contactService: "kontaktirajte nas",
      serverDesc: "Agent korisničke službe Voghion",
      serverWaitTip: "Podrška za povezivanje",

      serverWaitDesc:
        "Dragi korisniče, spajamo vas s korisničkom službom, molimo vas da strpljivo pričekate.",

      warnSpeakTitle: "Poruke sustava",
      warnSpeakP1: "Dobrodošli u Zoomies!",

      warnSpeakP2:
        "Uznemiravanje, eksplicitan sadržaj, nasilje, provokativne poruke i kršenje autorskih prava strogo su zabranjeni u našem chatu. Kršenja će rezultirati trenutačnim isključivanjem zvuka ili drugim disciplinskim mjerama. Hvala vam što nam pomažete održati pozitivnu zajednicu!",

      ServiceNotification: "Obavijest o usluzi",
      VipNotification: "Vip Obavijest",
      empty: "Ovdje je prazno",
      check_the_user_manual: "Provjerite korisnički priručnik",
      newin: "Novo u",
      uploading: "Prijenos",
      uploadError: "Pogreška pri prijenosu",

      ai: {
        recordInvisible:
          "Ups! Čini se da ti je glas postao nevidljiv ~ Molim te, približi se mikrofonu i pokušaj ponovno! 🎤🤔",

        failedResolveAudio: "Nije uspjelo razrješavanje zvuka",
        serverBusy: "Žao nam je, server je zauzet, pokušajte ponovno kasnije.",
        clearHistory: "Želite li izbrisati svu povijest razgovora?",
        cancel: "Otkazati",
        clear: "Jasan",
        newTopic: "Nova tema",
        Refresh: "Osvježiti",
        holdToTalk: "Držite za razgovor",
        releaseToCancel: "Otpustite za otkazivanje",
        swipeUpToCancel: "Prijeđite prstom prema gore za otkazivanje",
        askMTQuestion: "Postavite pitanje MT-u",
        describeYourNeeds: "Opišite svoje potrebe",
        speakTimeTooShort: "Vrijeme govora je prekratko",
        Camera: "Fotoaparat",
        Photo: "Fotografija",
        sold: "prodano",

        updateTitle:
          "Dostupna je nova verzija! Ažurirajte odmah za najnovije značajke.",

        confirm: "Potvrdi",
        thinking: "Razmišljanje.",
        suggestMore: "Predloži više",
        feedbackSubmitted: "Povratne informacije poslane",
        serverError: "Pogreška servera, pokušajte ponovno kasnije",
        copied: "Kopirano",
        mostPopular: "Najpopularnije",
        TopSales: "Najbolje prodaje",
        Price: "Cijena",
        recommendation: "Preporuka",
        title: "AskShop",
        subTitle: "Pitajte za kupovinu, kupujte pametnije.",
        askAnything: "Pitajte bilo što…",
        slogan: "AI shopping hub.",
      },

      loading: "Loading...",
      view_more: "view more",

      signIn: {
        main: "Prijavite se",
        register: "Registar",
        email: "E-mail",
        password: "Lozinka",
        forgotPassword: "Zaboravili ste lozinku",
        forgotDesc:
          "Potvrdite svoju adresu e-pošte i poslat ćemo vam vezu za ponovno postavljanje lozinke.",
        phoneNumber: "Broj telefona",
        emailPlaceholder: "Molimo unesite email",
        passwordPlaceholder: "Molimo unesite lozinku",
        passwordInvalid: "Lozinka se sastoji od 5-16 znakova",
        success: "Prijava je uspjela, stranica će se osvježiti",
        resendSuccess: "Ponovno slanje uspješno",
        signOut: "Odjavi se",
        otherWays: "Ili nastavite na druge načine",
        termsTips: "Prihvaćam Voghion",
        newsletterTips: "Prijavite se za Newsletter",
        privacyTips:
          "Koristimo kolačiće i slične tehnologije koje su neophodne za pružanje naših usluga. Za više detalja pogledajte naš",
        terms: "Uvjeti korištenja",
        and: "i",
        privacy: "Politika privatnosti i kolačića",
        confirmAcceptPrivacy: "Molimo potvrdite privatnost za prijavu",
        agreeAccpetSms: "Morate pristati na primanje SMS-a",

        sendResetEmailSuccess: {
          title: "Poslali smo vam e-mail",

          content: `Ako niste pronašli e-poštu, <br>
          • e-pošta može kasniti nekoliko minuta.<br>
          • provjerite svoju spam mapu.<br>
          • pokušajte kliknuti`,

          resend: "PONOVO POŠALJI",
          back: "Natrag na prijavu",
        },

        registerTitle: "Kreirajte svoj {platform} račun",
        registerAutoLoginTitle:
          "Vaša e-mail adresa je već registrirana. Prijavite se kako biste pristupili svim funkcijama Zoomiesa.",
        submitTips: "Unesite svoju e-mail adresu i svoje pitanje.",
      },

      common: {
        continue: "Nastaviti",
        submit: "Pošalji",
        save: "Uštedjeti",
      },

      notLogin: {
        question: "Hi,I have a question:",
        emailTip: "That email doesn't look quite right",
        pageTip:
          "Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.",
        or: "Ili",
        login: "log in",
        continue: "to continue",
      },
      noMoreInformation: "no more information",
    },
  },
};

export { message };

let instance = null;

/**
 * 返回 i18n 单例
 */
export default (initLocale = "en") => {
  if (!instance) {
    instance = createI18n({
      locale: initLocale, // 设置语言类型
      fallbackLocale: "en",
      legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
      globalInjection: true, // 全局注册$t方法
      messages: message,
    });
  }
  return instance;
};
